export const values = {
    aumico_reports_annualreport_import_structure_dialog_title: 'Taxonomy has changed',
    aumico_reports_annualreport_import_structure_dialog_text: 'Would you like to import the new taxonomy?',
    aumico_reports_annualreport_import_structure_dialog_action_button: 'Yes, change taxonomy',
    aumico_legacy_reclasses_autofill_warning_title: 'Rilevate riclassificazioni legacy',
    aumico_legacy_reclasses_autofill_warning_text:
        'Il report dell’anno precedente contiene riclassificazioni salvate nel sistema legacy. Non verranno riportate automaticamente nelle nuove riclassificazioni in Grouping & Masking. Per utilizzarle in questo report, reinseriscile qui come transazioni in Grouping & Masking.',
    aumico_legacy_reclasses_autofill_warning_ok: 'OK',
    aumico_annual_report_mapping_help_text_select_fli: 'Select the financial line item',
    aumico_annual_report_mapping_transfer_profit_fli_change_help_text:
        'Here you can change the financial positions where the profit should be transferred to.',
    aumico_annual_report_mapping_transfer_surplus_fli_change_help_text:
        'Here you can change the financial positions where the surplus should be transferred to.',
    aumico_annual_report_mapping_settings_section: 'Impostazioni',
    aumico_annual_report_execute_button: 'Esegui',
    aumico_annual_report_cancel_button: 'Annulla',
    aumico_annual_report_mapping_reset_fli_button: 'Reimposta etichette',
    aumico_annual_report_mapping_reset_fli_warning:
        'Premere il pulsante "Reimposta etichette" se i gruppi e i gruppi di account sono visualizzati in una lingua diversa dal resto del report. Utilizzando questa funzione, i gruppi e i gruppi di conti vengono ricaricati nella lingua corrente del profilo.  I gruppi, i gruppi di account o i sottogruppi di account aggiunti dall\'utente devono essere inseriti nuovamente. \nSi tratta di una soluzione temporanea!',
    aumico_annual_report_mapping_reset_fli_dialog_content:
        'Questa azione non può essere annullata dopo il salvataggio. Si prega di controllare attentamente la struttura dello stato patrimoniale e del conto economico dopo aver utilizzato questa funzione. È possibile ricaricare in qualsiasi momento i gruppi e i sottogruppi di conto nella lingua del profilo corrente.',
    aumico_admin_add_user_button: 'Aggiungi utente',
    aumico_admin_change_password_current_password_error: 'La password corrente è sbagliata',
    aumico_admin_change_password_password_length_error: 'La lunghezza delle password deve essere di 12 o più caratteri',
    aumico_admin_confirm_password: 'Conferma password',
    aumico_admin_current_password: 'Password attuale',
    aumico_admin_edit_localization: 'Modificare la localizzazione',
    aumico_admin_login_errorMessage: 'Il nome utente o la password sono sbagliati!',
    aumico_admin_login_title: 'Accedici',
    aumico_admin_manageUsers_role: 'Ruolo',
    aumico_admin_manageUsers_userName: 'Nome utente',
    aumico_admin_new_password: 'Nuova password',
    aumico_admin_password: "Parola d'ordine",
    aumico_admin_password_changed_successfully: 'password cambiata con successo',
    aumico_admin_passwords_doesnot_match: 'Password e conferma password non sono gli stessi',
    aumico_admin_templates_balance: 'Bilancia',
    aumico_admin_templates_income: 'Reddito',
    aumico_admin_user_created_successfully: 'Il nuovo utente viene creato correttamente',
    aumico_admin_weak_password_error: 'La password deve contenere più di 12 caratteri',
    aumico_annual_report_file_preview: 'Anteprima del file',
    aumico_annual_report_general_information_autofill_btn_text: "Compila automaticamente i dati dell'azienda",
    aumico_annual_report_general_information_balance_sheet_date: 'Data di bilancio',
    aumico_annual_report_general_information_balance_sheet_date_error:
        'La data del bilancio deve essere dopo la data di bilancio degli anni precedenti',
    aumico_annual_report_general_information_basis_of_accounting: 'Standard di contabilità',
    aumico_annual_report_general_information_report_language: 'Report Language it',
    aumico_annual_report_general_information_create_new_company_btn_text: 'Crea nuova azienda',
    aumico_annual_report_general_information_currency: 'Valuta',
    aumico_annual_report_general_information_previous_sheet_date_error:
        'La data precedente deve essere prima della data corrente',
    aumico_annual_report_general_information_previous_year_reporting_date: "Data del bilancio dell'anno precedente",
    aumico_annual_report_general_information_revision_type: 'Tipo di revisione',
    aumico_annual_report_general_information_select_company: "Seleziona l'azienda",
    aumico_annual_report_general_information_set_specification: 'informazioni generali',
    aumico_annual_report_import_definition_click_cell: "Fare clic sulla cella corrispondente nell'anteprima",
    aumico_annual_report_import_definition_click_corresponding_sheet:
        "Fare clic sulla cella corrispondente nell'anteprima",
    aumico_annual_report_import_definition_fill_manually: 'Riempi manualmente',
    aumico_annual_report_import_definition_specify_titles_line_1: 'vuoto',
    aumico_annual_report_import_definition_specify_titles_line_2: 'Tavolo',
    aumico_annual_report_import_definition_transfer_entries: 'Trasferisci le voci per',
    aumico_annual_report_import_definition_which_spreadsheet_1: 'In cui è il foglio di calcolo',
    aumico_annual_report_import_definition_which_spreadsheet_2: 'Foglio mostrato?',
    aumico_annual_report_import_form_balance_title: 'Bilancia',
    aumico_annual_report_import_form_income_title: 'Conto economico',
    aumico_annual_report_import_form_input_placeholder: 'Si prega di specificare un nome di versione',
    aumico_annual_report_import_form_upload_label: 'Carica file per il saldo netto del client',
    aumico_annual_report_import_form_uploaded_label: 'File caricato per il saldo netto del client',
    aumico_annual_report_import_form_version_label: 'Nome versione',
    aumico_annual_report_import_indicate_account_names_column:
        "Indicare la colonna in cui si trovano le designazioni dell'account",
    aumico_annual_report_import_indicate_account_numbers_column: 'Indicare la colonna in cui sono i numeri di conto',
    aumico_annual_report_import_indicate_balance_column: 'Indicare la colonna del periodo di segnalazione.',
    aumico_annual_report_import_indicate_previous_year_column: 'Immettere la colonna per il periodo di confronto.',
    aumico_annual_report_interpretation_account_name: "Designazione dell'account",
    aumico_annual_report_interpretation_account_number: 'Durata n. (Ex.: 4-5 o 5-5)',
    aumico_annual_report_interpretation_active: 'Risorse',
    aumico_annual_report_interpretation_closing_value: 'Valore di chiusura',
    aumico_annual_report_interpretation_excluded_word: 'Parola esclusa',
    aumico_annual_report_interpretation_expense: 'Spese',
    aumico_annual_report_interpretation_included_word: 'Parola inclusa',
    aumico_annual_report_interpretation_income: 'Reddito',
    aumico_annual_report_interpretation_negative: 'Negativo',
    aumico_annual_report_interpretation_opening_value: 'Valore di apertura',
    aumico_annual_report_interpretation_passive: 'Passività',
    aumico_annual_report_interpretation_positive: 'Positivo',
    aumico_annual_report_interpretation_select_signs: 'Definisci +/- del tuo equilibrio di prova.',
    aumico_annual_report_interpretation_specify_excluded_word:
        'Optional: "Facoltativo: Specificare una parola che deve essere esclusa nel nome dell account"',
    aumico_annual_report_interpretation_specify_included_word:
        'Optional: "Facoltativo: Specificare una parola che deve essere inclusa nel nome dell account"',
    aumico_annual_report_interpretation_specify_number_of_characters: 'Criteri di filtro opzionali',
    aumico_annual_report_interpretation_title: 'Interpretazione dei numeri',
    aumico_annual_report_mandatory_field_error: 'Questo campo è obbligatorio',
    aumico_annual_report_not_found_error: 'Non trovato',
    aumico_annual_report_print_options_add_metadata: 'Aggiungi metadati',
    aumico_annual_report_print_options_caption: '-',
    aumico_annual_report_print_options_collective_signature: 'Firma collettiva',
    aumico_annual_report_print_options_custom_page_numbers: 'Numeri di pagina personalizzati',
    aumico_annual_report_print_options_dont_show_name: 'Non mostrare il nome (può essere inserito manualmente)',
    aumico_annual_report_print_options_show_decimal_places: 'Luoghi decimali',
    aumico_annual_report_print_options_place_of_signing: 'Luogo di firma (opzionale)',
    aumico_annual_report_print_options_print: 'Stampa',
    aumico_annual_report_print_options_print_only_greyscale: 'Stampa solo in scala di grigio',
    aumico_annual_report_print_options_show_empty_lines: 'Le linee vuote',
    aumico_annual_report_print_options_show_company_info: "Informazioni sull'organizzazione",
    aumico_annual_report_print_options_show_cover_sheet: 'Foglio di copertina',
    aumico_annual_report_print_options_show_table_of_contents: 'Sommario',
    aumico_annual_report_print_options_show_uid: 'Uid (foglio di copertina)',
    aumico_annual_report_print_options_signatory_1: 'Firmatario 1 (opzionale)',
    aumico_annual_report_print_options_signatory_2: 'Firmatario 2 (opzionale)',
    aumico_annual_report_print_options_signature: 'Firma',
    aumico_annual_report_print_options_title: 'Opzioni di stampa',
    aumico_annual_report_print_preview_aop: 'Appropriazione del profitto',
    aumico_annual_report_print_preview_attachement: 'Note al bilancio',
    aumico_annual_report_print_preview_balance: 'Bilancio',
    aumico_annual_report_print_preview_income: 'Conto economico',
    aumico_annual_report_profit_calculation_annual_profit: 'Profitto annuale',
    aumico_annual_report_profit_calculation_header: 'Disponibili utili trattenuti',
    aumico_annual_report_proposal_add_new_item: 'Aggiungi un nuovo elemento',
    aumico_annual_report_proposal_available_retained_earnings: 'Guadagni totali trattenuti',
    aumico_annual_report_proposal_carried_forward_to_new_account: 'Equilibrio da portare avanti',
    aumico_annual_report_table_label_accounting_basis: 'Base contabile',
    aumico_annual_report_table_label_company: 'Azienda',
    aumico_annual_report_table_label_created_on: 'Creato',
    aumico_annual_report_table_label_language: 'Language -it',
    aumico_annual_report_table_label_currency: 'Valuta',
    aumico_annual_report_table_label_last_change: 'ultima modifica',
    aumico_button_cancel: 'Annulla',
    aumico_button_companies_form_cancel: 'Annulla',
    aumico_button_companies_form_save: 'Salva e continua',
    aumico_button_confirm: 'Confermare',
    aumico_button_delete: 'Eliminare',
    aumico_button_download: 'Scaricamento',
    aumico_button_edit: 'Modificare',
    aumico_button_copy: 'Copia',
    aumico_button_preview: 'Anteprima',
    aumico_button_save: 'Salva',
    aumico_button_submit: 'Invia',
    aumico_button_update: 'Aggiornamento',
    aumico_button_add: 'Aggiungere',
    aumico_companies_form_label_addition_to_address: "Aggiunta all'indirizzo",
    aumico_companies_form_label_address: 'Indirizzo',
    aumico_tags_box_title: 'Tag',
    aumico_companies_form_section_linked_persons: 'Persone collegate',
    aumico_tags_box_new_tag_placeholder: 'Crea nuovo tag',
    aumico_tags_box_create: 'Crea',
    aumico_tags_box_cancel: 'Annulla',
    aumico_tags_box_delete: 'Elimina',
    aumico_tags_box_delete_warning: 'è utilizzato da {{companies}} aziende e {{persons}} persone e verrà rimosso. Eliminare davvero?',
    aumico_tags_box_delete_aria: 'Elimina tag',
    aumico_persons_form_details_text: 'Dati della persona',
    aumico_persons_form_section_personal: 'Dati personali',
    aumico_persons_form_first_name: 'Nome',
    aumico_persons_form_last_name: 'Cognome',
    aumico_persons_form_assignee: 'Responsabile del mandato',
    aumico_persons_form_clerk: 'Collaboratore',
    aumico_persons_form_search: 'Cerca',
    aumico_persons_form_placeholder: 'Si prega di inserire',
    aumico_persons_form_section_address: 'Indirizzo',
    aumico_persons_form_street: 'Via e numero civico',
    aumico_persons_form_addition_to_address: 'Complemento indirizzo',
    aumico_persons_form_zip: 'NPA',
    aumico_persons_form_city: 'Località',
    aumico_persons_form_section_contact: 'Dati di contatto',
    aumico_persons_form_email: 'E-mail',
    aumico_persons_form_phone: 'Telefono',
    aumico_persons_form_email_invalid: 'Indirizzo e-mail non valido',
    aumico_persons_form_add_contact: 'Aggiungi contatto',
    aumico_persons_form_remove_contact_aria: 'Rimuovi contatto',
    aumico_persons_form_section_companies: 'Aziende collegate',
    aumico_persons_form_company: 'Azienda',
    aumico_persons_form_role: 'Ruolo',
    aumico_persons_form_please_choose: 'Si prega di scegliere',
    aumico_persons_form_link: 'Collega',
    aumico_persons_form_unlink_aria: 'Rimuovi collegamento',
    aumico_persons_form_company_deleted: 'Azienda eliminata',
    aumico_persons_form_role_OWNER: 'Titolare',
    aumico_persons_form_role_SHAREHOLDER: 'Azionista',
    aumico_persons_form_role_MANAGING_DIRECTOR: 'Direttore/trice',
    aumico_persons_form_role_BOARD_MEMBER: 'Consiglio di amministrazione',
    aumico_persons_form_role_OTHER: 'Altro',
    aumico_persons_form_save: 'Salva',
    aumico_persons_form_delete: 'Elimina',
    aumico_persons_form_deactivate: 'Disattiva',
    aumico_persons_form_activate: 'Attiva',
    aumico_persons_form_dialog_cancel: 'Annulla',
    aumico_person_delete_failed_title: "Errore durante l'eliminazione della persona",
    aumico_person_delete_failed_has_projects_message:
        'La persona ha ancora progetti. Devi prima eliminare i progetti esistenti di questa persona.',
    aumico_persons_form_clerk_change_dialog_text:
        "Stai cambiando l'impiegato amministrativo per questa persona. Come devono essere riassegnati i compiti esistenti?",
    aumico_persons_form_delete_dialog_title: 'Eliminare la persona?',
    aumico_persons_form_delete_dialog_text: 'La persona verrà eliminata definitivamente. L\'operazione non può essere annullata.',
    aumico_persons_overview_tab_active: 'Attivo',
    aumico_persons_overview_tab_inactive: 'Inattivo',
    aumico_persons_overview_search: 'Cerca',
    aumico_persons_overview_filter_assignee: 'Responsabile del mandato',
    aumico_persons_overview_filter_clerk: 'Collaboratore',
    aumico_persons_overview_filter_tag: 'Tag',
    // REV-22155 — person projects
    aumico_projects_toggle_companies: 'Aziende',
    aumico_projects_toggle_persons: 'Persone',
    aumico_person_projects_filter_person: 'Persona',
    aumico_person_projects_filter_period: 'Periodo',
    aumico_person_projects_filter_tag: 'Tag',
    aumico_person_projects_col_person: 'Persona',
    aumico_person_projects_col_period: 'Periodo',
    aumico_person_projects_col_tag: 'Tag',
    cpmm_projects_overview_col_tag: 'Tag',
    aumico_projects_overview_filter_tag: 'Tag',
    aumico_person_projects_tax_period: 'Periodo fiscale {{year}}',
    aumico_person_projects_empty: 'Ancora nessun progetto di persone',
    aumico_person_projects_empty_instructions: 'Crea un progetto per una persona per avviare la gestione del suo mandato.',
    aumico_person_projects_create_failure_title: 'Progetto non creato',
    aumico_person_projects_create_failure_description: 'Non è stato possibile creare il progetto. Riprova.',
    aumico_person_projects_create_failure_inactive: 'Questo mandato è inattivo. Non è possibile aggiungere nuovi progetti.',
    aumico_create_person_project_dialog_select_person_title: 'Scegli una persona',
    aumico_create_person_project_dialog_select_person_description: 'Per quale persona deve essere creato il progetto?',
    aumico_create_person_project_dialog_select_person_input_title: 'Persona',
    aumico_create_person_project_dialog_select_person_input_placeholder: 'Cerca persona',
    aumico_create_person_project_dialog_select_period_title: 'Scegli il periodo',
    aumico_create_person_project_dialog_select_period_description: 'Per quale periodo deve essere creato il progetto?',
    aumico_create_person_project_dialog_select_period_input_label: 'Periodo',
    aumico_create_person_project_dialog_select_period_input_placeholder: 'Scegli periodo',
    aumico_pm_tasks_type_filter_label: 'Tipo',
    aumico_pm_tasks_type_company: 'Azienda',
    aumico_pm_tasks_type_person: 'Persona',
    aumico_tasks_col_mandant: 'Mandante',
    aumico_person_projects_next_year_reason_inactive: 'Inattivo – nessun nuovo progetto possibile',
    aumico_person_projects_next_year_reason_no_project: 'Ancora nessun progetto',
    aumico_person_projects_next_year_reason_not_found: 'Persona non trovata',
    aumico_persons_overview_export: 'Export XLS',
    aumico_persons_overview_new: 'Nuova persona',
    aumico_persons_overview_col_name: 'Nome',
    aumico_persons_overview_col_street: 'Via e numero civico',
    aumico_persons_overview_col_zip: 'NPA',
    aumico_persons_overview_col_city: 'Località',
    aumico_persons_overview_col_tag: 'Tag',
    aumico_persons_overview_col_assignee: 'Responsabile del mandato',
    aumico_persons_overview_col_clerk: 'Collaboratore',
    aumico_persons_overview_empty_text1: 'Ancora nessuna persona registrata',
    aumico_persons_overview_empty_text2: 'Registra la prima persona con «Nuova persona».',
    aumico_persons_overview_bulk_assignee: 'Cambia responsabile del mandato',
    aumico_persons_overview_bulk_clerk: 'Cambia collaboratore',
    aumico_persons_overview_bulk_next_financial_year: 'Crea esercizio successivo',
    aumico_persons_overview_bulk_deactivate: 'Disattiva persone',
    aumico_persons_overview_bulk_deactivate_confirm: 'Sei sicuro di voler disattivare {{count}} persone?',
    aumico_persons_overview_bulk_selected: 'selezionato/i',
    aumico_persons_overview_bulk_assignee_title: 'Cambiare il responsabile del mandato per {{count}} persone?',
    aumico_persons_overview_bulk_clerk_title: 'Cambiare il collaboratore per {{count}} persone?',
    aumico_persons_overview_cancel: 'Annulla',
    aumico_persons_overview_save: 'Salva',
    aumico_persons_overview_please_choose: 'Si prega di scegliere',
    aumico_companies_form_label_city: 'Città',
    aumico_companies_form_label_country: 'Paese',
    aumico_companies_form_label_email: 'E-mail',
    aumico_companies_form_label_first_name: 'First Name',
    aumico_companies_form_label_last_name: 'Last Name',
    aumico_companies_form_label_legal_form: 'Forma giuridica',
    aumico_companies_form_label_name: 'Nome',
    aumico_companies_form_label_phone: 'Telefono',
    aumico_companies_form_label_street_and_number: 'Civico',
    aumico_companies_form_label_uid_number: 'Numero uid',
    aumico_companies_form_label_zip_code: 'Cap',
    aumico_companies_form_placeholder_optional: 'opzionale',
    aumico_companies_form_placeholder_please_enter: 'Prego entra',
    aumico_companies_form_placeholder_please_select: 'Seleziona',
    aumico_companies_form_section_name_contact_details: 'Dettagli del contatto',
    aumico_companies_form_section_name_legal_information: 'Informazione legale',
    aumico_companies_form_validation_email_invalid: 'E-mail non valido',
    aumico_companies_form_validation_enter_company_name_exists: "Il nome dell'azienda esiste già",
    aumico_companies_form_validation_enter_company_name_required: "Inserisci il nome dell'azienda",
    aumico_companies_form_validation_legal_form_required: 'Seleziona il modulo legale',
    aumico_companies_toast_error_something_went_wrong: 'Qualcosa è andato storto',
    aumico_core_form_invalid_error: 'Questo campo non è valido',
    aumico_core_form_mandatory_error: 'Questo campo è obbligatorio',
    aumico_errors_server_error: 'Errore del server',
    aumico_no_read_permission: 'Sorr',
    aumico_notes_component_options_add_more: 'Aggiungere altro',
    aumico_notes_component_options_current_value_title_1: 'Valore corrente Titolo 1',
    aumico_notes_component_options_current_value_title_2: 'Valore corrente Titolo 2',
    aumico_notes_component_options_previous_value_title_1: 'Valore precedente Titolo 1',
    aumico_notes_component_options_previous_value_title_2: 'Valore precedente Titolo 2',
    aumico_notes_component_options_selection_option: 'Opzione di selezione',
    aumico_notes_component_options_text_title: 'Titolo di testo',
    aumico_notes_equity: 'Equità',
    aumico_notes_fli: 'Articolo di linea finanziaria',
    aumico_notes_fli_component_add_more: 'Aggiungere altro articolo di linea finanziaria',
    aumico_notes_free_table_with_amounts: 'Tavolo gratuito con importi',
    aumico_notes_information_dialog_title: 'Informazioni generali',
    aumico_notes_mandatory_error: 'Questo campo è obbligatorio',
    aumico_notes_name_exist_error: 'Il nome esiste già',
    aumico_notes_notespage_notes_not_found: 'Non ci sono note trovate da questa forma giuridica e contabilità.',
    aumico_notes_notestemplate_form_legal_form_and_accounting_basis_combination_exist:
        'Questa combinazione di forma legale selezionata e base di account esiste già',
    aumico_notes_notestemplate_list_add_new: 'Aggiungi il modello di nuove note',
    aumico_notes_notestype_form_components: 'Componenti',
    aumico_notes_notestype_form_information: 'Informazione',
    aumico_notes_notestype_form_min_length_error: 'La lunghezza minima è di 5 caratteri',
    aumico_notes_notestype_form_name: 'Nome',
    aumico_notes_notestype_form_title: 'Titolo della sezione',
    aumico_notes_notestype_list_add_new: 'Aggiungi nuovo tipo di note',
    aumico_notes_options: 'Opzioni',
    aumico_notes_preview: 'Anteprima',
    aumico_notes_rich_text: 'Testo ricco',
    aumico_notes_simple_input: 'Simple Input fr',
    aumico_notes_select: 'Selezionare',
    aumico_notes_server_error: 'Errore interno del server',
    aumico_notes_table_with_form_add_new_item: 'Aggiungi un nuovo elemento',
    aumico_notes_table_with_form_no_formfield_defined: 'Nessun campo di modulo definito per',
    aumico_notes_table_with_form_no_properties_defined: 'Nessuna proprietà definita.',
    aumico_notes_table_with_form_no_properties_error: 'Nessuna proprietà definita',
    aumico_notes_table_with_form_total: 'Totale',
    aumico_notes_template: 'Modello di note',
    aumico_notes_testing_procedure: 'Procedura di test',
    aumico_notes_testing_procedure_comment: 'Commento',
    aumico_notes_testing_procedure_flis: 'Flis',
    aumico_notes_testing_procedure_references: 'Riferimenti',
    aumico_notes_text: 'Testo',
    aumico_notes_total_row: 'Riga totale',
    aumico_notes_types: 'Tipi di note',
    aumico_reporting_contentBlocks_addNew: 'Aggiungi un nuovo blocco di contenuti',
    aumico_reporting_contentBlocks_options_content: 'Il contenuto blocca il contenuto',
    aumico_reporting_contentBlocks_options_owner: 'Il contenuto blocca il proprietario',
    aumico_reporting_contentBlocks_options_properties: 'Il contenuto blocca le proprietà',
    aumico_reporting_report_content: 'Contenuto',
    aumico_reporting_report_edit_addNewContent: 'Aggiungi nuovi contenuti',
    aumico_reporting_report_edit_addNewFooter: 'Aggiungi nuovo piè di pagina',
    aumico_reporting_report_edit_addNewHeader: 'Aggiungi nuova intestazione',
    aumico_reporting_report_footer: 'Piè di pagina',
    aumico_reporting_report_header: 'Intestazione',
    aumico_reporting_report_name: 'Nome report',
    aumico_reporting_settings_options_name: 'Nome',
    aumico_reporting_settings_options_owner: 'Proprietario',
    aumico_reporting_templatesPreview_show: 'Anteprima dello spettacolo',
    aumico_reporting_templates_addNew: 'Aggiungi un nuovo modello di reporting',
    aumico_reporting_templates_edit: 'Modifica modello di reporting',
    aumico_reporting_templates_livePreview: 'Anteprima dal vivo',
    aumico_reporting_templates_options_accountingBasis: 'Base contabile',
    aumico_reporting_templates_options_legalForm: 'Forma giuridica',
    aumico_reporting_variables_addNew: 'Aggiungi una nuova variabile di reporting',
    aumico_reporting_variables_edit: 'Modifica la variabile di reporting',
    aumico_reporting_variables_options_currentVersion: 'Versione attuale',
    aumico_reporting_variables_options_identifier: 'Identificatore',
    aumico_reporting_variables_options_property: 'Proprietà',
    aumico_reporting_variables_title: 'Variabili',
    aumico_reports_fs_notes_instruction: 'Istruzioni di lavoro',
    aumico_reports_input_please_enter_placeholder: 'Prego entra',
    aumico_reports_intro_side_text: 'Porta i tuoi bilanci al livello successivo!',
    aumico_reports_login_bottom_button_of_question_register: 'Iscriviti ora',
    aumico_reports_login_bottom_question: 'Non hai ancora un account?',
    aumico_reports_login_credentials_error: 'Nome utente o password non sono corretti!',
    aumico_reports_login_credentials_toomany_requests_error:
        "L'accesso a questo account è stato temporaneamente disabilitato a causa di molti tentativi di accesso non riusciti. Puoi ripristinarlo immediatamente ripristinando la password o puoi riprovare più tardi.",
    aumico_reports_login_credentials_network_request_failed: 'Errore di rete',
    aumico_reports_login_invalid_role_error: 'Il tuo account non dispone di un ruolo valido per accedere a questa applicazione.',
    aumico_reports_login_forgot_password: 'Ha dimenticato la password',
    aumico_reports_login_introduction: 'vuoto',
    aumico_reports_login_login_button: 'Login',
    aumico_reports_login_title: 'Login',
    aumico_reports_page_not_found: 'Pagina non trovata',
    aumico_reports_password: "Parola d'ordine",
    aumico_reports_placeholder_needs_implementation: 'Pag PAG',
    aumico_reports_registration_bottom_button_of_question_login: 'Accedi ora',
    aumico_reports_registration_bottom_question: 'Hai già un account?',
    aumico_reports_registration_confirmation_bottom_question: "Non hai ricevuto un'e-mail?",
    aumico_reports_registration_confirmation_bottom_question_button: "Rinvia l'e-mail",
    aumico_reports_registration_confirmation_introduction: 'Breve introduzione e istruzioni',
    aumico_reports_registration_confirmation_title: 'Conferma il tuo indirizzo email',
    aumico_reports_registration_create_account_button: 'Creare un account',
    aumico_reports_registration_introduction:
        'Benvenuto! Iscriviti e inizia a creare bilanci per la propria organizzazione e i tuoi clienti.',
    aumico_reports_registration_welcome_button_login_go_dashboard: 'Accedi e vai a Dashboard',
    aumico_reports_registration_welcome_company_name_error: "È richiesto il nome dell'azienda",
    aumico_reports_registration_welcome_company_name_label: 'Nome della ditta',
    aumico_reports_registration_welcome_first_name_error: 'È richiesto il nome',
    aumico_reports_registration_welcome_first_name_label: 'Nome di battesimo',
    aumico_reports_registration_welcome_last_name_error: 'È richiesto cognome',
    aumico_reports_registration_welcome_last_name_label: 'Cognome',
    aumico_reports_registration_welcome_market_communication_subscription: 'Vorrei ricevere notizie sul prodotto',
    aumico_reports_registration_welcome_password_error: "E 'richiesta la password",
    aumico_reports_registration_welcome_password_label: "Parola d'ordine",
    aumico_reports_registration_welcome_password_match_error: 'Le password devono essere identiche',
    aumico_reports_registration_welcome_password_rules: 'Otto carattere minimo',
    aumico_reports_registration_welcome_password_validation_error: 'La password non soddisfa le regole.',
    aumico_reports_registration_welcome_privacy_policy: "Ho letto e accetto l'informativa sulla privacy sul sito Web*",
    aumico_reports_registration_welcome_privacy_policy_error: 'È richiesta la politica sulla privacy',
    aumico_reports_registration_welcome_repeat_password_error: 'È richiesta la password ripetizione',
    aumico_reports_registration_welcome_repeat_password_label: 'Si prega di ripetere la password',
    aumico_reports_reset_password_credentials_error: 'Nome utente o e -mail è sbagliato!',
    aumico_reports_reset_password_forgot_email_username: 'E-mail / nome utente',
    aumico_reports_reset_password_forgot_password_title: 'Ha dimenticato la password?',
    aumico_reports_reset_password_forgot_send_instruction_button: 'Inviami istruzioni via e-mail',
    aumico_reports_reset_password_introduction:
        'Inserisci la tua e-mail e ti invieremo istruzioni su come reimpostare la password.',
    aumico_reports_signup_title: 'Crea un nuovo account',
    aumico_reports_welcome_page_footer_about: 'GTC',
    aumico_reports_welcome_page_footer_imprint: 'Impronta',
    aumico_reports_welcome_page_footer_privacy_policy: 'politica sulla riservatezza',
    aumico_reports_write_permission_error: 'Scusa se non hai il permesso di scrivere.',
    aumico_reports_referral_invite_title: 'Referral',
    aumico_reports_referral_invite_text: 'Dillo a un amico',
    aumico_reports_referral_invite_invite_button: 'Invita ora',
    aumico_reports_referral_invite_dialog_title: 'Dillo a un amico',
    aumico_reports_referral_invite_dialog_content: 'Racconta a un amico di Aumico',
    aumico_reports_referral_invite_dialog_input_label: 'Aggiungi indirizzo e-mail',
    aumico_reports_referral_invite_dialog_input_placeholder: 'Inserisci gli indirizzi e-mail',
    aumico_reports_referral_invite_dialog_save_button: 'Invitare',
    aumico_settings_accountingBasis: 'Base contabile',
    aumico_settings_accountingbasis_id: 'ID',
    aumico_settings_accountingbasis_name: 'Nome',
    aumico_settings_accountingbasis_owner: 'Proprietario',
    aumico_settings_accountingbasis_text: 'Testo',
    aumico_settings_accountingbasis_version: 'Versione',
    aumico_settings_currency_id: 'ID',
    aumico_settings_currency_name: 'Nome',
    aumico_settings_currency_owner: 'Proprietario',
    aumico_settings_currency_text: 'Testo',
    aumico_settings_currency_version: 'Versione',
    aumico_settings_financialLineItem: 'Articolo di linea finanziaria',
    aumico_settings_financialLineItem_cashflow: 'Flusso di cassa',
    aumico_settings_financialLineItem_description: 'Descrizione',
    aumico_settings_financialLineItem_id: 'ID',
    aumico_settings_financialLineItem_invalidText: 'Inserisci i numeri solo a partire da 1000',
    aumico_settings_financialLineItem_name: 'Nome',
    aumico_settings_financialLineItem_owner: 'Proprietario',
    aumico_settings_financialLineItem_position: 'Posizione',
    aumico_settings_financialLineItem_text: 'Testo',
    aumico_settings_financialLineItem_type: 'Tipo',
    aumico_settings_financialLineItem_version: 'Versione',
    aumico_settings_legalForm_id: 'ID',
    aumico_settings_legalForm_name: 'Nome',
    aumico_settings_legalForm_owner: 'Proprietario',
    aumico_settings_legalForm_text: 'Testo',
    aumico_settings_legalForm_version: 'Versione',
    aumico_templates_cancel: 'Annulla',
    aumico_templates_combination_exist_error: 'La forma legale della forma e della base del conto esiste già',
    aumico_templates_description: 'Descrizione',
    aumico_templates_form_account_basis: 'Base contabile',
    aumico_templates_form_back_to_templates_list: "Torna all'elenco dei modelli",
    aumico_templates_form_cash_and_cash_equivalents: 'Equivalenti in contanti e contanti',
    aumico_templates_form_create_template: 'Crea modello',
    aumico_templates_form_enter_template_name_error: 'Inserisci il nome del modello',
    aumico_templates_form_legal_form: 'Forma giuridica',
    aumico_templates_form_profit_of_the_year: "Profitto dell'anno",
    aumico_templates_form_select_account_basis_error: "Seleziona la base dell'account",
    aumico_templates_form_select_legal_form_error: 'Seleziona il modulo legale',
    aumico_templates_form_template_name_exists_error: 'Il nome del modello esiste già',
    aumico_templates_form_update_template: 'Modello di aggiornamento',
    aumico_templates_group_form_allow_groups: 'Consentire gruppi',
    aumico_templates_group_form_allow_items: 'Consentire articoli',
    aumico_templates_group_form_create_group: 'Creare un gruppo',
    aumico_templates_group_form_enter_group_description_error: 'Inserisci la descrizione del gruppo',
    aumico_templates_group_form_enter_group_name_error: 'Inserisci il nome del gruppo',
    aumico_templates_group_form_hide_total: 'Nascondere il totale',
    aumico_templates_group_form_name_already_exists_error: 'Il nome del gruppo esiste già',
    aumico_templates_group_form_select_option: "Seleziona almeno un'opzione:",
    aumico_templates_group_form_update_group: 'Gruppo di aggiornamento',
    aumico_templates_group_list_new_group: 'Nuovo gruppo',
    aumico_templates_group_view_add_fli: 'Aggiungi articoli di linea finanziaria',
    aumico_templates_group_view_add_group: 'Aggiungere gruppo',
    aumico_templates_group_view_add_subtotal: 'Aggiungi subtotale',
    aumico_templates_list_edit: 'Modificare',
    aumico_templates_list_new: 'Nuovo',
    aumico_templates_list_new_template: 'Nuovo modello',
    aumico_templates_name: 'Nome',
    aumico_templates_save: 'Salva',
    aumico_templates_subtotal_form_enter_subtotal_description_error: 'Inserisci una descrizione subtotale',
    aumico_templates_subtotal_form_enter_subtotal_name_error: 'Inserisci il nome subtotale',
    aumico_templates_subtotal_form_name_already_exists_error: "Il nome dell'articolo del gruppo esiste già",
    aumico_templates_subtotal_form_subtotal_name: 'Nome subtotale',
    aumico_templates_subtotal_form_subtotal_scope: 'Scope -it',
    aumico_templates_subtotal_form_subtotal_position: 'Position after -it',
    mocked_data: 'Dati modificati',
    mocked_data_1: 'Data modificata',
    aumico_reports_annualreport_fcp_input_data_has_changed_notification_title: 'Data has changed -it',
    aumico_reports_annualreport_fcp_input_data_has_changed_notification_text: 'The data has changed. -it',
    aumico_reports_annualreport_fcp_input_data_has_changed_dialog_title: 'Mapping Daten changed? -it',
    aumico_reports_annualreport_fcp_input_data_has_changed_dialog_text: 'Do you want to update? -it',
    aumico_reports_annualreport_fcp_input_data_has_changed_dialog_action_button: 'Si',
    aumico_reports_annualreport_navigation_fcp: 'Financial Closing Process',
    aumico_reports_annualreport_navigation_aop: 'Appropriazione del profitto',
    aumico_reports_annualreport_navigation_generalinformation: 'Informazioni generali',
    aumico_reports_annualreport_navigation_finish_and_print: 'Finitura e stampa',
    aumico_reports_annualreport_navigation_import: 'Bilancio di importazione',
    aumico_reports_annualreport_navigation_import_upload: 'Carica il bilancio',
    aumico_reports_annualreport_navigation_import_mapping: "Mappatura dell'account",
    aumico_reports_annualreport_navigation_notes: 'Appunti',
    aumico_reports_annualreport_navigation_notes_and_aop: 'Cfs | Note | Appropriazione del profitto',
    aumico_reports_main_navigation_company: 'Organizzazione',
    aumico_reports_main_navigation_financialstatements: 'Rendiconto finanziario',
    aumico_reports_main_navigation_logout: 'Disconnettersi',
    aumico_reports_profile_navigation_security: 'Sicurezza',
    aumico_reports_profile_navigation_generalinformation: 'Informazioni generali',
    aumico_annual_report_general_information_please_determine_currency: 'Seleziona valuta',
    aumico_annual_report_general_information_please_determine_previous_year_date: 'Inserisci la data',
    aumico_annual_report_general_information_please_determine_date: 'Seleziona Data del bilancio',
    aumico_annual_report_general_information_please_select_company: "Seleziona l'azienda",
    aumico_annual_report_general_information_select_revision_type: 'Seleziona il tipo di revisione',
    aumico_annual_report_general_information_select_accounting_basis: 'Sélectionnez le type de comptabilité',
    aumico_annual_report_general_information_select_locale: 'Select Report language it',
    aumico_annual_report_import_please_select: 'Seleziona',
    aumico_annual_report_interpretation_enter_excluded_word: 'Inserisci la parola',
    aumico_annual_report_interpretation_enter_included_word: 'Inserisci la parola',
    aumico_annual_report_print_options_date_of_signing: 'Data di firma',
    aumico_annual_report_print_options_place_of_signing_placeholder: 'Luogo di firma',
    aumico_annual_report_print_options_start_at_page: 'Inizia da pagina',
    aumico_annual_report_print_page_content_preview: 'Anteprima dei contenuti',
    aumico_annual_report_profit_calculation_enter_text: 'Immettere il testo / importo',
    aumico_annual_report_proposal_enter_text: 'Immettere il testo / importo',
    aumico_annual_report_print_options_show_aop: 'Appropriazione del profitto',
    aumico_annual_report_print_options_show_Fcp: 'Prozessdokumentation',
    aumico_annual_report_proposal_description: "Proposta per l'appropriazione degli utili trattenuti",
    aumico_annual_report_label_cover_page: 'Titolo della Guida della copertina (non sarà visibile nel PDF)',
    aumico_annual_report_print_preview_cashflow: 'Rendiconto di cassa',
    aumico_annual_report_label_table_of_contents: 'Sommario',
    aumico_annual_report_table_label_previous_year_date: "Data dell'anno precedente",
    aumico_core_data_grid_accounts: 'Account',
    aumico_annual_report_table_label_current_year_date: 'Data di bilancio',
    aumico_core_data_grid_all: 'Tutto',
    aumico_core_data_grid_remove: 'Rimuovere tutti gli account',
    aumico_core_data_grid_search_placeholder: 'Ricerca...',
    aumico_core_empty_data_grid_assigned_all_accounts: 'Grea',
    aumico_core_empty_data_grid_information_text: 'vuoto',
    aumico_core_empty_data_grid_information_title: 'vuoto',
    aumico_core_file_upload_extension_error: 'Carica un file .xlsx o un .xls',
    aumico_core_file_upload_instruction_text: 'Trascina e lascia cadere il saldo netto del cliente qui',
    aumico_core_file_upload_instruction_label: 'Carica il bilancio',
    aumico_core_form_min_length_error: 'La lunghezza minima per questo input è',
    aumico_core_file_upload_title: 'Upload di file',
    aumico_reports_action_bar_footer_back_to: 'Torna a',
    aumico_reports_action_bar_footer_proceed_to: 'Salva e continua a',
    aumico_reports_annualreport_toc_label_balance_sheet: 'Bilancio',
    aumico_reports_annualreport_toc_label_cash_flow_statement: 'Rendiconto di cassa',
    aumico_reports_annualreport_toc_label_notes_to_the_financial_statement: 'Note al bilancio',
    aumico_reports_annualreport_toc_label_income_statement: 'Conto economico',
    aumico_reports_annualreport_cover_annual_label_title_prefix: 'Bilancio per la periodo',
    aumico_reports_annualreport_cover_quarterly_label_title_prefix: 'Dichiarazione finanziaria trimestrale per la periodo',
    aumico_reports_annualreport_cover_monthly_label_title_prefix: 'Dichiarazione finanziaria mensile per la periodo',
    aumico_reports_annualreport_cover_custom_label_title_prefix: 'Dichiarazione finanziaria per la periodo',
    aumico_templates_account_mapping_child_form_name: 'Nome',
    aumico_templates_account_mapping_form_balance: 'Bilancia',
    aumico_templates_sub_fli_form_fli: 'Seleziona account',
    aumico_templates_account_mapping_child_form_number: 'NO.',
    aumico_templates_template_account_mapping_form_expand_all: 'Espandi tutto',
    aumico_users_edit_user_company_general_information_city: 'Città',
    aumico_users_edit_user_company_general_information_enter_no: 'Inserisci No.',
    aumico_users_edit_user_company_general_information_street: 'Strada',
    aumico_users_edit_user_company_general_information_address_addition: 'Aggiunta di indirizzo',
    aumico_users_edit_user_general_information_enter_email_address: "Immettere l'indirizzo e-mail",
    aumico_reports_annualreport_toc_label_table_of_contents: 'Sommario',
    aumico_reports_annualreport_print_date_from: 'da',
    aumico_reports_annualreport_print_date_to: 'a',
    aumico_reports_annualreport_print_date_of: 'al',
    aumico_reports_annualreport_print_label_previous_year: 'Anno precedente',
    aumico_reports_annualreport_print_label_current_year: 'Esercizio corrente',
    aumico_reports_annualreport_print_label_ratio: 'Rapporto',
    aumico_reports_annualreport_print_label_taxdomicile: 'Ufficio delle imposte',
    aumico_reports_annualreport_print_label_taxid: 'Numero fiscale',
    aumico_reports_annualreport_print_label_assets: 'ATTIVO',
    aumico_reports_annualreport_print_label_liabilities: 'PASSIVO',
    aumico_reports_annualreport_print_label_paeg: 'Foglio',
    aumico_users_edit_user_general_information_name: 'Nome',
    aumico_users_edit_user_company_general_information_enter_city: 'Entra in città',
    aumico_users_edit_user_general_information_surname: 'Cognome',
    aumico_users_edit_user_company_general_information_name: 'Nome',
    aumico_users_edit_user_security_enable_two_factor_authentication: 'Abilita autenticazione a 2 fattori',
    aumico_users_edit_user_general_information_edit_your_profile: 'Modifica Profilo',
    aumico_templates_template_account_mapping_form_collapse_all: 'Crollare tutto',
    aumico_users_edit_user_general_information_enter_surname: 'Immettere il cognome',
    aumico_templates_caption: 'Didascalia',
    aumico_templates_subtotal_name: 'Subtotal name -it',
    aumico_templates_subtotal_scope: 'Subtotal scope -it',
    aumico_templates_subtotal_position_after: 'Position After -it',
    aumico_templates_subtotal_select_position: 'Select Position -it',
    aumico_templates_subtotal_select_position_as_first_element: 'As first element -it',
    aumico_users_edit_user_general_information_select_salutation: 'Seleziona il saluto',
    aumico_users_edit_user_company_general_information_choose_country: 'Scegli il paese',
    aumico_users_edit_user_security_confirm_new_password: 'Conferma la nuova password',
    aumico_users_aumico_form_error: 'Errore di forma Aumico',
    aumico_users_edit_user_security_new_password: 'Nuovo Passowrd',
    aumico_users_edit_user_company_general_information_enter_name: 'Inserisci il nome',
    aumico_users_edit_user_company_general_information_edit_your_profile: 'Modifica Profilo',
    aumico_users_edit_user_company_general_information_no: 'NO.',
    aumico_users_edit_user_company_general_information_enter_zip: 'Inserisci Zip',
    aumico_users_edit_user_general_information_email_address: 'Indirizzo e-mail',
    aumico_users_edit_user_general_information_choose_language: 'Scegli la lingua',
    aumico_users_edit_user_general_information_langugage: 'Lingua',
    aumico_users_edit_user_general_information_enter_phone_number: 'Immettere il numero di telefono',
    aumico_users_edit_user_general_information_settings: 'Impostazioni',
    aumico_users_edit_user_general_information_salutation: 'Saluto',
    aumico_users_edit_user_security_current_password: 'password attuale',
    aumico_users_edit_user_security_change_password: 'Cambiare la password',
    aumico_users_edit_user_security_repeat_new_password: 'Ripetere la nuova password',
    aumico_reports_annualreport_toc_label_proposal_for_the_appropriation_of_profit:
        "Proposta per l'appropriazione del profitto",
    aumico_users_edit_user_security_enter_new_password: 'Inserire una nuova password',
    aumico_templates_account_mapping_form_income: 'Reddito',
    aumico_templates_template_account_mapping_form_mapped_accounts: 'Account mappati',
    aumico_users_edit_user_company_general_information_country: 'Paese',
    aumico_users_edit_user_company_general_information_enter_street: 'Entra in strada',
    aumico_users_edit_user_company_general_information_zip: 'Codice Postale',
    aumico_users_edit_user_general_information_enter_name: 'Immettere il nome',
    aumico_users_edit_user_general_information_phone: 'Telefono',
    aumico_users_edit_user_security_authentication: 'Autenticazione',
    aumico_users_edit_user_security_enter_current_password: 'Immetti la password corrente',
    aumico_templates_account_mapping_form_map_sme_account_plan: 'Mappatura automatica / piano account PMI',
    aumico_templates_account_mapping_form_datev_format_mismatch_warning:
        'La struttura delle voci importata prevede destinazioni di conto, il file caricato non ne ha — la mappatura esistente resta invariata.',
    aumico_templates_account_mapping_form_datev_unknown_purpose_warning: 'Destinazione di conto sconosciuta: {{key}}',
    aumico_templates_account_mapping_form_datev_purpose_shaped_value_warning:
        'Valore in formato destinazione nel percorso per numero di conto: {{key}}',
    aumico_templates_account_mapping_form_datev_no_candidate_warning: 'Conto {{key}}: il file DATEV non consente una voce univoca. Mappalo manualmente.',
    aumico_templates_account_mapping_form_datev_ambiguous_candidates_warning:
        'Conto {{key}}: il file DATEV lo assegna a più voci ({{candidates}}). Mappalo manualmente.',
    aumico_templates_account_mapping_form_datev_warnings_dismiss: 'Chiudi messaggio',
    aumico_templates_account_mapping_form_datev_unknown_format_warning:
        'Formato di assegnazione sconosciuto nel modello, usato il percorso per numero di conto: {{key}}',
    aumico_annual_report_import_form_balance_end: "Si prega di specificare l'ultima riga per i conti del saldo",
    aumico_annual_report_import_form_error_invalid_row_input: 'Ingresso di riga non valido',
    aumico_annual_report_import_form_balance_start: 'Si prega di specificare la riga iniziale per i conti del saldo',
    aumico_annual_report_import_form_error_overlapping:
        'Gli intervalli per i conti di saldo e reddito sono sovrapposti',
    aumico_annual_report_import_form_income_end: "Si prega di specificare l'ultima riga per i conti di reddito",
    aumico_annual_report_import_form_income_start: 'Si prega di specificare la riga iniziale per i conti di reddito',
    aumico_annualreport_aop_word_before_currency: 'In',
    aumico_core_form_submit: 'Salva',
    aumico_notes_word_in: 'In',
    aumico_reports_annualreport_cover_annual_label_title_1st_prefix: 'Dichiarazione finanziaria annuale',
    aumico_reports_annualreport_cover_quarterly_label_title_1st_prefix: 'Dichiarazione finanziaria trimestrale',
    aumico_reports_annualreport_cover_monthly_label_title_1st_prefix: 'Dichiarazione finanziaria mensile',
    aumico_reports_annualreport_cover_custom_label_title_1st_prefix: 'Dichiarazione finanziaria',
    aumico_reports_annualreport_page_print_account_mapping_label_total: 'Totale',
    aumico_reports_annualreport_page_print_account_mapping_label_word_before_currency: 'In',
    aumico_reports_annualreport_page_print_account_mapping_label_notes: 'Appunti',
    aumico_users_edit_user_general_information_salutations_mr: 'Sig',
    aumico_users_edit_user_general_information_salutations_mrs: 'Sig.ra',
    aumico_users_edit_user_general_information_languages_english_us: 'Inglese (noi)',
    aumico_users_edit_user_general_information_languages_german_switzerland: 'Tedesco (Svizzera)',
    aumico_users_edit_user_general_information_languages_german_germany: 'Germania (Germania)',
    aumico_users_edit_user_general_information_languages_italian_switzerland: 'Italiano (Svizzera)',
    aumico_users_edit_user_general_information_languages_french_switzerland: 'Francese (Svizzera)',
    aumico_templates_group_account_mapping_create_subfli: 'Crea subfli',
    aumico_reports_annualreport_cover_label_title_2nd_prefix: "per la periodo da",
    aumico_templates_sub_fli_form_fli_options_label: 'Scegli fli',
    aumico_annual_report_table_menu_option_archive: 'Archivio',
    aumico_annual_report_table_menu_option_display_active: 'Visualizza attivo',
    aumico_annual_report_table_menu_option_delete: 'Eliminare',
    aumico_annual_report_table_menu_option_restore: 'Ristabilire',
    aumico_notes_fli_selection_placeholder: 'Seleziona posizione',
    aumico_notes_fli_drag_disabled_tooltip: 'Tutte le posizioni devono essere selezionate prima di trascinare e rilasciare',
    aumico_annual_report_table_menu_option_display_archived: 'Mostra archiviato',
    aumico_notes_rich_text_placeholder: 'Inserire il testo',
    aumico_reports_bexio_error:
        "O hai rifiutato di concedere le autorizzazioni necessarie o si è verificato un errore durante l'elaborazione della richiesta",
    aumico_reports_unsaved_changes_warning_dialog_cancel: 'Annulla',
    aumico_notes_table_with_form_enter_placeholder: 'accedere',
    aumico_reports_unsaved_changes_warning_dialog_content: 'Hai cambiati cambiamenti. Vuoi salvare i tuoi dati?',
    aumico_reports_unsaved_changes_warning_dialog_discard: 'Non salvare le modifiche',
    aumico_reports_unsaved_changes_warning_dialog_save: 'Salva',
    aumico_reports_unsaved_changes_warning_dialog_save_unsuccessful: 'Il risparmio non ha successo',
    aumico_annual_report_cash_flow_add_new_item: 'Aggiungi un nuovo elemento',
    aumico_annual_report_cash_flow_financing_activities_title: 'Flusso di cassa dalle attività di finanziamento',
    aumico_annual_report_cash_flow_button_recalculate_flis: 'Ripristina',
    aumico_annual_report_cash_flow_investing_activities_disinvestments: 'Disinvestimenti',
    aumico_annual_report_cash_flow_investing_activities_title: 'Flusso di cassa dalle attività di investimento',
    aumico_annual_report_cash_flow_investing_activities_investments: 'Investimenti',
    aumico_annual_report_cash_flow_operating_activities_title: 'Flusso di cassa dalle attività operative',
    aumico_annual_report_cash_flow_total: 'Modifica totale in contanti e contanti equivalenti',
    aumico_annual_report_cash_flow_total_cashAndCashEnd: 'In contanti e equivalenti in contanti alla fine del periodo',
    aumico_annual_report_cash_flow_total_cashAndCashStart: "Equivalenti in contanti e contanti all'inizio del periodo",
    aumico_annual_report_cash_flow_total_total1_name: 'Modifica totale in contanti e contanti equivalenti',
    aumico_annual_report_cash_flow_total_total2: 'Modifica totale in contanti e contanti equivalenti',
    aumico_annual_report_print_options_label_show_reclasses_in_sums: 'comprese le riclassificazioni',
    aumico_annual_report_print_options_mainTitle: 'Titolo',
    aumico_annual_report_cash_flow_total_total1: 'Modifica totale in contanti e contanti equivalenti',
    aumico_notes_component_options_movementschedule_column2: 'Colonna 2',
    aumico_notes_component_options_movementschedule_column3: 'Colonna 3',
    aumico_annual_report_print_options_date: 'Periodo',
    aumico_reports_annualreport_navigation_cfs: 'Rendiconto di cassa',
    aumico_reports_annualreport_navigation_label_balance: 'Bilancia',
    aumico_templates_reclass_label_adjustment: 'Riserve nascoste',
    aumico_annual_report_cash_flow_total_recapitulation: 'Ricapitolazione',
    aumico_annual_report_interpretation_remove_account_with_zero_balance: 'Rimuovere i conti con saldo zero',
    aumico_annual_report_print_options_show_cfs: 'Rendiconto di cassa',
    aumico_templates_reclass_label_change_in_adjustment: '△ Regola.',
    aumico_notes_component_options_movementschedule_column4: 'Colonna 4',
    aumico_templates_reclass_label_reclass: 'Riclasse.',
    aumico_reports_annualreport_navigation_label_income: 'Reddito',
    aumico_annual_report_print_options_subTitle: 'Sottotitolo',
    aumico_templates_reclass_label_in: 'In',
    aumico_notes_preview_attention:
        'Attenzione: questa sezione mostra solo come appare il componente e qualsiasi cambiamento in esso non rifletterà sui dati salvati',
    aumico_templates_reclass_label_total: 'Riclassificazioni totali',
    aumico_annual_report_cash_flow_total_total2_name: 'Modifica totale in contanti e contanti equivalenti',
    aumico_reports_annualreport_page_adjustments_label_account_number: 'Numero di conto',
    aumico_annual_report_print_options_label_show_adjustments_in_sums: 'Interno (riserve nascoste incl.)',
    aumico_templates_reclass_label_income: 'Conto economico',
    aumico_notes_component_options_movementschedule_column1: 'Colonna 1',
    aumico_reports_annualreport_navigation_adjustments_and_reclasses: 'Regolazioni e riclassi',
    aumico_templates_reclass_label_account_number: 'Numero di conto',
    aumico_templates_reclass_label_internal: 'interno',
    aumico_annual_report_cash_flow_print_preview_notes: 'Appunti',
    aumico_annual_report_print_options_decimal_and_empty_lines_title: 'Linee decimali e vuote',
    aumico_annual_report_print_options_reclasses_and_internal_title: 'Valori e rapporti',
    aumico_annual_report_print_options_design_settings_title: 'Design e formattazione',
    aumico_annual_report_print_options_show_organization_logo: 'Organization Logo',
    aumico_annual_report_print_options_show_company_logo: 'Print Company Logo',
    aumico_annual_report_print_options_show_components_title: 'Mostra componenti',
    aumico_annual_report_print_options_show_accounts: 'Account dettagliati',
    aumico_annual_report_print_options_hide_previous_year: 'Nascondi anno precedente',
    aumico_annual_report_print_options_show_notes: 'Appunti',
    aumico_companies_table_label_company_legal_status: 'Forma giuridica',
    aumico_companies_table_label_status: 'Status',
    aumico_companies_table_new_button: 'Add New Company',
    aumico_companies_table_search_button: 'Search for companies',
    aumico_companies_table_label_company_badge_active: 'Active',
    aumico_companies_table_label_company_badge_inactive: 'Inactive',
    aumico_companies_details_text: 'Company Details',
    aumico_companies_delete_dialog_ok: 'Delete',
    aumico_companies_delete_dialog_cancel: 'Cancel',
    aumico_companies_delete_dialog_text_1: 'Do you want to <strong>Delete</strong> this company profile?',
    aumico_companies_delete_dialog_text_2: 'This action is permanent and cannot be undone.',
    aumico_companies_inactivate_dialog_ok: 'Disable',
    aumico_companies_activate_button: 'Activate',
    aumico_companies_inactivate_dialog_cancel: 'Cancel',
    aumico_companies_inactivate_dialog_text_1: 'Do you want to <strong>Disable</strong> this company?',
    aumico_companies_inactivate_dialog_text_2: 'You can reactivate the company at any time if needed.',
    aumico_companies_activate_state: 'Active',
    aumico_companies_inactivate_state: 'Inactive',
    aumico_companies_changes_saved_successfully_dialog: 'La società è stata aggiornata con successo.',
    aumico_companies_table_label_company_location: 'Posizione',
    aumico_companies_table_label_company_name: 'Nome della ditta',
    aumico_companies_table_label_company_street_and_number: 'Via e numero',
    aumico_reports_main_navigation_company_list: 'Aziende',
    aumico_reports_print_highlight_color: 'Evidenzia il colore',
    aumico_companies_table_label_company_postal_code: 'Codice Postale',
    aumico_templates_adjustmentAndReclassed_group_form_tooltip:
        'Invia il cambio di rettifica ai conti di reddito specifici',
    aumico_templates_income_selection_popup_done_btn: 'Fatto',
    aumico_users_edit_user_company_general_information_upload_logo_label: 'Carica il modello di carta intestata',
    aumico_templates_income_selection_popup_title: 'Conti di reddito',
    aumico_users_edit_user_company_general_information_upload_logo_text:
        'Trascina e lascia cadere un PDF con il modello di carta intestata qui',
    aumico_reports_print_text_color: 'Colore del testo',
    aumico_users_edit_user_company_general_information_company_logo: 'Modello di carta intestata',
    aumico_reports_main_navigation_edit_company: 'Modifica / crea azienda',
    aumico_reports_print_title_color: 'Colore del titolo',
    aumico_reports_print_table_header_color: 'Table Header',
    aumico_reports_print_table_footer_color: 'Table Footer',
    aumico_reports_design_settings_select_colors_title: 'Select colors',
    aumico_reports_design_settings_preview_title: 'Preview',
    aumico_reports_design_settings_save_button: 'Save',
    aumico_reports_design_settings_example_title: '1. Example Table',
    aumico_reports_design_settings_example_title_row: 'This is a example title row',
    aumico_reports_design_settings_example_normal_row: 'This is a example common row',
    aumico_reports_design_settings_example_footer_row: 'This is a example footer row',
    aumico_users_edit_user_company_general_information_upload_logo_extension_error: 'Carica il file PDF',
    aumico_annual_report_import_balance_and_income_from_separate_files_option: 'Carica saldo e reddito separatamente',
    aumico_annual_report_import_definition_specify_data_start_line_1:
        'Specificare il numero di riga su cui iniziano i dati per gli account',
    aumico_annual_report_import_definition_specify_data_start_line_2: 'Tavolo',
    aumico_annual_report_import_form_balance_instruction_text:
        'Trascina e lascia cadere il file di saldo del client qui',
    aumico_annual_report_import_form_income_instruction_text:
        'Trascina e lascia cadere il file di reddito del cliente qui',
    aumico_annual_report_import_optional_settings_title: 'Impostazioni opzionali',
    aumico_annual_report_aop_accounts_placeholder: 'Seleziona account',
    aumico_annual_report_general_information_autofill_from_list_btn_text: 'Scegli il rapporto annuale da AutoFill da',
    aumico_annual_report_general_information_autofill_from_previous_year_btn_text:
        "Rapporto annuale Autofill dell'anno precedente",
    aumico_annual_report_general_information_balance_sheet: 'Bilancio',
    aumico_annual_report_general_information_current_year: 'Anno corrente',
    aumico_annual_report_general_information_date_from: 'Da',
    aumico_annual_report_general_information_date_to: 'A',
    aumico_annual_report_general_information_income_current_date_from_error:
        'Il reddito corrente dalla data deve essere inferiore alla data attuale e maggiore o uguale prima della data',
    aumico_annual_report_general_information_income_current_date_to_error:
        'La data di fine è prima della data di inizio',
    aumico_annual_report_general_information_income_previous_date_from_error:
        'Il reddito precedente dalla data deve essere inferiore a quello precedente',
    aumico_annual_report_general_information_income_previous_date_to_error:
        'Il reddito precedente fino alla data deve essere inferiore o uguale alla data e maggiore rispetto alla data',
    aumico_annual_report_general_information_income_statement: 'Conto economico',
    aumico_annual_report_general_information_no_previous_data: 'Nessun dati precedente disponibile (Fondazione)',
    aumico_annual_report_general_information_optional_or: 'O',
    aumico_annual_report_general_information_options: 'Opzioni',
    aumico_annual_report_general_information_please_determine_income_date: 'Determina la data del conto economico',
    aumico_annual_report_general_information_previous_period: 'Periodo precedente',
    aumico_annual_report_general_information_take_autofill_from_previous_annual_report:
        'Usa le configurazioni del rapporto precedente (UPLOA',
    aumico_annual_report_general_information_take_previous_data_from_annual_report:
        "Per il valore dell'anno precedente",
    aumico_annual_report_import_choose_annual_report_for_autofill_and_mapping_button:
        'Scegli il rapporto annuale per prendere il caricamento/mappatura automatica da',
    aumico_annual_report_import_select_annual_report_for_autofill_and_mapping:
        'Seleziona un rapporto annuale per prendere il caricamento/mappatura automatica da',
    aumico_annual_report_selection_list_accounting_basis: 'Base contabile',
    aumico_annual_report_selection_list_company: 'Azienda',
    aumico_annual_report_selection_list_current_year_date: 'Anno corrente',
    aumico_annual_report_selection_list_legal_form: 'Forma giuridica',
    aumico_new_button: 'Nuovo',
    aumico_reports_annualreport_page_financial_statement_general_information_label_general_information:
        'informazioni generali',
    aumico_reports_print_page_adjustments_reclasses_warning:
        "Si prega di essere consapevoli del fatto che le modifiche eseguite manualmente nell'estratto conto del flusso di cassa potrebbero essere sovrascritte attraverso i valori interni.",
    aumico_reports_print_title_establishment: 'Istituzione',
    aumico_reports_warning_popup_warning_title: 'Avvertimento',
    aumico_search_placeholder: 'Ricerca...',
    aumico_templates_account_mapping_form_map_income_total: 'Trasferisci il risultato annuale al saldo',
    aumico_templates_account_mapping_form_transferred_profit_account_name: 'Profitto trasferito',
    aumico_templates_account_mapping_form_transferred_surplus_account_name: 'Profitto trasferito',
    aumico_annual_report_print_options_disable_balance_sheet_page_break: 'Bilancia su una pagina',
    aumico_annual_report_print_options_place_signature_after_aop: 'Posizionare la firma dopo AOP',
    aumico_core_data_grid_items: 'elementi',
    aumico_core_pagination_action_bar_range_text: 'Di',
    aumico_core_accordion_Information_dialog_title: 'Informazione',
    aumico_core_table_filter_placeholder: 'Filtro',
    aumico_users_company_profile_general_information_side_margins: 'Margini di pagina: 1,5 cm da tutti i lati',
    aumico_admin_navigation_accounting_basis: 'Base contabile',
    aumico_admin_navigation_change_password: 'Cambiare la password',
    aumico_admin_navigation_aumico_users: 'Utenti Aumico',
    aumico_admin_navigation_home: 'Casa',
    aumico_admin_navigation_legal_form: 'Forma giuridica',
    aumico_admin_navigation_financial_line_item: 'Articolo di linea finanziaria',
    aumico_admin_navigation_localization: 'Localizzazione',
    aumico_admin_navigation_logout: 'Disconnettersi',
    aumico_admin_navigation_manage: 'Maneggio',
    aumico_admin_navigation_login: 'Login',
    aumico_admin_navigation_notes: 'Appunti',
    aumico_admin_navigation_settings: 'Impostazioni',
    aumico_admin_navigation_signup: 'Iscrizione',
    aumico_admin_navigation_templates: 'Modelli',
    aumico_admin_navigation_user_management: 'Gestione utenti',
    aumico_admin_navigation_types: 'Tipi',
    aumico_annual_report_cash_flow_mandatory_field: 'Il seguente campo è obbligatorio',
    aumico_admin_user_already_exists: "L'utente esiste già",
    aumico_admin_form_language: 'Language it-ch',
    aumico_settings_financialLineItem_form_name_already_exists_error:
        "Il nome dell'articolo della linea finanziaria esiste già",
    aumico_settings_accountingbasis_form_name_already_exists_error: 'Il nome di base contabile esiste già',
    aumico_settings_legalForm_form_name_already_exists_error: 'Il nome della forma legale esiste già',
    aumico_annual_report_general_information_company: 'Azienda',
    aumico_reports_main_navigation_user_profile: 'Modifica il profilo utente',
    aumico_annual_report_print_options_show_fli_total: 'Mostra il totale FLI',
    aumico_reports_internal_mapping_changes_warning:
        'Il sistema ha apportato alcune modifiche alla mappatura, quindi ti preghiamo di salvare se si desidera mantenerle.',
    aumico_annual_report_interpretation_account_number_invalid_input:
        'Sono consentiti solo numeri o intervalli positivi (ad es. 3 o 3-5)',
    aumico_reports_welcome_page_footer_about_link: 'https://aumico.io/en/agb/',
    aumico_reports_welcome_page_footer_impressum_link: 'https://aumico.io/impressum/',
    aumico_reports_welcome_page_footer_privacy_policy_link:
        'https://aumico.io/en/datenschutz/aumico_reports_welcome_page_footer_impressum_link',
    aumico_templates_group_account_mapping_unallowed:
        'La mappatura dei conti selezionati sul FLI desiderato non è consentita perché contiene uno o più FLI secondari.',
    aumico_information_dialog_title: 'Informazione',
    aumico_reports_equality_check_dialog_assets_and_liabilities_closing_not_equal:
        "Le attività non sono uguali alle passività e all'equità nell'anno in corso",
    aumico_reports_equality_check_dialog_assets_and_liabilities_opening_and_closing_not_equal:
        "Le attività non sono uguali alle passività e all'equità negli anni attuali e precedenti",
    aumico_reports_equality_check_dialog_assets_and_liabilities_opening_not_equal:
        "Le attività non sono uguali alle passività e all'equità nell'anno precedente",
    aumico_reports_equality_check_dialog_cashflow_totals_closing_not_equal:
        "I totali del flusso di cassa non sono uguali nell'anno in corso",
    aumico_reports_equality_check_dialog_cashflow_totals_opening_and_closing_not_equal:
        'I totali del flusso di cassa non sono uguali negli anni attuali e precedenti',
    aumico_reports_equality_check_dialog_cashflow_totals_opening_not_equal:
        "I totali del flusso di cassa non sono uguali nell'anno precedente",
    aumico_reports_equality_check_dialog_go_back_and_correct_it: 'Torna indietro e correggilo',
    aumico_potential_impact_on_all_users_utilizing_that_template_will_occur:
        'a potential impact on all users utilizing that template will occur it-ch',
    aumico_reports_equality_check_dialog_proceed: 'Procedere',
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_closing_not_equal:
        "Il reddito degli utili non è uguale all'utile FLI nell'anno in corso",
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_opening_and_closing_not_equal:
        'Il reddito degli utili non è uguale al profitto FI negli anni attuali e precedenti',
    aumico_reports_equality_check_dialog_profit_income_and_profit_fli_opening_not_equal:
        "Il reddito degli utili non è uguale al profitto FI dell'anno precedente",
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_closing_not_equal:
        "Le attività di adeguamenti totali e le passività totali non sono uguali nell'anno in corso",
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_opening_and_closing_not_equal:
        'Le attività di adeguamento totali e le passività totali non sono uguali negli anni attuali e precedenti',
    aumico_reports_equality_check_dialog_total_adjustments_assets_and_total_adjustments_liabilities_opening_not_equal:
        "Le attività di adeguamento totali e le passività totali non sono uguali nell'anno precedente",
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_closing_not_equal:
        "Regotti totali reddito e rettifiche totali L'utile non è uguale nell'anno in corso",
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_opening_and_closing_not_equal:
        "Regotti totali reddito e rettifiche totali L'utile non è uguale negli anni attuali e precedenti",
    aumico_reports_equality_check_dialog_total_adjustments_income_and_total_adjustments_profit_fli_opening_not_equal:
        "Regotti totali reddito e rettifiche totali L'utile non è uguale nell'anno precedente",
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_opening_and_closing_not_equal:
        'Le attività di riclassi totali e le passività totali di riclassi non sono uguali negli anni attuali e precedenti',
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_closing_not_equal:
        "Le attività di riclassi totali e le passività totali di riclassi non sono uguali nell'anno in corso",
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_closing_not_equal:
        "Il reddito totale riclasse e il profitto totale riclassi non sono uguali nell'anno in corso",
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_opening_and_closing_not_equal:
        'Il reddito totale riclasse e il profitto totale riclassi non sono uguali negli anni attuali e precedenti',
    aumico_reports_equality_check_dialog_total_reclasses_income_and_total_reclasses_profit_fli_opening_not_equal:
        "Il reddito totale riclasse e il profitto di riclassi totali non sono uguali nell'anno precedente",
    aumico_reports_equality_check_print_preview_table_adjustments: 'Regolazioni',
    aumico_reports_equality_check_print_preview_information_dialog_content:
        'I nostri controlli di coerenza ti aiutano a evitare errori nel tuo rendiconto finanziario.',
    aumico_reports_equality_check_print_preview_table_adjustments_profit_income_equals_adjustments_profit_balance:
        'Competitori reddito utile = adeguamento del bilancio degli utili',
    aumico_reports_equality_check_dialog_total_reclasses_assets_and_total_reclasses_liabilities_opening_not_equal:
        "Le attività di riclassi totali e le passività totali di riclassi non sono uguali nell'anno precedente",
    aumico_reports_equality_check_print_preview_table_assets_equal_liabilities: 'Attività = passività',
    aumico_reports_equality_check_print_preview_table_current_year_column: 'Anno corrente',
    aumico_reports_equality_check_print_preview_table_cashflow_statement: 'Rendiconto di cassa',
    aumico_reports_equality_check_print_preview_table_previous_year_row: "L'anno scorso",
    aumico_reports_equality_check_print_preview_table_profit_income_equals_profit_fli:
        'Reddito da profitto = profitto fli',
    aumico_reports_equality_check_print_preview_table_previous_year_column: "L'anno scorso",
    aumico_reports_equality_check_print_preview_table_reclasses_profit_income_equals_reclasses_profit_balance:
        'Riclassiona il reddito da utili = riclasse il saldo degli utili',
    aumico_reports_equality_check_print_preview_table_current_year_row: 'Anno corrente',
    aumico_reports_equality_check_print_preview_table_title: 'Panoramica',
    aumico_reports_equality_check_print_preview_table_reclasses: 'Riclassi',
    aumico_reports_equality_check_print_preview_title: 'Controlli di coerenza',
    aumico_reports_required_data_not_completed: 'I dati dei passaggi precedenti non sono ancora completati!',
    aumico_reports_template_not_found:
        'Non è stato trovato alcun modello con la forma giuridica e il conto selezionati',
    aumico_reports_error_dialog_something_went_wrong: 'Qualcosa è andato storto',
    aumico_annual_report_print_options_label_income_ratio_reference: 'Riferimento del rapporto di reddito',
    aumico_annual_report_print_options_income_ratio_reference_internal_change_warning_message:
        "Si prega di essere consapevoli del fatto che il valore selezionato come riferimento del rapporto di reddito è stato modificato dal sistema. Questo è dovuto al fatto che il valore di apertura o di chiusura dell'elemento precedentemente selezionato è diventato 0",
    aumico_annual_report_print_options_label_show_ratios: 'Rapporti di spettacolo',
    aumico_companies_notification_error_description: 'La società non potrebbe essere aggiornata.',
    aumico_reports_notification_information_title: 'Informazione',
    aumico_reports_notification_success_title: 'Aggiornato con successo',
    aumico_reports_default_page_header: 'Non definito',
    aumico_reports_notification_error_title: 'Qualcosa è andato storto',
    aumico_admin_edit_user_profile: 'Modifica il profilo utente',
    aumico_core_information_popup_default_title: 'Informazione',
    aumico_templates_group_form_enter_group_title_error: 'Inserisci il titolo del gruppo',
    aumico_templates_group_form_enter_group_total_name_error: 'Immettere il nome totale del gruppo',
    aumico_templates_group_form_title: 'Titolo del gruppo',
    aumico_templates_group_form_total_name: 'Nome totale del gruppo (totale ...)',
    aumico_annual_report_complementary_reports_add_report_button: 'Aggiungi report',
    aumico_annual_report_complementary_reports_description:
        'Si prega di aggiungere ulteriori rapporti al tuo rendiconto finanziario come la direzione sommaria',
    aumico_annual_report_complementary_reports_headline: 'Rapporti complementari',
    aumico_annual_report_complementary_reports_report_rich_text_placeholder: 'Inserisci il tuo testo',
    aumico_annual_report_complementary_reports_report_title: 'Titolo del rapporto',
    aumico_annual_report_complementary_reports_title_error: 'Il titolo è richiesto',
    aumico_annual_report_print_options_show_complementary_reports: 'Rapporti complementari',
    aumico_empty_field_error: 'Questo campo è obbligatorio',
    aumico_reports_annualreport_navigation_complementary_reports: 'Rapporti complementari',
    aumico_users_personal_information_language_error: 'È richiesto il linguaggio',
    aumico_users_personal_information_organization_label: 'Nome della tua organizzazione',
    aumico_users_personal_information_language_section_title: 'scegli la tua LINGUA',
    aumico_users_registration_email_username_placeholder: 'Pleas Inserisci il tuo indirizzo e-mail',
    aumico_users_personal_information_sub_title: 'Fornici le seguenti informazioni:',
    aumico_users_personal_information_main_title: 'Vorremmo conoscerti',
    aumico_users_registration_password_label: 'Impostare la password',
    aumico_users_registration_password_placeholder: 'Per favore, inserisci la password',
    aumico_users_registration_email_username_required_error: 'È richiesto e-mail / nome utente',
    aumico_users_personal_information_organization_error: "L'organizzazione è richiesta",
    aumico_users_reset_password_button: 'Resetta la password',
    aumico_users_signup_continue_button: 'Continua',
    aumico_users_signup_creating_your_account_button: 'Creare il tuo account',
    aumico_users_registration_read_and_agree: 'Ho letto il',
    aumico_users_registration_main_title: 'Inizia la tua prova gratuita di 30 giorni!',
    aumico_users_registration_sub_title:
        '<ul> <li> Nessuna carta di credito e nessuna installazione richiesta <li> Supporto gratuito <li> Annulla in qualsiasi momento </ul> <br/> dopo 30 giorni',
    aumico_annual_report_ems_add_new_item_button_text: '+ Nuova riga',
    aumico_annual_report_ems_total_equity_header_text: 'Equità totale',
    aumico_annual_report_ems_new_total_column: 'Nuovo totale',
    aumico_annual_report_ems_manual_column: 'Colonna aggiunta manualmente',
    aumico_annual_report_ems_row_title: 'Capitale proprio al',
    aumico_annual_report_ems_business_year: 'Esercizio',
    aumico_annual_report_ems_difference_to: 'Differenza rispetto al capitale proprio al',
    aumico_annual_report_ems_position_column_header: 'Voce / movimento',
    aumico_annual_report_ems_add_column: '+ Nuova colonna',
    aumico_annual_report_ems_add_column_limit: 'Il PDF può visualizzare al massimo 8 colonne.',
    aumico_annual_report_ems_column_type_select_label: 'Seleziona il tipo di colonna',
    aumico_annual_report_ems_column_type_value: 'Colonna valori',
    aumico_annual_report_ems_column_type_value_description: 'Voce con valori inseribili',
    aumico_annual_report_ems_column_type_total: 'Colonna totale',
    aumico_annual_report_ems_column_type_total_description: 'Somma delle colonne valori selezionate',
    aumico_annual_report_ems_structure_diff_intro: 'La struttura dei conti nel mapping è cambiata.',
    aumico_annual_report_ems_structure_diff_new: 'Nuovi aggiunti: {{names}}.',
    aumico_annual_report_ems_structure_diff_removed: 'Non più presenti nel mapping: {{names}}.',
    aumico_annual_report_ems_structure_diff_apply: 'Aggiorna colonne',
    aumico_annual_report_print_options_show_ems: 'Mostra EMS',
    aumico_reports_annualreport_navigation_equity_movement_schedule: 'Movimento azionario',
    aumico_reports_annualreport_navigation_fixed_assets_schedule: 'Programma di immobilizzazioni',
    aumico_reports_annualreport_navigation_reorder_report_and_print: 'Stampa in ordine diverso',
    aumico_reports_equity_movement_schedule_no_table_shown_error_message:
        'Non ci sono FLIS nel gruppo azionario idoneo per il programma di movimento azionario',
    aumico_reports_reorder_report_cover_section_title: 'Copertina',
    aumico_reports_reorder_report_section_save_button: 'Salva',
    aumico_reports_reorder_report_sections_dialog_title: 'Sezioni di report riordina',
    aumico_annual_report_ems_text_addition_above_title: 'Introduzione',
    aumico_annual_report_ems_text_addition_below_title: 'Nota',
    aumico_annual_report_ems_title: 'Programma di movimento azionario',
    aumico_annual_report_print_preview_ems: 'Programma di movimento azionario',
    aumico_reports_main_navigation_organization_settings: "Impostazioni dell'organizzazione",
    aumico_reports_main_navigation_design_settings: 'Design',
    aumico_reports_organization_settings_navigation_organization_profile: 'Profilo',
    aumico_reports_organization_settings_navigation_text_snippets: 'Modelli di segnalazione',
    aumico_reports_organization_settings_text_snippets_title: 'Modelli di segnalazione',
    aumico_annual_report_complementary_reports_delete_icon_text: 'Eliminare',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_cancel_button: 'Annulla',
    aumico_annual_report_complementary_reports_prefill_with_text_snippet_icon_text: 'Preimpall con modello di report',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_description:
        'Sei sicuro ? Stai per sovrascrivere la tua casella di testo',
    aumico_annual_report_complementary_reports_text_snippets_decision_dialog_yes_button: 'SÌ',
    aumico_annual_report_complementary_reports_text_snippets_dialog_description: 'Descrizione',
    aumico_annual_report_complementary_reports_text_snippets_dialog_insert_text_snippet_button: 'Inserisci modello',
    aumico_annual_report_complementary_reports_text_snippets_dialog_title: 'Inserire il modello predefinito',
    aumico_reports_equity_movement_schedule_refresh_button_text: 'Aggiorna EMS',
    aumico_reports_organization_settings_text_snippets_add_new_button: 'Aggiungere nuova',
    aumico_reports_organization_settings_text_snippets_create_dialog_title: 'Aggiungi nuovo modello',
    aumico_reports_organization_settings_text_snippets_form_dialog_content_field_required_error:
        'È richiesto il contenuto',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_conflict_error_notification_description:
        'Impossibile creare un frammento di testo: la descrizione esiste già',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_success_notification_description:
        'Snippet di testo creato correttamente',
    aumico_reports_organization_settings_text_snippets_form_dialog_create_internal_server_error_description:
        'Impossibile creare snippet di testo: errore del server interno',
    aumico_reports_organization_settings_text_snippets_form_dialog_cancel_button: 'Annulla',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field_already_exists_error:
        'La descrizione esiste già',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field_required_error:
        'Descrizione richiesta',
    aumico_reports_organization_settings_text_snippets_form_dialog_save_button: 'Salva',
    aumico_reports_organization_settings_text_snippets_form_dialog_error_notification_title: 'Errore',
    aumico_reports_organization_settings_text_snippets_form_dialog_title_field: 'Titolo',
    aumico_reports_organization_settings_text_snippets_list_created_by_column_header: 'Creato da',
    aumico_reports_organization_settings_text_snippets_form_dialog_title_field_required_error: 'Titolo richiesto',
    aumico_reports_organization_settings_text_snippets_list_created_at_column_header: 'Creato a',
    aumico_reports_organization_settings_text_snippets_form_dialog_description_field: 'Descrizione',
    aumico_reports_organization_settings_text_snippets_list_delete_error_notification_description:
        'Impossibile eliminare gli snippet di testo: errore del server interno',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_description:
        'Sei sicuro di voler eliminare gli snippet di testo selezionati?',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_yes_button: 'SÌ',
    aumico_reports_organization_settings_text_snippets_list_delete_dialog_cancel_button: 'Annulla',
    aumico_reports_organization_settings_text_snippets_list_delete_success_notification_title: 'Riuscito',
    aumico_reports_organization_settings_text_snippets_list_last_modified_column_header: 'Ultima modifica',
    aumico_reports_organization_settings_text_snippets_form_dialog_success_notification_title: 'Successo',
    aumico_reports_organization_settings_text_snippets_list_delete_success_notification_description:
        'Frammenti di testo eliminati correttamente',
    aumico_reports_organization_settings_text_snippets_list_description_column_header: 'Descrizione',
    aumico_reports_organization_settings_text_snippets_list_title_column_header: 'Titolo',
    aumico_reports_organization_settings_text_snippets_list_delete_button: 'Eliminare',
    aumico_reports_organization_settings_text_snippets_list_delete_error_notification_title: 'Errore',
    aumico_reports_organization_settings_text_snippets_list_modified_by_column_header: 'Modificato da',
    aumico_admin_ar_template_data_not_completed_error:
        'I dati delle informazioni generali devono essere completati per primi',
    aumico_admin_ar_template_define_pdf_template: 'Definire il modello PDF',
    aumico_admin_ar_template_download_pdf_template: 'Scarica il modello PDF',
    aumico_admin_ar_template_general_information_accounting_bases: 'Basi contabili',
    aumico_admin_ar_template_general_information_annual_report_steps: 'Passi di navigazione del rapporto annuale',
    aumico_admin_ar_template_general_information_consistency: 'Consistenza',
    aumico_admin_ar_template_general_information_countries: 'Paese',
    aumico_admin_ar_template_general_information_field_required_error: 'Questo campo è obbligatorio',
    aumico_admin_ar_template_general_information_legal_forms: 'Forme legali',
    aumico_admin_ar_template_general_information_business_models: 'Business Model -it-ch',
    aumico_admin_ar_template_general_information_state: 'Stato',
    aumico_admin_ar_template_general_information_name: 'Nome',
    aumico_admin_ar_template_list_delete_error_notification_description:
        'Impossibile eliminare il modello di report annuale',
    aumico_admin_ar_template_list_delete_failed_notification_title: 'Errore',
    aumico_admin_ar_template_list_delete_success_notification_description:
        'Modello di rapporto annuale eliminato con successo',
    aumico_admin_ar_template_list_menu_item_delete: 'Eliminare',
    aumico_admin_ar_template_navigation_general_information: 'Informazioni generali',
    aumico_admin_ar_template_list_delete_success_notification_title: 'Successo',
    aumico_admin_ar_template_navigation_balance_sheet_taxonomy: 'Tassonomia del foglio di bilancio',
    aumico_admin_ar_template_navigation_income_statement_taxonomy: 'Tassonomia del conto economico',
    aumico_admin_ar_template_pdf_error_notification_description_file_too_large:
        'Impossibile caricare il modello PDF: il file è troppo grande',
    aumico_admin_ar_template_navigation_notes: 'Appunti',
    aumico_admin_ar_template_navigation_pdf_template: 'Modello PDF',
    aumico_admin_ar_template_pdf_updated_success_notification_description: 'Modello pdf aggiornato correttamente',
    aumico_admin_countries_label: 'Paesi',
    aumico_admin_ar_template_table_actions: 'Azioni',
    aumico_admin_ar_template_specifications: 'Specifiche',
    aumico_admin_ar_template_pdf_error_notification_description_file_type_invalid:
        'Impossibile caricare il modello PDF: il tipo di file deve essere docx',
    aumico_admin_menu_item_demote_to_admin: 'DEMOTE AMMIN',
    aumico_admin_navigation_ar_templates: 'Modelli AR',
    aumico_admin_menu_item_unblock_user: 'Sblocca utente',
    aumico_admin_menu_item_promote_to_admin: "Promuovere l'amministratore",
    aumico_admin_menu_item_block_user: 'Blocca utente',
    aumico_admin_user_list_notification_failure_description:
        'Si è verificato un errore, riprova più tardi o contattaci',
    aumico_admin_user_list_notification_success_title: 'Successo',
    aumico_admin_user_list_notification_success_description: 'Utente aggiornato correttamente',
    aumico_admin_user_list_notification_failure_title: 'fallimento',
    aumico_admin_user_list_status_inactive: 'inattivo',
    aumico_admin_usermanagement_confirmation_modal_change_user_role: 'Vuoi cambiare il ruolo di {email} da',
    aumico_admin_usermanagement_confirmation_modal_change_user_activity_state: 'Vuoi cambiare {email} da',
    aumico_admin_usermanagement_confirmation_modal_cancel_button: 'Annulla',
    aumico_admin_usermanagement_confirmation_modal_title_block_user: 'Blocca utente',
    aumico_admin_usermanagement_confirmation_modal_title_promote_admin: "Promuovere l'amministratore",
    aumico_admin_usermanagement_confirmation_modal_title_unblock_user: 'sblocca utente',
    aumico_admin_usermanagement_confirmation_modal_title_demote_admin: 'DEMOTE AMMIN',
    aumico_admin_navigation_aumico_organization: 'Organizzazioni Aumico',
    aumico_annual_report_import_page_can_not_navigate_to_mapping_dialog_description:
        'È necessario caricare prima i dati per navigare nel passaggio di mappatura',
    aumico_annual_report_print_options_experimental_section: 'Crea il tuo design',
    aumico_annual_report_print_options_experimental_section_description:
        'Crea il tuo design tra cui stile di carattere e layout. Contattaci a sales@aumico.ch per ulteriori informazioni. Ci metteremo in contatto con te.',
    aumico_annual_report_print_options_aop: 'Appropriazione del profitto',
    aumico_annual_report_print_options_fin_statement: 'Rendiconto finanziario',
    aumico_annual_report_print_options_hide_decimal_places_in_values: 'Nascondi i luoghi decimali in valori',
    aumico_annual_report_print_options_hide_decimal_places_in_ratios: 'Nascondere i luoghi decimali in rapporti',
    aumico_annual_report_print_options_hide_empty_lines: 'Rimuovere le linee vuote',
    aumico_admin_user_list_status_active: 'Attivo',
    aumico_annual_report_print_options_show_account_numbers: 'Mostra i numeri di conto',
    aumico_change_password_notification_success: 'Password cambiata con successo',
    aumico_change_password_notification_failed_title: 'Fallito!',
    aumico_change_password_relogin_title: 'Password modificata',
    aumico_change_password_relogin_description: 'La sua password è stata modificata. Effettui di nuovo l\'accesso.',
    aumico_change_password_relogin_failed_title: 'Accedere di nuovo',
    aumico_change_password_relogin_failed_description: 'La sua password non è stata modificata. Effettui di nuovo l\'accesso.',
    aumico_change_password_relogin_button: 'Disconnettersi',
    aumico_change_password_notification_failed: 'Si è verificato un errore durante la modifica della password',
    aumico_admin_usermanagement_confirmation_modal_confirm_button: 'Confermare',
    aumico_companies_form_country_has_no_legal_form: 'Questo paese non contiene la forma legale selezionata precedente',
    aumico_editable_account_number_unique_validator: 'Il numero di conto dovrebbe essere univoco',
    aumico_editable_account_invalid_data_modal_title: 'dati non validi',
    aumico_editable_account_invalid_data_modal_content:
        "Il nome e il numero dell'account sono richiesti e il numero di conto dovrebbe essere univoco",
    aumico_editable_account_placeholder_name: 'Nome utente',
    aumico_annual_report_country_has_no_legal_account_basis:
        "Nessuna base di account disponibile per il paese dell'azienda",
    aumico_editable_account_placeholder_opening_value: "L'anno scorso",
    aumico_general_information_autofill_date_popup_autofill_btn: 'Autofill',
    aumico_editable_account_placeholder_number: 'Numero',
    aumico_general_information_autofill_date_popup_no_autofill_btn: 'Non automaticamente',
    aumico_annual_report_print_options_experimental_section_text:
        "Si prega di notare che queste opzioni di stampa funzionano solo se si sta stampando con il nuovo pulsante di stampa e non si riflettono nell'anteprima.",
    aumico_googleidp_invalid_code_error_message_title: 'Codice scaduto o non valido',
    aumico_invitation_expired_description: 'Sembra che il tuo codice di invito sia scaduto',
    aumico_notification_resend_email_failed_content: "Fallimento nell'invio di un emai",
    aumico_googleidp_invalid_code_error_message_content:
        "La tua e -mail di verifica è scaduta. Fai clic sul pulsante per ricredere l'email",
    aumico_notification_resend_email_success_content: 'Email ha inviato successo',
    aumico_notification_resend_email_success: 'Successo!',
    aumico_annual_report_print_options_notes: 'Appunti',
    aumico_reports_ar_templates_list_dialog_save_button: 'Salva modello di report annuale scelto',
    aumico_notification_resend_email_failure: 'Fallimento',

    aumico_reports_invitation_intro: 'Sei stato invitato da {InviTerName}',
    aumico_change_password_notification_success_title: 'Riuscito',
    aumico_reports_ar_templates_list_dialog_title: 'Modelli di report annuali',
    aumico_reports_invite_new_users_dialog_input_placeholder: 'Add Email Address',
    aumico_reports_invite_users_email_already_exist_error_message:
        "Le seguenti e-mail non sono state invitate perché esistono già e-mail in un'altra organizzazione",
    aumico_reports_invite_users_cannot_invite_same_organization_users:
        'Le seguenti e-mail non sono state invitate perché esistono già e-mail nella tua organizzazione',
    aumico_reports_organization_navigation_users: 'Utenti',
    aumico_reports_invite_users_success_message: 'Gli utenti sono stati invitati con successo',
    aumico_reports_invite_new_users_dialog_title: "Invita il nuovo utente dell'organizzazione",
    aumico_reports_invite_new_users_dialog_save_button: 'Invitare',
    aumico_reports_remove_users_success_message: 'Gli utenti sono stati rimossi con successo',
    aumico_reports_organization_settings_text_snippets_form_dialog_update_success_notification_description:
        'Snippet di testo aggiornato correttamente.',
    aumico_editable_account_placeholder_closing_value: 'Periodo di segnalazione',
    aumico_users_organization_change_organization_state_modal_confirm_no_action: 'Annulla',
    aumico_user_email_already_exists_error: "L'indirizzo e -mail è già in uso da un altro account",
    aumico_reports_no_annualreport_template_defined:
        'Non esiste un modello di report annuale definito per la forma giuridica selezionata e la base contabile e il paese specificato',
    aumico_reports_invite_users_wrong_data_error_message: 'Sono stati inviati dati sbagliati',
    aumico_general_information_autofill_date_popup_content: 'Vuoi automaticamente altre date?',
    aumico_users_organization_users_table_email_label: 'E-mail',
    aumico_users_organization_users_remove_cancel_button: 'Annulla',
    aumico_reports_print_page_data_not_available: 'Nessun dato disponibile',
    aumico_users_organization_users_table_phone_number_label: 'Numero di telefono',
    aumico_users_organization_users_table_role_label: 'Ruolo',
    aumico_reports_organization_settings_text_snippets_update_dialog_title: 'Aggiorna lo snippet di testo',
    aumico_invitation_expired_title: 'Codice di invito scaduto',
    aumico_users_organization_change_organization_state_modal_confirm_action: 'Confermare',
    aumico_users_organization_change_organization_state_action: 'Cambia lo stato',
    aumico_reports_annualreport_navigation_print_using_pdf_tron: 'Esportazione pdf',
    aumico_users_organization_users_remove_confirmation_button: 'Rimuovere',
    aumico_users_organization_users_remove_confirmation_text:
        "Gli utenti selezionati perderanno l'accesso alla piattaforma. Sei sicuro di volerli rimuoverli?",
    aumico_reports_invite_new_users_dialog_input_label: 'Aggiungi indirizzo e-mail',
    aumico_users_organization_users_table_remove_users: "Togliere dall'organizzazione",
    aumico_reports_invite_users_failure_okay_button_label: 'OK',
    aumico_reports_organization_settings_text_snippets_form_dialog_update_error_notification_description:
        'Impossibile aggiornare lo snippet di testo: errore del server interno',
    aumico_reports_remove_users_user_removing_self_error_message: 'Non puoi rimuoverti dagli utenti',
    aumico_users_organization_change_organization_state_modal_title: "Cambia lo stato dell'organizzazione",
    aumico_users_organization_users_table_name_label: 'Utente',
    aumico_admin_home_welcome_label: "En - Benvenuti nell'interfaccia amministrativa!",
    aumico_reports_share_annual_report_dialog_text:
        'Vuole condividere un rendiconto finanziario. Vuoi accettare la quota di questa organizzazione?',
    aumico_reports_share_annual_report_dialog_accept_button: 'Accettare',
    aumico_reports_share_annual_report_dialog_decline_button: 'Declino',
    aumico_annual_report_table_menu_option_per_row_secure_share: 'Condividere',
    aumico_reports_share_annual_report_dialog_title: 'Rapporto annuale di condivisione',
    aumico_reports_share_annual_report_dialog_content:
        'È possibile condividere il rapporto annuale con qualsiasi indirizzo email',
    aumico_reports_invitation_dialog_validation_message_enter_valid_email:
        'Si prega di inserire un indirizzo email valido',
    aumico_reports_share_annual_report_dialog_input_label: 'e-mail',
    aumico_reports_share_annual_report_dialog_save_button: 'Condividere',
    aumico_reports_annualreport_footer_share_annual_report: 'Condivisione sicura',
    aumico_reports_customer_attraction_dialog_title: 'Curioso di come puoi usare Aumico con la tua azienda?',
    aumico_reports_customer_attraction_dialog_button_text: 'Parla con noi',
    aumico_reports_customer_attraction_dialog_text_below_button: 'Oppure chiamaci: +12 345 67686',
    aumico_reports_customer_attraction_dialog_descriptive_text:
        'Abbiamo alcune ottime soluzioni per Pellesque SEM MI SAPIEN DIAM SEM PORTTITOR. Feugiat Ultrices molestali Varius adipiscente vitae amet tempot. Pharetra Vulputate Sagittis Bibendum.',
    aumico_reports_share_annual_report_confirmation_dialog_message:
        'Sei sicuro di voler condividere il tuo rapporto con:',
    aumico_reports_share_annual_report_confirmation_go_back_cancel_button: 'torna indietro',
    aumico_reports_share_annual_report_confirmation_dialog_save_button: 'Voi',
    aumico_reports_share_annual_report_success_notification_title: 'Condiviso con successo',
    aumico_reports_share_annual_report_success_notification_description:
        'Il tuo rapporto annuale ha condiviso con successo',
    aumico_annual_report_print_only: 'Stampa',
    aumico_annual_reports_export_excel: 'Export Excel',
    aumico_annual_report_export_to_word: 'Parola di esportazione',
    aumico_admin_navigation_translations: 'Traduzioni',
    aumico_admin_translations_expand_all: 'Espandi tutto',
    aumico_admin_translations_collapse_all: 'Crollare tutto',
    aumico_admin_translations_show_only_untranslated: 'Mostra solo non tradotto',
    aumico_admin_translations_save: 'Salva',
    aumico_admin_translations_notes_types: 'Tipi di note',
    aumico_admin_translations_notes_templates: 'Modelli di note',
    aumico_admin_translations_accounting_bases: 'Basi contabili',
    aumico_admin_translations_tasks: 'Tâches',
    aumico_admin_translations_checklists: 'Listes de contrôle',
    aumico_admin_translations_legal_forms: 'Forme legali',
    aumico_admin_translations_financial_line_items: 'Articoli di linea finanziaria',
    aumico_admin_translations_groups: 'Gruppi',
    aumico_admin_translations_name_column_header: 'Nome',
    aumico_admin_filter_translation_by_name: 'Filtro traduzioni',
    aumico_reports_error_dialog_bad_request: 'Brutta richiesta',
    aumico_reports_error_dialog_bad_request_first_and_last_names_required: 'Sono richiesti nomi e cognomi',
    aumico_reports_error_dialog_bad_request_phone_number_invalid:
        'Il numero di telefono deve essere nel formato corretto e non deve essere vuoto. Formato corretto: +<ontry_code> <phone_number>',
    aumico_annual_report_print_preview_fcp: 'Financial Closing Process',
    aumico_annual_report_print_preview_fas: 'Programma di immobilizzazioni',
    aumico_annual_report_fas_section_costs_title: 'Costi di acquisizione e produzione',
    aumico_annual_report_fas_section_depr_title: 'Deprezzazioni',
    aumico_annual_report_fas_section_valAppr_title: 'Apprezzamento del valore',
    aumico_annual_report_fas_select_reference: 'Seleziona riferimento',
    aumico_annual_report_fas_remove_group: 'Rimuovere il gruppo',
    aumico_annual_report_fas_add_group: 'Aggiungere gruppo',
    aumico_annual_report_fas_remove_column: 'Rimuovere la colonna',
    aumico_annual_report_fas_add_column: 'Aggiungi colonna',
    aumico_annual_report_fas_costs: 'Ahk',
    aumico_annual_report_fas_additions_column: 'Aggiunte',
    aumico_annual_report_fas_disposals_column: 'Cessione',
    aumico_annual_report_fas_transfers_column: 'Trasferimenti',
    aumico_annual_report_fas_depr_additions_column: 'Ammortamenti del periodo',
    aumico_annual_report_fas_depr_disposals_column: 'Cessione',
    aumico_annual_report_fas_depr_transfers_column: 'Trasferimenti',
    aumico_annual_report_fas_depr_cumulated: 'Deprezzazioni cumulate',
    aumico_annual_report_fas_valueAppreciation: 'Apprezzamento del valore',
    aumico_annual_report_fas_bookvalue_current: 'Valore contabile',
    aumico_annual_report_fas_bookvalue_previous: 'Valore contabile',
    aumico_annual_report_fas_depreciations: 'Deprezzazioni',
    aumico_annual_report_fas_direct_assigned_accounts: 'Account assegnati direttamente',
    aumico_annual_report_fas_file_upload_instruction_label: 'Carica il tuo file',
    aumico_annual_report_datev_error_detected:
        'Abbiamo scoperto almeno un errore! Si prega di correggere gli errori o utilizzare un altro file.',
    aumico_annual_report_datev_error_malformatted_file: 'File malformato',
    aumico_annual_report_datev_error_wrong_asset_data: 'Gli attivi non possono essere interpretati',
    aumico_annual_report_datev_error_wrong_liabilties_data: 'Le passività non possono essere interpretate',
    aumico_annual_report_datev_error_wrong_income_data: 'Il conto economico non può essere interpretato',
    aumico_annual_report_datev_error_root_node_empty: 'First element empty',
    aumico_annual_report_datev_master_file_detected:
        'We detected a DATEV master data import file. please click "save and continue" if you want to import the taxonomy and accounts.',
    aumico_annual_report_datev_account_file_detected:
        'We detected a DATEV account data import file. please click "save and continue" if you want to import the accounts.',
    aumico_report_fas_print_subtotal: 'totale parziale',
    aumico_report_fas_print_section_costs_title: 'Costi di acquisizione e produzione',
    aumico_report_fas_print_section_depr_title: 'Deprezzazioni cumulate',
    aumico_report_fas_print_section_valueApr_title: 'Rivalutazioni del periodo',
    aumico_report_fas_print_section_bookvalue_current: 'Valore contabile',
    aumico_report_fas_print_section_bookvalue_previous: 'Valore contabile',
    aumico_report_fas_print_costs_additions: 'Aggiunte di costi',
    aumico_report_fas_print_costs_disposals: 'Smaltimento dei costi',
    aumico_report_fas_print_costs_transfers: 'Trasferimenti di costi',
    aumico_report_fas_print_depreciations_additions: 'Ammortamenti del periodo',
    aumico_report_fas_print_depreciations_disposals: 'Disposto di deprezzazioni',
    aumico_report_fas_print_depreciations_transfers: 'Trasferimenti di deprezzazioni',
    aumico_report_fas_print_value_appreciation: 'Apprezzamento del valore',
    aumico_annual_report_table_label_share_date: 'Condiviso',
    aumico_annual_report_aop_profit_calculation_custom_account_name_placeholder: "Immettere la didascalia dell'account",
    aumico_annual_report_aop_profit_calculation_account_caption_form_field_label: 'Didascalia',
    aumico_users_edit_user_general_information_name_required: 'Il nome è obbligatorio',
    aumico_users_edit_user_general_information_surname_required: 'Il cognome è obbligatorio',
    aumico_users_edit_user_general_information_phone_invalid:
        'Il numero di telefono non è valido. Dovrebbe essere nel formato di +<country_code> <phone_number>',
    aumico_annual_report_print_options_show_balance_account_proof: 'Prova del conto del saldo',
    aumico_annual_report_print_options_show_income_account_proof: 'Prova del conto reddito',
    aumico_annual_report_print_preview_account_proof_for_balance: 'Prova del conto per il bilancio',
    aumico_annual_report_print_preview_account_proof_for_income: 'Prova del conto per il conto economico',
    aumico_templates_group_account_mapping_add_subtotal: 'Aggiungi subtotale',
    aumico_templates_group_account_mapping_add_subtotal_form_group_options_label: 'Seleziona Gruppo',
    aumico_templates_group_account_mapping_add_subtotal_form_group_options: 'Gruppi',
    aumico_templates_group_account_mapping_add_fli: 'Aggiungi fli',
    aumico_templates_fli_form_cash_flow_types: 'Tipo di flusso di cassa',
    aumico_templates_fli_form_cash_flow_options_label: 'Seleziona Tipo di flusso di cassa',
    aumico_templates_fli_form_fli_types: 'Tipo di articolo della linea finanziaria',
    aumico_templates_fli_form_fli_type_options_label: 'Seleziona il tipo FLI',
    aumico_templates_fli_form_groups: 'Gruppi',
    aumico_templates_fli_form_group_options_label: 'Seleziona Gruppo',
    aumico_templates_group_account_mapping_cash_flow_type_none: 'Nessuno',
    aumico_templates_group_account_mapping_cash_flow_type_operations: 'Operazioni',
    aumico_templates_group_account_mapping_cash_flow_type_networking_capital: 'Capitale di networking',
    aumico_templates_group_account_mapping_cash_flow_type_investing: 'Investimento',
    aumico_templates_group_account_mapping_cash_flow_type_financing: 'Finanziamento',
    aumico_templates_group_account_mapping_fli_type_assets: 'Risorse',
    aumico_templates_group_account_mapping_fli_type_liabilities: 'Passività',
    aumico_templates_group_account_mapping_fli_type_income: 'Reddito',
    aumico_templates_group_account_mapping_fli_type_expenses: 'Spese',
    aumico_organization_settings_print_closing_value_totals_in_separate_columns:
        'Stampare i totali del valore di chiusura in colonne separate',
    aumico_organization_settings_display_assets_and_liabilities_in_same_page:
        'Visualizza risorse e passività nella stessa pagina',
    aumico_organization_settings_print_success_notification_title: 'Successo',
    aumico_organization_settings_print_success_notification_description:
        "Impostazioni dell'organizzazione salvate con successo",
    aumico_templates_group_account_mapping_add_more_items_of_that_item_checkbox: "Crea come parte di quell'età",
    aumico_templates_group_account_mapping_of_that_item_text: "{di quell'elemento}",
    aumico_annual_report_fas_accounts_select_reference_placeholder: 'Seleziona riferimento',
    aumico_users_organization_upload_pdf_template_action: 'Carica il modello PDF',
    aumico_users_organization_reset_to_default_template_action: 'Reset to default template -it',
    aumico_users_organization_reset_to_default_template_action_success: 'Reset to default template succeeded -it',
    aumico_users_organization_reset_to_default_template_action_failed: 'Reset to default template failed -it',
    aumico_users_organization_upload_pdf_template_failure_notification_description:
        'Impossibile caricare il modello di reporting',
    aumico_users_organization_upload_pdf_template_success_notification_description:
        'Modello di reporting caricato correttamente',
    aumico_reports_print_page_fixed_assets_schedule_invalid_warning:
        'La pianificazione delle attività fisse non è valida rispetto ai dati di mappatura',
    aumico_reports_referral_invite_notification_failure_title: 'Invito di riferimento',
    aumico_reports_referral_invite_notification_failure_description: 'Impossibile inviare e -mail di riferimento',
    aumico_reports_referral_invite_notification_success_title: 'Invito di riferimento',
    aumico_reports_referral_invite_notification_success_description: 'E -mail di riferimento inviata con successo',
    aumico_annual_report_complementary_reports_autofill_button: "Autofill dell'anno precedente",
    aumico_annual_report_complementary_reports_autofill_dialog_description:
        'Sei sicuro di voler sovrascrivere i tuoi rapporti complementari con quelli precedenti?',
    aumico_annual_report_complementary_reports_autofill_dialog_yes: 'SÌ',
    aumico_annual_report_complementary_reports_autofill_dialoh_cancel: 'Annulla',
    aumico_admin_ar_template_navigation_settings: 'Impostazioni',
    aumico_admin_ar_template_settings_title: 'Definire le impostazioni',
    aumico_admin_ar_template_settings_uncovered_shortfall: 'Equità ha scoperto la carenza',
    aumico_organization_settings_uncoveredShortfall: 'Scontimento di carenza',
    aumico_templates_account_mapping_form_apply_uncovered_shortfall: 'Applica carenza scoperta',
    aumico_templates_switch_accounts_dialog_title: "Definire l'account switch",
    aumico_templates_switch_accounts_dialog_initial_situation: 'Stato iniziale',
    aumico_templates_switch_accounts_dialog_preview_output: 'Output di anteprima',
    aumico_templates_switch_accounts_dialog_drop_account: 'Dove dovremmo abbandonare il nuovo account?',
    aumico_templates_switch_accounts_dialog_selection_label: 'Seleziona fli o subfli',
    aumico_templates_switch_accounts_dialog_selection_placeholder: 'Seleziona FLI o Subfli',
    aumico_templates_switch_accounts_dialog_error_mandatory_selection: 'È necessario selezionare un FLI o SUBFLI',
    aumico_reports_share_not_found: 'La quota deve essere stata ritirata',
    aumico_organization_settings_show_shareholder_info: 'Mostra le informazioni sugli azionisti',
    aumico_annual_report_print_options_label_show_shareholderInformation: 'Mostra informazioni sugli azionisti',
    aumico_templates_fli_form_error_name_already_exists: 'Il nome fli esiste già',
    aumico_templates_mapping_engine_equity_group_not_defined_title: 'Errore di carenza scoperto',
    aumico_templates_mapping_engine_equity_group_not_defined_description:
        'Il gruppo azionario non è definito nella tassonomia del saldo',
    aumico_templates_account_mapping_form_uncovered_shortfall_assets_fli_caption: 'Scontimento di carenza',
    aumico_templates_account_mapping_form_uncovered_shortfall_equity_fli_caption: 'Scontimento di carenza',
    aumico_templates_account_mapping_form_uncovered_shortfall_assets_account_name: 'Conto di deficit scoperto',
    aumico_templates_account_mapping_form_uncovered_shortfall_equity_account_name: 'Conto di deficit scoperto',
    aumico_templates_form_equity_group: 'Seleziona Equity Group',
    aumico_templates_form_uncovered_shortfall_assets_fli: 'Seleziona le attività di deficit scoperte FLI',
    aumico_templates_form_uncovered_shortfall_liabilities_fli: 'Selezionare le passività di deficit scoperte fli',
    aumico_templates_form_add_hidden_group: 'Aggiungi gruppo nascosto',
    aumico_templates_form_create_sub_fli_or_of_that_item: "Crea sub fli o di quell'elemento",
    aumico_annual_report_import_indicate_shareholder_column: 'Specificare la colonna degli azionisti',
    aumico_admin_ar_template_settings_show_shareholder_information: 'Mostra le informazioni sugli azionisti',
    aumico_companies_form_label_tax_domicile: 'Domicile fiscale',
    aumico_companies_form_label_GICSCode: 'Industria',
    aumico_core_search: 'Ricerca',
    aumico_core_search_not_found: 'Non trovato',
    aumico_reports_annualreport_navigation_balance_account_proof: 'Prova del conto del saldo',
    aumico_reports_annualreport_navigation_income_account_proof: 'Prova del conto reddito',
    aumico_templates_mapping_remove_group_warning_dialog_text:
        "La rimozione di questo gruppo porterà a ripristinare qualsiasi altro passaggio che utilizza questo gruppo o qualsiasi elemento all'interno di questo gruppo. Sei sicuro di volerlo rimuoverlo?",
    aumico_templates_mapping_remove_item_warning_dialog_cancel_button: 'Annulla',
    aumico_templates_mapping_remove_item_warning_dialog_remove_button: 'Rimuovere',
    aumico_templates_mapping_remove_item_warning_dialog_text:
        'La rimozione di questo elemento porterà a ripristinare qualsiasi altro passaggio che lo utilizza. Sei sicuro di volerlo rimuoverlo?',
    aumico_reports_accept_policy_dialog_title: 'Aggiorna GT',
    aumico_reports_accept_policy_dialog_first_paragraph: 'Il 1 settembre',
    aumico_reports_accept_policy_dialog_first_paragraph_the: 'IL',
    aumico_reports_accept_policy_dialog_first_paragraph_as_well_as_those: 'così come il',
    aumico_reports_accept_policy_dialog_first_paragraph_adjusted: 'vuoto',
    aumico_reports_accept_policy_dialog_second_paragraph:
        'Le versioni riviste sono ora pienamente conformi alla nuova protezione dei dati svizzeri LA',
    aumico_reports_accept_policy_dialog_third_paragraph: 'Si prega di accettare la nostra nuova GT',
    aumico_reports_accept_policy_dialog_privacy_policy: 'Regolamento sulla protezione dei dati',
    aumico_reports_accept_policy_dialog_terms_and_conditions: 'Termini e condizioni generali (GTC',
    aumico_reports_accept_policy_dialog_agreement_on_data_processing: 'Accordo di elaborazione dei dati (DPA)',
    aumico_reports_accept_policy_to_continue_dialog_first_paragraph:
        'Sei sicuro di non voler continuare a usare Aumico?',
    aumico_reports_accept_policy_to_continue_dialog_second_paragraph: 'Se non si accetta il nuovo termine',
    aumico_reports_accept_policy_to_continue_dialog_third_paragraph: 'Se hai qualche domanda',
    aumico_reports_accept_policy_to_continue_dialog_third_paragraph_contact_email: 'privacy@aumico.ch',
    aumico_reports_accept_policy_to_continue_dialog_i_agree_button: "Sono d'accordo",
    aumico_reports_accept_policy_to_continue_dialog_decline_policy_button: 'Cancella il mio account',
    aumico_users_registration_privacy_policy: 'Regolamento sulla protezione dei dati.',
    aumico_users_registration_prices: 'Prezzo',
    aumico_users_registration_terms_and_conditions: 'Termini e condizioni generali',
    aumico_users_registration_text_between_links: "di Aumico e io siamo d'accordo con loro. Ulteriormente",
    aumico_users_registration_text_after_links: 'vuoto',
    aumico_users_registration_agreement_on_data_processing: 'Accordo di elaborazione dei dati',
    aumico_annual_report_account_proof_display_account_number_column_header: 'Numero',
    aumico_annual_report_account_proof_display_account_name_column_header: 'Nome',
    aumico_annual_report_display_current_date_column_header: 'Anno fiscale',
    aumico_annual_report_display_previous_date_column_header: 'Anno Precedente',
    aumico_annual_report_print_options_show_group_headers: 'Mostra intestazioni del gruppo',
    aumico_annual_report_print_options_show_group_totals: 'Mostra totali del gruppo',
    aumico_templates_template_account_mapping_form_show_details: 'Mostra dettagli',
    aumico_templates_template_account_mapping_form_hide_details: 'Nascondere dettagli',
    aumico_templates_group_account_mapping_create_group: 'Crea un gruppo',
    aumico_templates_group_account_mapping_create_group_form_fli_options_label: 'Seleziona flis',
    aumico_templates_group_account_mapping_create_group_form_fli_options: 'Seleziona flis',
    aumico_templates_group_account_mapping_create_group_form_name_label: 'Nome del gruppo',
    aumico_templates_group_account_mapping_create_group_form_name: 'Nome del gruppo',
    aumico_templates_group_account_mapping_create_group_form_name_required_error: 'È richiesto il nome del gruppo',
    aumico_templates_group_account_mapping_create_group_form_name_already_exists_error: 'Il nome del gruppo esiste già',
    aumico_templates_group_account_mapping_create_group_form_total_name_required_error:
        'È richiesto il nome totale del gruppo',
    aumico_templates_group_account_mapping_create_group_form_total_name_label: 'Nome totale del gruppo',
    aumico_templates_group_account_mapping_create_group_form_total_name: 'Nome totale del gruppo',
    aumico_templates_group_account_mapping_create_group_form_button: 'Salva',
    aumico_templates_group_account_mapping_there_is_an_empty_group_warning:
        'Esistono uno o più gruppi vuoti che non contengono elementi di linea finanziaria',
    aumico_annual_report_print_options_title_and_signature: 'Titolo e firma',
    aumico_reports_equality_check_print_preview_hide_details: 'Nascondere dettagli',
    aumico_reports_equality_check_print_preview_show_details: 'Mostra dettagli',
    aumico_templates_group_account_mapping_menu_edit: 'Modificare',
    aumico_templates_group_account_mapping_switch_account: 'Cambia account',
    aumico_templates_group_account_mapping_add_account: 'Aggiungi nuovo account',
    aumico_templates_group_account_mapping_add_sub_total: 'Add subtotal -it-ch',
    aumico_templates_group_account_mapping_add_group: 'Groupe -it-ch',
    aumico_templates_group_account_mapping_add_empty_space_above: 'Inserire la spaziatura sopra',
    aumico_templates_group_account_mapping_add_empty_space_below: 'Inserire la spaziatura di seguito',
    aumico_templates_group_account_mapping_add_header_above: "Inserire l'intestazione sopra",
    aumico_templates_group_account_mapping_add_header_below: "Inserire l'intestazione sotto",
    aumico_admin_ar_template_general_information_locales: 'Località',
    aumico_annual_report_print_options_show_fas: 'Mostra Fas',
    aumico_templates_account_mapping_form_map_income_total_to_annual_surplus:
        'Trasferisci il totale delle entrate al surplus annuale',
    aumico_annual_report_special_flis_annual_surplus_fli_label: 'Surplus Annuale',
    aumico_annual_report_general_information_update_company_btn_text: 'Aggiorna Informazioni Azienda',
    aumico_reports_general_info_company_update_confirm: 'Aggiorna Informazioni Azienda',
    aumico_reports_general_info_company_update_cancel: 'Mantieni Vecchi Dati',
    aumico_reports_general_info_company_update_confirmation_text:
        'Vuoi aggiornare le informazioni aziendali nel rapporto?',
    aumico_reports_general_info_update_company_success_notification_title: 'Aggiornamento Riuscito',
    aumico_reports_general_info_update_company_success_notification_description:
        'Le informazioni aziendali sono state aggiornate con successo',
    aumico_reports_company_legal_form_update_confirmation_text:
        'Vuoi aggiornare le informazioni aziendali? Un *cambio nella forma giuridica* avrà un impatto sulla struttura del bilancio e del conto economico',
    aumico_templates_group_account_mapping_duplicate_account: 'Duplica Conto',
    aumico_templates_group_account_mapping_duplicate_account_form_of_that_items_options: "Seleziona di quell'elemento",
    aumico_templates_group_account_mapping_duplicate_account_form_of_that_items_options_label:
        "Seleziona di quell'elemento",
    aumico_templates_group_account_mapping_duplicate_account_form_button: 'Duplica conto',
    aumico_general_information_no_template_for_your_combination: 'Nessun modello per la tua combinazione',
    aumico_general_information_no_template_for_your_combination_content_1:
        'Spiacenti, non abbiamo trovato un modello per la tua azienda e la combinazione della forma giuridica con base contabile. Controlla la forma giuridica e il paese della società.',
    aumico_general_information_no_template_for_your_combination_content_2:
        'Puoi anche contattarci in modo che possiamo aiutarti. Di solito possiamo risolvere il tuo problema in un giorno lavorativo.',
    aumico_notes_input_options_compare_years: 'Confronta anni',
    aumico_notes_input_options_text: 'Testo',
    aumico_notes_input_options_data_type: 'Seleziona tipo di valori',
    aumico_notes_input_options_number_of_decimal_places: 'Numero di cifre dopo la virgola',
    aumico_notes_input_options_use_as_parameter: 'Disponibile come parametro del rapporto',
    aumico_notes_input_options_parameter_name: 'Inserisci Nome Parametro',
    aumico_notes_input_options_data_type_text: 'Testo',
    aumico_notes_input_options_data_type_number: 'Numero',
    aumico_notes_input_options_data_type_currency: 'Valuta',
    aumico_notes_super_table_options_title: 'Titolo',
    aumico_notes_super_table_options_col_type: 'Tipo di Colonna',
    aumico_notes_super_table_col_title: 'Titolo Colonna',
    aumico_notes_super_table_options_segment_type: 'Tipo di Segmento',
    aumico_notes_super_table_segment_title: 'Titolo Segmento',
    aumico_notes_super_table_options_col_type_current_year: 'Anno corrente',
    aumico_notes_super_table_options_col_type_previous_year: 'Anno Precedente',
    aumico_notes_super_table_options_col_type_text: 'Testo',
    aumico_notes_super_table_options_col_type_number: 'Numero',
    aumico_notes_super_table_options_segment_type_basic: 'Segmento Base',
    aumico_notes_super_table_options_segment_type_total: 'Segmento Totale',
    aumico_dialog_error: 'Error',
    aumico_dialog_error_too_many_requests:
        'Oops! It looks like too many requests were made at once. Please wait a moment and reload the page. We appreciate your patience.',
    aumico_confirmation_modal_cancel_button: 'Cancel',
    aumico_confirmation_modal_delete_button: 'Delete',
    aumico_confirmation_modal_notes_deletion:
        'Do you want to delete the note? It will be not possible to restore the information after deletion.',
    aumico_confirmation_modal_notes_component_deletion:
        'Do you want to delete this note component? It will be not possible to restore the information after deletion. de',
    aumico_edit_notes_toggle: 'Edit notes mode',
    aumico_add_notes_button: 'Add Notes',
    aumico_new_note_placeholder: 'New Notes',
    aumico_add_notes_component_button: 'Add another component',
    aumico_notes_add_all_text: 'Add all text to the note',
    aumico_reports_main_navigation_company_valuation: 'Valutazione Aziendale',
    aumico_reports_company_valuation_navigation_valuation_report: 'Rapporto di Valutazione',
    aumico_reports_company_valuation_report_title: 'Creiamo una valutazione aziendale per i tuoi clienti',
    aumico_reports_company_valuation_report_descriptive_text_1: 'Basato sui bilanci annuali passati dei tuoi clienti.',
    aumico_reports_company_valuation_report_descriptive_text_2:
        'Ottieni un rapporto di valutazione professionale e completo entro due giorni lavorativi',
    aumico_reports_company_valuation_report_descriptive_text_3:
        'Ricevi un rapporto di valutazione di 5 pagine nella tua casella di posta, per CHF 200 per rapporto (IVA esclusa).',
    aumico_reports_company_valuation_report_download_button_text: 'Scarica rapporto di esempio',
    aumico_reports_company_valuation_report_order_button_text: 'Ordina rapporto di valutazione',
    aumico_reports_company_valuation_dialog_title: 'Ordina un rapporto sul valore fiscale',
    aumico_reports_company_valuation_dialog_text:
        "Il calcolo fiscale costa CHF 49 per rapporto (IVA esclusa). Il rapporto viene ricevuto entro due giorni lavorativi. Effettuando l'ordine, accetti che aumico possa elaborare i dati finanziari del cliente allo scopo di creare il rapporto di valutazione.",
    aumico_reports_company_valuation_dialog_place_order_button_text: 'Effettua Ordine',
    aumico_reports_company_valuation_confirmation_dialog_content_title: 'Conferma Ordine',
    aumico_reports_company_valuation_confirmation_dialog_text:
        'Abbiamo ricevuto il tuo ordine. Riceverai il/i rapporto/i entro due giorni lavorativi.',
    aumico_reports_company_valuation_confirmation_dialog_button_text: 'Fatto',
    aumico_reports_valuation_report_announcement_dialog_title: 'Scopri il Rapporto sul Valore Fiscale',
    aumico_reports_valuation_report_announcement_dialog_content_1:
        'Crea un calcolo del valore fiscale per i tuoi clienti utilizzando il metodo del professionista.',
    aumico_reports_valuation_report_announcement_dialog_content_2:
        'Seleziona i clienti per i quali desideri creare il rapporto. Conferma la tua selezione e ricevi i calcoli del valore fiscale entro 2 giorni lavorativi.',
    aumico_reports_valuation_report_announcement_dialog_content_3:
        'Offri ai tuoi clienti un valore aggiunto e invia loro un calcolo del valore fiscale con ogni bilancio annuale.',
    aumico_reports_valuation_report_announcement_dialog_button_text: 'Provalo',
    aumico_notes_super_table_options_col_belonging_year_current: 'Anno Corrente',
    aumico_notes_super_table_options_col_belonging_year_previous: 'Anno Precedente',
    aumico_notes_super_table_options_col_belonging_year: 'Anno di Appartenenza',
    aumico_notes_super_table_segment_child_columns: 'Colonne Figlio',
    aumico_notes_super_table_options_define_columns: 'Definisci Colonne',
    aumico_notes_super_table_options_define_segments: 'Definisci Segmenti',
    aumico_notes_super_table_add_row: 'Aggiungi Riga',
    aumico_notes_super_table_add_row_menu_option_select_from_balance: 'Seleziona dal Bilancio',
    aumico_notes_super_table_add_row_menu_option_select_from_income: 'Seleziona dal Reddito',
    aumico_notes_super_table_add_row_menu_option_add_calculation: 'Aggiungi Calcolo',
    aumico_notes_super_table_add_row_menu_option_add_title_row: 'Aggiungi Riga Titolo',
    aumico_notes_super_table_add_row_menu_option_add_space_row: 'Aggiungi Riga Spazio',
    aumico_notes_super_table_add_row_menu_option_add_free_text_row: 'Aggiungi Riga Testo Libero',
    aumico_notes_super_table_add_row_menu_option_create_segments: 'Crea Segmenti',
    aumico_notes_super_table_current_value_placeholder: 'Inserisci Valore Anno Corrente',
    aumico_notes_super_table_previous_value_placeholder: 'Inserisci Valore Anno Precedente',
    aumico_notes_super_table_numeric_value_placeholder: 'Inserisci Numero',
    aumico_notes_super_table_text_value_placeholder: 'Inserisci Testo',
    aumico_notes_super_table_data_selection_title: 'Aggiungi Riga',
    aumico_notes_super_table_data_selection_label: 'Seleziona uno o più elementi per una nuova riga:',
    aumico_notes_super_table_create_segment_title: 'Crea Segmento',
    aumico_notes_super_table_enter_here: 'Inserisci Titolo Segmento',
    aumico_notes_super_table_create_segment_select_columns_placeholder: 'Seleziona Colonne',
    aumico_notes_super_table_create_segment_save_button: 'Aggiungi Segmento',
    aumico_annual_report_main_navigation_new: 'NUOVO',
    aumico_notes_movement_schedule: 'Movement Schedule it',
    aumico_notes_fli_table: 'FLi table it',
    aumico_notes_super_table_add_calculation_row_title: 'Aggiungi Riga di Calcolo',
    aumico_notes_super_table_add_calculation_column_title: 'Aggiungi Colonna di Calcolo',
    aumico_notes_super_table_add_caclulation_select_calculation_type: 'Seleziona il tipo di calcolo',
    aumico_notes_super_table_add_calculation_function_summation: 'Somma degli Elementi',
    aumico_notes_super_table_add_calculation_function_ratio: 'Rapporto',
    aumico_notes_super_table_add_calculation_function_subtraction: 'Sottrazione',
    aumico_notes_super_table_add_calculation_function_multiplication: 'Moltiplicazione',
    aumico_notes_super_table_add_calculation_title_placeholder: 'Inserisci titolo del calcolo',
    aumico_notes_super_table_add_calculation_button: 'Aggiungi Calcolo',
    aumico_notes_super_table_add_calculation_select_relation_item_placeholder: 'In Relazione a',
    aumico_notes_super_table_add_calculation_select_column_placeholder: 'Seleziona colonne',
    aumico_notes_super_table_add_calculation_select_column_placeholder_SUM:
        'Seleziona le colonne che devono essere sommate',
    aumico_notes_super_table_add_calculation_select_column_placeholder_MUL:
        'Seleziona le colonne che devono essere moltiplicate',
    aumico_notes_super_table_add_calculation_select_column_placeholder_RATIO:
        'Seleziona le colonne per le quali deve essere calcolato il rapporto',
    aumico_notes_super_table_add_calculation_select_rows_placeholder_SUM:
        'Seleziona le righe che devono essere sommate',
    aumico_notes_super_table_add_calculation_select_rows_placeholder_MUL:
        'Seleziona le righe che devono essere moltiplicate',
    aumico_notes_super_table_add_calculation_select_rows_placeholder_RATIO:
        'Seleziona le righe per le quali deve essere calcolato il rapporto',
    aumico_notes_super_table_add_calculation_minuend_placeholder: "Seleziona l'elemento X",
    aumico_notes_super_table_add_calculation_subtrahend_placeholder: "Seleziona l'elemento Y",
    aumico_notes_super_table_add_column: 'Aggiungi Colonna',
    aumico_notes_super_table_add_column_menu_option_add_calculation: 'Aggiungi Colonna di Calcolo',
    aumico_notes_super_table_add_column_menu_option_add_column: 'Aggiungi Colonna Libera',
    aumico_notes_super_table_add_free_column_title_placeholder: 'Inserisci Titolo Colonna',
    aumico_notes_super_table_add_free_column_col_type: 'Formato dei valori della colonna',
    aumico_notes_super_table_add_free_column_belonging_year: "La colonna appartiene all'anno",
    aumico_notes_super_table_add_free_column_save_button: 'Aggiungi Colonna',
    aumico_notes_super_table_select_income_or_balance: 'Seleziona da dove provengono i dati:',
    aumico_reports_company_valuation_dialog_select_company: 'Seleziona Azienda',
    aumico_add_to_notes_button: 'Add to note',
    aumico_add_to_notes_dialog_title: 'Notes components library',
    aumico_notes_extra_settings: 'Extra settings it',
    aumico_notes_extra_settings_title: 'Enter title (optional)',
    aumico_notes_select_option_description: 'Description (optional) - it',
    aumico_notes_select_options: 'Options -it',
    aumico_notes_extra_settings_add_option: 'Add option',
    aumico_notes_extra_settings_options: 'Dropdown values',
    aumico_notes_extra_settings_option: 'Option',
    aumico_core_ck_editor_add_custom_style: 'Aggiungi stile personalizzato',
    aumico_core_ck_editor_make_row_total: 'Rendi totale riga',
    aumico_core_ck_editor_make_column_total: 'Rendi totale colonna',
    aumico_core_ck_editor_make_column_highlight: 'Evidenzia colonna',
    aumico_core_ck_editor_make_column_number_column: 'Rendi colonna numerica',
    aumico_core_ck_editor_remove_row_style: 'Rimuovi stile riga',
    aumico_core_ck_editor_remove_column_style: 'Rimuovi stile colonna',
    aumico_core_ck_editor_align_table: 'Allinea tabella',
    aumico_core_ck_editor_align_table_left: 'Allinea tabella a sinistra',
    aumico_core_ck_editor_align_table_right: 'Allinea tabella a destra',
    aumico_core_ck_editor_align_table_center: 'Allinea tabella al centro',
    aumico_core_ck_editor_align_cell_horizontal: 'Allinea cella orizzontalmente',
    aumico_core_ck_editor_align_cell_horizontal_left: 'Allinea cella a sinistra',
    aumico_core_ck_editor_align_cell_horizontal_right: 'Allinea cella a destra',
    aumico_core_ck_editor_align_cell_vertical: 'Allinea cella verticalmente',
    aumico_core_ck_editor_align_cell_vertical_top: 'Allinea cella in alto',
    aumico_core_ck_editor_align_cell_vertical_bottom: 'Allinea cella in basso',
    aumico_core_ck_editor_table_column: 'Colonna',
    aumico_core_ck_editor_table_column_header_column: 'Colonna intestazione',
    aumico_core_ck_editor_table_column_insert_column_left: 'Inserisci colonna a sinistra',
    aumico_core_ck_editor_table_column_insert_column_right: 'Inserisci colonna a destra',
    aumico_core_ck_editor_table_column_delete_column: 'Elimina colonna',
    aumico_core_ck_editor_table_column_select_column: 'Seleziona colonna',
    aumico_core_ck_editor_table_row: 'Riga',
    aumico_core_ck_editor_table_row_header_row: 'Riga intestazione',
    aumico_core_ck_editor_table_row_insert_row_above: 'Inserisci riga sopra',
    aumico_core_ck_editor_table_row_insert_row_below: 'Inserisci riga sotto',
    aumico_core_ck_editor_table_row_delete_row: 'Elimina riga',
    aumico_core_ck_editor_table_row_select_row: 'Seleziona riga',
    aumico_core_ck_editor_table_merge_cells: 'Unisci celle',
    aumico_core_ck_editor_table_merge_cells_up: 'Unisci celle in alto',
    aumico_core_ck_editor_table_merge_cells_down: 'Unisci celle in basso',
    aumico_core_ck_editor_table_merge_cells_right: 'Unisci celle a destra',
    aumico_core_ck_editor_table_merge_cells_left: 'Unisci celle a sinistra',
    aumico_core_ck_editor_table_split_cell_vertically: 'Dividi cella verticalmente',
    aumico_core_ck_editor_table_split_cell_horizontally: 'Dividi cella orizzontalmente',
    aumico_core_ck_editor_enforce_page_break: 'Forza interruzione di pagina',
    aumico_notes_components_list_reset_values_from_mapping: 'Ripristina valori dalla mappatura',
    aumico_notes_components_list_no_content: 'Clicca modifica per aggiungere contenuto',
    aumico_notes_super_table: 'Super tabella',
    aumico_notes_select_options_min_options: 'Seleziona almeno due opzioni',
    aumico_notes_super_table_options_transpose: 'Trasponi 90',
    aumico_notes_super_table_options_col_belonging_year_none: 'Nessuno',
    aumico_notes_super_table_add_free_column_edit_button: 'Modifica colonna',
    aumico_notes_super_table_reset_form_values_from_mapping_confirmation_dialog_ok: 'Sì',
    aumico_notes_super_table_reset_form_values_from_mapping_confirmation_dialog_cancel: 'Annulla',
    aumico_notes_super_table_reset_form_values_from_mapping_confirmation_dialog_description:
        'Sei sicuro di voler ripristinare i valori dalla fase di mappatura',
    aumico_notes_super_table_turning_on_transpose_toggle_not_allowed:
        "Il numero massimo di righe consentite per la vista trasposta è di 7 righe. Impossibile attivare l'interruttore di trasposizione.",
    aumico_notes_super_table_turning_off_transpose_toggle_not_allowed:
        "Il numero massimo di colonne consentite per la vista non trasposta è di 7 colonne. Impossibile disattivare l'interruttore di trasposizione.",
    aumico_notes_super_table_remove_confirmation_dialog_ok: 'Okay',
    aumico_notes_super_table_remove_confirmation_dialog_cancel: 'Annulla',
    aumico_notes_super_table_remove_confirmation_dialog_description: 'Stai per rimuovere una colonna. Vuoi continuare?',
    aumico_print_preview_rename_section_title_dialog_title: 'Rename Section Title -it',
    aumico_print_preview_rename_section_title_dialog_input_field_placeholder: 'Enter Section Title -it',
    aumico_print_preview_rename_section_title_dialog_input_field_title: 'Section Title -it',
    aumico_reports_main_navigation_company_profile: 'Company Profile - it',
    aumico_reports_main_navigation_person_list: 'Persone',
    aumico_reports_export_all_persons_file_name: 'tutte le persone',
    aumico_reports_main_navigation_person_new: 'Nuova persona',
    aumico_reports_main_navigation_person_profile: 'Profilo',
    aumico_users_registration_password_lower_case_criteria_message: 'atleast one lower case character - it',
    aumico_users_registration_password_upper_case_criteria_message: 'atleast one upper case character - it',
    aumico_users_registration_password_digits_criteria_message: 'atleast one digit - it',
    aumico_users_registration_password_special_char_criteria_message: 'atleast one special character - it',
    aumico_users_registration_password_min_chars_criteria_message: 'atleast 8 characters - it',
    aumico_admin_ar_template_general_information_caption: 'Description - it',
    aumico_report_copy_success_notification_description: 'Copied to clipboard - it',
    aumico_report_save_success_notification_description: 'Saved Successfully - it',
    aumico_report_save_failure_notification_description: 'Save Failed - it',
    aumico_add_referencing_in_balance_and_income_btn: 'Add referencing in Balance sheet and Income-it',
    aumico_add_numbering_toggle: 'Add numbering',
    aumico_view_notes_components_in_edit_mode_toggle: 'View Components in Edit Mode -it',
    aumico_annual_report_save_error_not_loaded: 'I dati del report non sono ancora stati caricati. Attendere un momento e riprovare.',
    aumico_notes_title: 'Title',
    aumico_notes_referencing_title: 'Add referncing in Balance sheet and Income',
    aumico_notes_referencing_sub_title: 'You can select one ore more FLis and SubFlis:',
    aumico_notes_referencing_add_referencing: 'Add referencing',
    aumico_admin_translations_ar_templates: 'Annual Report Templates - it',
    aumico_annual_report_fas_unmapped_uploaded_accounts_warning: 'The following accounts uploaded are not mapped - it',
    aumico_annual_report_fas_invalid_file_format_warning_text: 'The uploaded sheet has a wrong format - it',
    aumico_admin_menu_item_change_fcp: 'Change Fcp subscription it',
    aumico_admin_menu_item_deactivate_fcp: 'Deactivate closing process it',
    aumico_view_notes_components_highlight_todos_toggle: 'Highlight Todos - it',
    aumico_annual_report_complementary_reports_show_in_toc_toggle: 'Show report in table of contents -it',
    aumico_annual_report_complementary_reports_at_the_start: 'At the start -it',
    aumico_annual_report_complementary_reports_at_the_end: 'At the end -it',
    aumico_annual_report_complementary_reports_as_appendix: 'As appendix -it',
    aumico_annual_report_print_preview_appendix_section_title: 'Appendix -it',
    aumico_copy_notes_structure_from_another_annual_report: 'Copy notes structure from another annual report -it',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_description:
        'This will replace all the notes created and cannot be undone. Are you sure you want to continue ? -it',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_yes_button: 'Yes -it',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_yes_inclusive_data_button:
        'Yes, inclusive data -it',
    aumico_notes_copy_notes_structure_from_another_annual_report_confirmation_dialog_cancel_button: 'Cancel -it',
    aumico_notes_copy_notes_structure_fetch_error: 'Impossibile recuperare le note da questo rapporto.',
    aumico_users_organization_upload_or_pdf_template_action: 'Upload OR Pdf template -it',
    aumico_users_organization_upload_hgb_pdf_template_action: 'Upload HGB Pdf template -it',
    aumico_users_organization_reset_to_default_or_template_action: 'Reset or template to default -it',
    aumico_users_organization_reset_to_default_hgb_template_action: 'Reset hgb template to default -it',
    aumico_reports_organization_settings_navigation_checklists: 'Checklists-it',
    aumico_admin_change_fcpstate_select_fcp_status: 'FCP Status',
    aumico_admin_change_fcp_statefcp_status: 'Change Status',
    aumico_admin_change_fcpstate_cancel: 'Cancel',
    aumico_admin_change_fcpstate_confirm: 'Confirm',
    aumico_reports_main_navigation_closing_process_enabling: 'Closing Process',

    aumico_reports_closing_process_request_approval: 'Sign up for Beta',
    aumico_reports_closing_process_waiting_for_approval: 'Beta Approval in Progress',
    aumico_reports_closing_process_cancel: 'Cancel Subscription',

    aumico_reports_closing_process_benefits: 'Benefits .....',
    aumico_reports_closing_process_pricing: 'Pricing .....',
    aumico_reports_closing_process_terms_and_conditions: 'Terms and Conditions.....',
    aumico_confirmation_modal_activate_button: 'Activate',
    aumico_confirmation_modal_cancel_subscription_button: 'Cancel Subscription',
    aumico_confirmation_modal_activate_subscription_description:
        'By clicking "Activate", you will activate a 31-day free trial. During this period, you will have full access to closing process feature. Trial will be converted to automatic renewal once the trial ends!',
    aumico_reports_closing_process_deactivate: 'Deactivate',
    aumico_reports_cant_activate_fcp:
        'You can not activate FCP trial as you have already subscribed to, for annual subscription contact aumico sales sales@aumico.ch',
    aumico_reports_cant_activate_fcp_ok: 'Ok',
    aumico_reports_create_new_checklist: 'Créer une nouvelle liste de contrôle',
    aumico_reports_checklist_title_label: 'Title',
    aumico_reports_checklist_title_placeholder: 'Enter checklist title...',
    aumico_reports_select_flis_label: 'Select FLIs',
    aumico_reports_enter_task_placeholder: 'enter task',
    aumico_reports_add_more_tasks_button: 'Add more tasks',
    aumico_reports_cancel_button: 'Cancel',
    aumico_reports_save_checklist_button: 'Save check list',
    aumico_admin_user_notification_success_description: 'Data Saved Successfully',
    aumico_reports_checklist_title: 'Checklist',
    aumico_reports_checklist_content:
        'Here will be the check lists for your FLIs. They will help you to track the process and make sure, you don’t forget anything.',
    aumico_reports_comments_title: 'Comments',
    aumico_reports_comments_content:
        'Here you can add comments for the accounts. You can use it as notes for yourself and for your collaborators.',
    aumico_reports_docs_title: 'Documents',
    aumico_reports_docs_content:
        'Documents will be available here. You can upload and download documents for the accounts.',
    aumico_reports_no_checklist_message: 'We couldn’t find any check list for this FLI.',
    aumico_reports_create_checklist_button: 'Create a new check list',
    aumico_reports_or_text: 'or',
    aumico_reports_import_checklist_button: 'Import a check list',

    aumico_reports_last_year: 'Last Year',
    aumico_reports_this_year: 'This Year',
    aumico_reports_select_checklist: 'Select a check list',
    aumico_reports_import_checklist: 'Import a check list',
    aumico_reports_custom_checklist_creation_text: 'You can also {{linkText}} in the Organization settings.',

    aumico_reports_custom_checklist_creation_link_text: 'create your own checklists',
    aumico_reports_closing_entries_title: 'Closing Entries - IT',
    aumico_reports_closing_entries_content: 'Please select closing entry -it',
    aumico_checklist_management_table_checklist_name: 'Name',
    aumico_checklist_management_table_checklist_created_at: 'Created At',
    aumico_checklist_management_table_checklist_last_change: 'Last Change',
    aumico_checklist_management_table_checklist_modified_by: 'Modified By',
    aumico_reports_annualreport_print_with_legacy_service: 'Print with legacy service -it',

    aumico_reports_fcp_enable_title: 'Enable Financial Closing Process',
    aumico_reports_fcp_enable_subtitle: 'Get full access to the closing process for a competitive annual rate.',
    aumico_reports_fcp_teaser_1_title: 'Automate your financial closings',
    aumico_reports_fcp_teaser_1_text: 'Plan it, create it, launch it. Collaborate seamlessly with your organization.',
    aumico_reports_fcp_teaser_2_title: 'Reduce manual errors',
    aumico_reports_fcp_teaser_2_text: 'Protect your organization and stay compliant with structured workflows.',
    aumico_reports_fcp_teaser_3_title: 'Ensure compliance with accounting standards',
    aumico_reports_fcp_teaser_3_text: 'Auto-assign tasks and use hundreds of templates.',
    aumico_reports_fcp_beta_terms_title: 'Beta Information',
    aumico_reports_fcp_trial_terms_1: '30-day free trial',
    aumico_reports_fcp_trial_terms_2: 'Automatically converts to an annual contract if not canceled',
    aumico_reports_fcp_trial_terms_3: 'Cancel anytime during the trial period',
    aumico_reports_fcp_trial_info_title: 'Trial Information',
    aumico_reports_fcp_trial_info_text: 'You have {{x}} days remaining in your trial period.',
    aumico_reports_fcp_subscription_info_title: 'Subscription Information',
    aumico_reports_fcp_subscription_info_text: 'You have {{x}} days remaining in your subscription period.',
    aumico_reports_fcp_trial_deactivation_title: `We'd love to hear your feedback`,
    aumico_reports_fcp_trial_deactivation_text: `Please tell us why you're stopping the trial...`,
    aumico_reports_fcp_subscription_deactivation_title: `We'd love to hear your feedback`,
    aumico_reports_fcp_subscription_deactivation_text: `Please tell us why you're stopping the subscription...`,
    aumico_reports_fcp_deactivation_placeholder: `Write feedback here ...`,
    aumico_reports_fcp_deactivation_feedback_button: `Submit Feedback and Disable`,
    aumico_reports_fcp_deactivation_confirmation_question_text: `Are you sure you want to deactivate closing process?`,
    aumico_reports_fcp_deactivation_terms: `Note:`,
    aumico_reports_fcp_deactivation_term_data_storage: `Data produced during the activation will be lost.`,
    aumico_reports_fcp_deactivation_term_end_date: `The feature will be terminated at {{date}}`,
    aumico_reports_fcp_deactivation_term_costs: `No charges will be made.`,
    aumico_reports_add_a_new_comment_placeholder: 'Add a new comment -it',
    aumico_reports_add_new_comments_button: 'Add -it',
    aumico_reports_add_edit_comments_button: 'Edit -it',
    aumico_reports_mark_comment_as: 'Mark as: -it',
    aumico_reports_comments_section_description:
        'Here you can add comments for the accounts. You can use it as notes for yourself and for your collaborators.',
    aumico_reports_mark_as_internal_comment: 'Mark as internal -it',
    aumico_reports_mark_as_external_comment: 'Mark as external -it',
    aumico_reports_mark_as_review_comment: 'Mark to review -it',
    aumico_reports_mark_comment_as_pendency: 'Pendency -it',
    aumico_reports_copy_comment: 'Copy -it',
    aumico_reports_delete_comment: 'Delete -it',
    aumico_reports_is_internal_comment: 'Internal -fr',
    aumico_reports_is_external_comment: 'External -fr',
    aumico_reports_is_pendancy_comment: 'Pendency -fr',
    aumico_reports_is_review_comment: 'Review -it',

    aumico_reports_fcp_file_virused_error_message: 'The uploaded file is infected with virus',
    aumico_reports_fcp_file_uploaded_success_message: 'File Uploaded Successfully',
    aumico_reports_browse_files: 'Browse for files',
    aumico_reports_fcp_edit_checklist: 'Edit Checklist',

    aumico_reports_fcp_tree_adjustment_col_header: 'Adjustment',
    aumico_reports_fcp_tree_current_year_col_header: 'Current Year',
    aumico_reports_fcp_tree_previous_year_col_header: 'Previous Year',
    aumico_reports_notes_search_reports: 'Search Reports',
    aumico_reports_finalize_and_continue_button: 'Finalize and Continue',
    aumico_reports_preview_button_text: 'Preview',
    aumico_reports_export_button_text: 'Export',
    aumico_reports_export_unlabeled_comment: 'Include unlabeled Comment',
    aumico_reports_export_internal_comment: 'Include Internal Comment',
    aumico_reports_export_external_comment: 'Include External Comment',
    aumico_reports_export_review_comment: 'Include Review Comment',
    aumico_reports_export_pendency: 'Include Pendencies',
    aumico_reports_export_excel: 'Excel',
    aumico_reports_export_closing: 'Include Closing Entries',
    aumico_reports_closing_process_balance_navigation_tab: 'Balance -it',
    aumico_reports_closing_process_income_navigation_tab: 'Income -it',
    aumico_reports_fcp_save_checklist_button: 'Save Checklist',
    aumico_reports_fcp_closing_edit_entry: 'Edit',
    aumico_reports_fcp_closing_delete_entry: 'Delete',
    aumico_reports_fcp_closing_add_entry: 'Add Entry',
    aumico_reports_fcp_closing_save_entry: 'Save',
    aumico_reports_fcp_closing_enter_amount: 'Enter Amount',
    aumico_reports_fcp_closing_add_new_amount: 'Add a new amount',
    aumico_reports_fcp_closing_select_debit: 'Select Debit',
    aumico_reports_fcp_closing_add_new_debit: 'Add a new debit',
    aumico_reports_fcp_closing_select_credit: 'Select Credit',
    aumico_reports_fcp_closing_add_new_credit: 'Add a new credit',
    aumico_reports_fcp_closing_add_details: 'Add Details',
    aumico_reports_fcp_closing_details: 'Details',
    aumico_reports_fcp_closing_add_new_text: 'Add a new text',
    aumico_reports_fcp_closing_no_closing_entries_last_year: 'There are no closing entries for this account last year.',
    aumico_reports_fcp_closing_amount: 'Amount',
    aumico_reports_fcp_closing_debit: 'Debit',
    aumico_reports_fcp_closing_credit: 'Credit',
    aumico_reports_fcp_closing_done: 'Done',
    aumico_reports_fcp_no_items: 'No items -it',
    aumico_reports_fcp_unknown_state: 'UNKNOWN STATE -it',
    aumico_reports_fcp_search_placeholder: 'Search -it',

    aumico_reports_fcp_closing_process_checklist_mark_all_as_done: 'Mark all as done',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done_confirm: 'Yes',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done_cancel: 'No',
    aumico_reports_fcp_closing_process_checklist_mark_all_as_dont_show_again: "Don't show this pop up again",
    aumico_reports_fcp_closing_process_checklist_mark_all_as_done_text:
        'Do you want to complete the task for all accounts?',

    aumico_reports_fcp_closing_process_checklist_delete_checklist: 'Are you sure you want to delete this checklist?',
    aumico_reports_fcp_closing_process_checklist_confirm_delete_checklist: "Yes, I'm sure",
    aumico_reports_fcp_closing_process_checklist_cancel_delete_checklist: 'No, cancel',
    aumico_reports_confirm_delete: "Yes, I'm sure",
    aumico_reports_cancel_delete: 'No, cancel',
    aumico_support_nav_item: 'Support',
    aumico_annual_report_mapping_load_fli_cfs_settings_warning:
        'Press the "Load CFS Settings" button if when editing flis it is missing the cash flow type. By using this function, the cashflow types in all of the flis will be reloaded from settings.Any cash flow type that you have added yourself must be entered again. This is a temporary solution! - it',
    aumico_annual_report_mapping_load_fli_cfs_settings_button: 'Reaload CFS Settings - it',
    aumico_annual_report_mapping_load_fli_cfs_settings_dialog_content:
        'This action cannot be undone after saving. Please check the cash flow types of each fli carefully after using this function. - it',

    aumico_annual_report_fcp_checklist_not_allow_duplicate: 'Duplicate tasks are not allowed!',
    aumico_reports_just_now: 'just now',

    aumico_reports_fcp_uploading: 'uploading',
    aumico_reports_fcp_uploaded: 'Uploaded',
    aumico_reports_hours_of_uploading: '{{diffInHours}} hours ago',
    aumico_reports_hour_of_uploading: '{{diffInHours}} hour ago',
    aumico_reports_days_of_uploading: '{{diffInDays}} days ago',
    aumico_reports_day_of_uploading: '{{diffInDays}} day ago',
    aumico_reports_fcp_file_is_virused_warning_popup:
        ' The file you uploaded is infected with a virus and cannot be processed.',

    aumico_reports_fcp_file_allowed_files: 'Please upload a .xlsx or a .xls or a .pdf file',
    aumico_core_ham_referencing_input_placeholder: 'Title - it',
    aumico_notes_components_list_actions_break_page: 'Add page break - it',
    aumico_notes_components_list_actions_compare_years: 'Compare Years - it',
    aumico_notes_components_list_actions_settings: 'Impostazioni',
    aumico_notes_components_list_actions_add: 'Aggiungi',
    aumico_notes_components_list_actions_show_previous_year: 'Show Previous Year - it',
    aumico_notes_components_list_actions_transpose: 'Transpose - it',
    aumico_notes_components_list_actions_flip_signs: 'Flip Signs - it',
    aumico_notes_components_list_actions_show_total: 'Mostra totale',
    aumico_notes_components_list_actions_hide_component_tooltip: 'Nascondi componente',
    aumico_notes_components_list_actions_show_component_tooltip: 'Mostra componente',
    aumico_notes_actions_hide_accordion_tooltip: 'Nascondi tutti i componenti nell\'accordion',
    aumico_notes_actions_show_accordion_tooltip: 'Mostra tutti i componenti nell\'accordion',
    aumico_notes_component_hidden_badge: 'NASCOSTO',
    aumico_reports_fcp_file_uploaded_by: 'By',
    aumico_reports_drag_files: 'Drag files here to upload',
    aumico_annual_report_aop_description: 'AOP Description',
    aumico_annual_report_investing_activities: 'Investing',
    aumico_annual_report_financing_activities: 'Financing',
    aumico_annual_report_cash_flow_networking_capital: 'Networking Capital',
    aumico_annual_report_cash_flow_operating_activities: 'Operating',
    aumico_annual_report_cash_flow_manual: 'Manual Input',
    aumico_annual_report_delete_item_confirmation_text: 'Are you sure you want to delete this item?',
    aumico_annual_report_cashflow_difference_text: 'Difference (Check to Zero)',
    aumico_annual_report_cashflow_difference_should_be_zero_text: 'Calculated Difference (Should Be 0.00)',

    aumico_add_new_notes_accordion_section_title: 'Add Note -it',
    aumico_add_new_notes_accordion_section_note_title: 'Note title -it',
    aumico_add_new_notes_accordion_section_note_title_input_placeholder: 'Input text -it',
    aumico_add_new_notes_accordion_section_select_note_component_to_add: 'Select a note component to add -it:',
    aumico_add_new_notes_accordion_section_add_numbering_toggle: 'Add Numbering -it',
    aumico_add_new_notes_accordion_section_add_numbering_toggle_description:
        'Automatically apply numbered lists to your note -it',
    aumico_add_new_notes_accordion_section_button: 'Add -it',
    aumico_add_new_notes_component_title: 'Select another component to add -it:',
    aumico_add_new_notes_component_button: 'Add -it',
    aumico_add_new_notes_component_add_numbering_toggle: 'Add Numbering -it',
    aumico_add_new_notes_component_add_numbering_toggle_description:
        'Automatically apply numbered lists to your note -it',
    aumico_annual_report_cashflow_unsaved_changes:
        'Unsaved changes detected. The print data will not be updated until you confirm and save your changes.',
    aumico_annual_report_cash_flow_investing_add_new_section: 'Add new section',
    aumico_annual_report_cash_flow_investing_add_row: 'Add row',
    aumico_reports_tooltip_text_verify_data:
        'The values have been updated. Please verify if the cash flow is still correct.',
    aumico_reports_tooltip_text_verify_fcp_data:
        'Les valeurs ont été mises à jour. Processus de clôture financière si le flux de trésorerie est toujours correct.',
    aumico_reports_side_bar_organization_name: 'Organization Name -it',
    aumico_reports_side_bar_help: 'Help & getting started -it',
    aumico_text_snippets_table_search_placeholder: 'Search for Templates -it',
    aumico_reports_organization_settings_users_add_new_button: 'Add New -it',
    aumico_reports_organization_settings_checklist_add_new_button: 'Add New -it',
    admin_create_licence_package_title: 'Create Licence Package',
    admin_create_licence_package_type: 'Package Type',
    admin_create_licence_package_type_required: 'Package type is required.',
    admin_create_licence_package_size: 'Package Size',
    admin_create_licence_package_size_required: 'Package size is required.',
    admin_create_licence_package_size_min: 'Package size must be at least {{min}}.',
    admin_create_licence_package_start_date: 'Start Date',
    admin_create_licence_package_start_date_required: 'Start date is required.',
    admin_create_licence_package_end_date: 'End Date',
    admin_create_licence_package_end_date_required: 'End date is required.',
    admin_create_licence_package_end_date_invalid: 'End date must be after the start date.',
    admin_create_licence_package_description: 'Description',
    admin_create_licence_package_price: 'Price',
    admin_create_licence_package_price_min: 'Price must be at least {{min}}.',
    admin_create_licence_package_discount_amount: 'Discount Amount',
    admin_create_licence_package_discount_amount_min: 'Discount amount must be at least {{min}}.',
    admin_create_licence_package_discount_percent: 'Discount Percent',
    admin_create_licence_package_discount_percent_min: 'Discount percent must be at least {{min}}%.',
    admin_create_licence_package_discount_percent_max: 'Discount percent cannot exceed {{max}}%.',
    admin_create_licence_package_cancel: 'Cancel',
    admin_create_licence_package_confirm: 'Confirm',
    aumico_reports_aop_account_caption: 'Caption',
    aumico_annual_report_print_options_label_non_breaking_hyphen_toggle: 'Non breaking hyphen -it',
    aumico_annual_report_print_options_repeat_appendix_title: 'Ripetere il titolo dell\'allegato su ogni pagina',
    aumico_annual_report_print_options_round_to_thousands: 'Arrotondare i valori in migliaia',
    aumico_templates_mapping_remove_account_will_change_previous_year_values_warning:
        'Please take care that removing an account will modify in the previous year value - it',
    aumico_companies_form_assigned_users: 'Assigned Users',
    aumico_companies_form_assigned_on: 'Assigned on',

    aumico_admin_organization_list_package_type: 'Type',
    aumico_admin_organization_list_package_start_date: 'Start Date',
    aumico_admin_organization_list_package_end_date: 'End Date',
    aumico_admin_organization_list_package_size: 'Size',
    aumico_admin_organization_list_actions: 'Actions',
    aumico_admin_organization_list_add_package: 'Add Package',
    aumico_admin_organization_list_package_delete: 'Delete',
    aumico_admin_organization_list_package_edit: 'Edit',
    aumico_admin_delete_package_confirmation_dialog_description: 'Are you sure you want to delete this package?',
    aumico_admin_organization_abcp_needs_cpmm: 'Richiede CPMM',
    aumico_admin_organization_abcp_update_failed: 'Impossibile cambiare ABCP.',
    aumico_users_organization_users_table_date_added_label: 'Date Added',
    aumico_users_organization_users_table_status_label: 'Status',
    aumico_users_organization_users_table_pending_label: 'Pending',
    aumico_users_organization_users_table_active_label: 'Active',
    aumico_users_organization_users_table_resend_invite: 'Resend Invite',
    aumico_users_organization_users_table_withdraw_invite_action: 'Withdraw',
    aumico_users_organization_users_table_resend_invite_action: 'Resend',
    aumico_users_organization_users_table_withdraw_invite_modal_title: 'Withdraw Invitation?',
    aumico_users_organization_users_table_resend_invite_modal_title: 'Resend Invitation',
    aumico_users_organization_users_table_withdraw_invite_modal_body:
        'Are you sure you want to withdraw this invitation? The user will no longer be able to join the platform unless re-invited.',
    aumico_users_organization_users_table_resend_invite_modal_body: 'Are you sure you want to resend this invitation?',
    aumico_users_organization_users_table_invite_modal_body:
        'Easily collaborate with your team by inviting new employees. This feature simplifies task distribution, enhances communication, and enables seamless teamwork on annual reports.',
    aumico_companies_mandate_text: 'Mandat',
    aumico_reports_design_settings_example_subtitle: '1.1 Example Subtitle',
    aumico_annual_report_print_options_show_notes_in_detail_in_toc: 'Detailed version -it',
    aumico_components_ham_styling_menu_align_left: 'align left -it',
    aumico_components_ham_styling_menu_align_center: 'align center -it',
    aumico_components_ham_styling_menu_align_right: 'align right -it',
    aumico_components_ham_styling_menu_bold: 'bold -it',
    aumico_components_ham_styling_menu_underlined: 'underlined -it',
    aumico_components_ham_styling_menu_italic: 'italic -it',
    aumico_components_ham_styling_menu_percentage: 'percentage -it',
    aumico_components_ham_styling_menu_less_decimals: 'decrease decimals -it',
    aumico_components_ham_styling_menu_more_decimals: 'increase decimals -it',
    aumico_components_ham_styling_menu_flip_sign:
        'flip sign affects only the displayed value and not the actual value -it',
    aumico_reports_organization_delete_user: 'Are you sure want to delete this user?',
    aumico_reports_organization_delete: 'Delete',
    aumico_reports_companies_upload_logo: 'Upload Logo',
    aumico_reports_companies_upload_logo_description:
        'The uploaded logo will appear in the company profile and can optionally be included in printed documents.',

    aumico_reports_companies_upload_file_upload_image_info: 'Upload PNG logo',
    aumico_reports_companies_upload_file_upload_image_size: '(Maximum 5MB, 100x100px)',
    aumico_reports_companies_upload_file_upload_error_format: 'Please upload logo in .png format',
    aumico_annual_report_print_options_advanced_title: 'Advanced -it',
    aumico_annual_report_print_options_components_accordion_title: 'Components -it',
    aumico_annual_report_print_options_settings_accordion_title: 'Settings -it',
    aumico_annual_report_print_options_signature_accordion_title: 'Signature -it',
    aumico_annual_report_print_options_financial_statement_components_title: 'Financial statement -it',
    aumico_annual_report_print_options_cash_flow_component_title: 'Cash flow statement -it',
    aumico_annual_report_print_options_notes_component_title: 'Notes -it',
    aumico_annual_report_print_options_aop_component_title: 'Appropriation of profit -it',
    aumico_annual_report_print_options_place_signature_after_income_statement:
        'Place signature after income statement -it',
    aumico_annual_report_file_size_error: 'File Size exceeds 5MB',
    aumico_cover_page_internal_label: 'Interno',
    aumico_annual_report_select_autofill_options: 'Select information to copy from this template',
    aumico_annual_report_autofill_options_taxonamy: 'Taxonomy',
    aumico_annual_report_autofill_options_cfs: 'Cash flow statement',
    aumico_annual_report_autofill_options_notes: 'Notes',
    aumico_annual_report_autofill_options_aop: 'Accounts of profit',
    aumico_annual_report_print_options_general_accordion_title: 'General -it',
    aumico_notes_super_table_row_settings: 'Row settings - it',
    aumico_notes_super_table_reconcile: 'Reconcile - it',
    aumico_notes_super_table_reconcile_dialog_description: 'Select one item to reconcile - it',
    aumico_notes_super_table_mapping_row_settings_description: 'Please select one or multiple items for a new row - it',
    aumico_notes_super_table_mapping_row_settings_row_title: 'Row Title - it',
    aumico_notes_super_table_delete_column_confirmation_text: 'Are you sure want to delete this Column ?',
    aumico_notes_super_table_delete_row_confirmation_text: 'Are you sure want to delete this Row ?',
    aumico_notes_super_table_add_calculation_next: 'Next - it',
    aumico_notes_super_table_add_calculation_cancel: 'Go Back - it',
    aumico_notes_super_table_segmented_columns: 'Select the Columns to be Segmented',
    aumico_notes_super_table_select_columns: 'Select Columns',
    aumico_admin_ar_template_list_reporting_template_name: 'Pdf template name -it',
    aumico_admin_ar_template_reset_pdf_template_to_default_button: 'Reset template to default -it',
    aumico_admin_ar_template_uploaded_pdf_template_name: 'Uploaded pdf template name -it',
    aumico_admin_ar_template_no_custom_pdf_template_uploaded: 'No custom template uploaded -it',
    aumico_notes_super_table_select_from_here: 'Select from here',
    aumico_notes_super_table_edit_column: 'Edit Column',
    aumico_notes_super_table_select_summation_columns_label: 'Select the columns which shall be summed up - it',
    aumico_notes_super_table_select_subtraction_column_mineund: 'Mineund - it',
    aumico_notes_super_table_select_subtraction_column_subtrahend: 'Subtrahend - it',
    aumico_notes_super_table_select_multiplication_columns_label: 'Select the columns which shall be multiplied - it',
    aumico_notes_super_table_ratio_choose_rows_for: 'Choose Rows For - it',
    aumico_notes_super_table_ratio_choose_row_for: 'Choose Row For -it ',
    aumico_notes_super_table_ratio_choose_cell: 'Choose Cell - it',
    aumico_notes_super_table_ratio_numerator: 'Numerator -it',
    aumico_notes_super_table_calculation_item_selected: 'Item Selected - it',
    aumico_notes_super_table_ratio_denomenator: 'Denomenator - it',
    aumico_annual_reports_export_excel_structured: 'Export Excel NEW',
    aumico_notes_super_table_previous_column_removal_confirmation:
        'Are you sure you want to delete the previous year column? - it',
    aumico_notes_fli_component_remove_fli_confirmation_text: 'Are you sure you want to remove this fli? - it',
    aumico_admin_navigation_survey_management: 'Survey Management -it',
    aumico_admin_survey_management_page_title: 'Survey Management -it',
    aumico_admin_survey_management_table_creation_date: 'Creation date -it',
    aumico_admin_survey_management_table_end_date: 'End date -it',
    aumico_admin_survey_management_table_survey_status: 'Survey status -it',
    aumico_admin_survey_management_table_number_of_participants: 'Number of participants -it',
    aumico_admin_survey_management_start_new_survey_button: 'Start new survey -it',
    aumico_admin_survey_management_start_new_survey_button_tooltip:
        'A new survey can only be launched if no other surveys are active. -it',
    aumico_admin_survey_management_table_survey_status_badge_ACTIVE: 'Aktiv',
    aumico_admin_survey_management_table_survey_status_badge_INACTIVE: 'Inaktiv',
    aumico_admin_survey_management_table_menu_options_delete: 'Delete survey -it',
    aumico_admin_survey_management_table_menu_options_stop: 'Stop survey -it',
    aumico_admin_survey_management_table_menu_options_download: 'Download CSV -it',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_DISAPPOINTED: 'Neutral -it',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_NOT_DISAPPOINTED: 'Detractor -it',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_VERY_DISAPPOINTED: 'Promoter -it',
    aumico_admin_survey_satisfaction_table_pmf_response_badge_OPEN: 'Open -it',
    aumico_admin_survey_satisfaction_table_user: 'USER -it',
    aumico_admin_survey_satisfaction_table_organization: 'ORGANIZATION -it',
    aumico_admin_survey_satisfaction_table_pmf_response: 'PMF RESPONSE -it',
    aumico_admin_survey_satisfaction_table_question_2: 'MAIN BENEFIT YOU RECEIVE FROM AUMICO -it',
    aumico_admin_survey_satisfaction_table_question_3: 'HOW CAN WE IMPROVE OUR PRODUCT -it',
    aumico_admin_survey_satisfaction_table_question_4: 'TYPE OF PERSON WOULD BENEFIT MOST -it',
    aumico_admin_survey_satisfaction_page_pmf_score: 'PMF Score -it',
    aumico_admin_survey_satisfaction_page_participants: 'Participants -it',
    aumico_admin_survey_satisfaction_page_participants_out_of: 'out of -it',
    aumico_admin_survey_satisfaction_page_users: 'Users -it',
    aumico_admin_survey_satisfaction_page_promoters: 'Promoters -it',
    aumico_admin_survey_satisfaction_page_neutrals: 'Neutrals -it',
    aumico_admin_survey_satisfaction_page_detractors: 'Detractors -it',
    aumico_admin_survey_satisfaction_page_end_survey_button: 'End Survey -it',
    aumico_admin_survey_satisfaction_page_download_csv_button: 'Download CSV -it',
    aumico_admin_navigation_survey_satisfaction: 'Employee Satisfaction Survey -it',
    aumico_survey_popup_go_back_button: 'Go back -it',
    aumico_survey_popup_of: 'of -it',
    aumico_reports_navigation_survey_give_feedback: 'Give Feedback -it',
    aumico_survey_popup_thank_you: 'Thank you -it',
    aumico_survey_popup_we_value_your_feedback:
        'We truly appreciate your feedback! Your insights help us make Aumico even better. Thanks for taking the time to share your thoughts! -it',
    aumico_survey_popup_question_one: 'How would you feel if you could no longer use aumico? -it',
    aumico_survey_popup_question_two: 'What do you enjoy most about aumico? -it',
    aumico_survey_popup_question_three: 'How can we further improve aumico for you? -it',
    aumico_survey_popup_question_four: 'What type of person would benefit most from aumico? -it',
    aumico_survey_popup_question_one_response_very_disappointed: 'Very disappointed -it',
    aumico_survey_popup_question_one_response_somewhat_disappointed: 'Somewhat disappointed -it',
    aumico_survey_popup_question_one_response_not_disappointed: 'Not disappointed -it',
    aumico_survey_popup_close_button: 'Close -it',
    aumico_survey_popup_next_button: 'Next -it',
    aumico_survey_popup_maybe_later_button: 'Maybe Later -it',
    aumico_survey_popup_submit_button: 'Submit -it',
    aumico_survey_popup_placeholder: 'Write text here... -it',
    aumico_annual_report_complementary_reports_drag_here: 'Drag a report here',
    aumico_complementary_reports_report_organize_reports: 'Organize Reports',
    aumico_complementary_reports_report_create_edit_reports: 'Create reports',

    aumico_annual_reports_export_excel_structured_tooltip:
        'Esportazione di Excel con una nuova struttura e un aspetto visivamente accattivante',
    aumico_admin_menu_item_activate_cpmm: 'Attiva CPMM',
    aumico_admin_menu_item_deactivate_cpmm: 'Disattiva CPMM',

    aumico_annual_report_print_seal_report_action: 'Seal Annual Report',
    aumico_annual_report_print_seal_report_history: 'Seal History',
    aumico_annual_report_print_seal_report_history_tooltip: 'There is no history to show',
    aumico_annual_report_print_seal_report_history_empty: 'No seal history available',
    aumico_annual_report_confirmation_seal_dialog_title: 'Are you sure you want to seal this report?',
    aumico_annual_report_confirmation_seal_dialog_description:
        'Once sealed, it will be marked as completed and ready for stakeholders.',
    aumico_annual_report_confirmation_seal_dialog_action: 'Yes, Seal',
    aumico_annual_report_confirmation_unseal_dialog_title: 'Unseal Report?',
    aumico_annual_report_confirmation_unseal_dialog_description:
        'Unsealing this report may lead to discrepancies if it has already been shared with stakeholders. Do you want to proceed?',
    aumico_annual_report_confirmation_unseal_dialog_action: 'Unseal Report',
    aumico_annual_report_seal: 'Sealed',
    aumico_annual_report_unseal: 'Unsealed',
    aumico_annual_report_sealed_tag: 'Annual Report Sealed',
    aumico_annual_report_fs_overview_sealed_tag: 'Sealed',
    aumico_annual_report_locked: 'Locked Report',
    aumico_annual_report_Unlock: 'Unlock',
    aumico_annual_report_sealed_by: 'By ',
    aumico_button_close: 'Close',
    aumico_annual_report_complementary_report_name: 'Report name',
    aumico_annual_report_print_page_no_seal_history: 'No seal history available',
    aumico_annual_report_complementary_report_create_report: 'Create reports',
    aumico_annual_report_complementary_report_organize_report: 'Organize reports',
    aumico_notes_movement_schedule_component_column1_header: 'Entrées',
    aumico_notes_movement_schedule_component_column2_header: 'Cessions',
    aumico_notes_movement_schedule_component_column3_header: 'Amortiss.',
    aumico_notes_movement_schedule_component_column4_header: 'Suramortiss.',
    aumico_reports_seal_unseal_cancel_action: 'No, cancel',
    aumico_companies_table_label_company_assignee: 'Manager',
    aumico_companies_table_download_xls: 'Download XLS',
    aumico_pm_tasks_status_filter_label: 'Status - it',
    aumico_pm_tasks_status_open: 'Open -it',
    aumico_pm_tasks_status_in_progress: 'In Progress -it',
    aumico_pm_tasks_status_in_review: 'In Review -it',
    aumico_pm_tasks_status_done: 'Completed -it',
    aumico_pm_tasks_company_filter_label: 'Company - it',
    aumico_pm_tasks_apply_filter: 'Apply - it',
    aumico_pm_tasks_clear_filter: 'Clear - it',
    aumico_pm_tasks_assignee_filter_label: 'Responsible - it',
    aumico_pm_tasks_due_date_filter_label: 'Due Date - it',
    aumico_create_project_dialog_select_company_title: 'Select a company to assign this project -it',
    aumico_create_project_dialog_select_company_description:
        'Dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    aumico_create_project_dialog_select_company_input_title: 'Company -it',
    aumico_create_project_dialog_select_company_input_placeholder: 'Set a company to assign this project -it',
    aumico_create_project_dialog_cancel_button: 'Cancel -it',
    aumico_create_project_dialog_next_button: 'Next -it',
    aumico_create_project_dialog_submit_button: 'Submit -it',
    aumico_create_project_dialog_back_button: 'Back -it',
    aumico_create_project_dialog_select_balance_sheet_date_title: 'Set a Balance Sheet Date -it',
    aumico_create_project_dialog_select_balance_sheet_date_description:
        'Dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    aumico_create_project_dialog_select_balance_sheet_date_input_title: 'Balance Sheet Date -it',
    aumico_create_project_dialog_select_balance_sheet_date_input_placeholder: 'Select a balance sheet date -it',
    aumico_create_project_dialog_select_balance_sheet_date_calendar_today: 'Today -it',
    aumico_create_project_dialog_select_balance_sheet_date_calendar_clear: 'Clear -it',
    aumico_create_project_dialog_select_mandate_management_title: 'Set Mandate Management Configuration -it',
    aumico_create_project_dialog_select_mandate_management_copy_from_previous:
        'Copy configuration from previous year -it',
    aumico_create_project_dialog_select_mandate_management_reset_to_standard: 'Reset to standard configuration -it',
    aumico_create_project_dialog_select_closing_workflow_title: 'Set Closing Workflow Configuration -it',
    aumico_create_project_dialog_select_closing_workflow_copy_from_previous:
        'Copy configuration from previous year -it',
    aumico_create_project_dialog_select_closing_workflow_reset_to_standard: 'Reset to standard configuration -it',
    aumico_create_project_dialog_of: 'of -it',
    aumico_tasks_overview_search_tasks: 'Search for tasks - it',
    aumico_reports_organization_settings_workflow: 'Workflow',
    aumico_reports_organization_settings_mandate_management: 'Mandate Management Configurator - it',
    aumico_organization_settings_mandate_management_configuration_page_header: 'Mandate Management Configuration - it',
    aumico_reports_organization_settings_closing_workflow: 'Closing Workflow Configurator - it',
    aumico_closing_workflow_overview_search_configurations: 'search configurations -it',
    aumico_closing_workflow_overview_add_new_workflow: 'Add New Workflow - it',
    aumico_closing_workflow_overview_add_workflow_dialog_title: 'Add Workflow - it',
    aumico_closing_workflow_overview_add_workflow_dialog_description:
        'Do you want to start from scratch or select from a template? -it',
    aumico_closing_workflow_overview_start_from_scratch: 'Start from scratch - it',
    aumico_closing_workflow_overview_start_from_existing_workflow: 'Start from existing workflow - it',
    aumico_closing_workflow_overview_select_workflow_template_dialog_title: 'Select a workflow to use as template - it',
    aumico_closing_workflow_overview_next_button: 'Next - it',
    aumico_closing_workflow_overview_back_button: 'Back - it',
    aumico_closing_workflow_overview_select_workflow_template_name: 'Name - it',
    aumico_organization_settings_closing_workflow_configuration_page_header: 'Closing Workflow Configuration - it',
    aumico_cpmm_closing_workflows_table_delete_workflow_confirmation_text:
        'Are you sure that you want to delete this workflow?This action cannot be undone - it',
    aumico_cpmm_closing_workflows_table_title_label: 'TITLE - it',
    aumico_cpmm_closing_workflows_table_creation_date_label: 'CREATION DATE - it',
    aumico_reports_annual_report_navigation_mandate_management: 'Mandate Management -it',
    aumico_reports_annual_report_navigation_closing_workflow: 'Closing Workflow -it',
    aumico_reports_annual_report_navigation_closing: 'Annual Closing -it',
    aumico_reports_annual_report_navigation_report: 'Report -it',
    aumico_cp_workflow_title: 'Titolo del flusso di lavoro',
    aumico_cpmm_enter_title: 'Inserisci il titolo del flusso di lavoro',
    aumico_cp_general: 'Generale',
    aumico_cp_balance_sheet: 'Bilancio',
    aumico_cp_income_statement: 'Conto economico',
    aumico_cpmm_add_section: 'Aggiungi sezione',
    aumico_cpmm_no_tasks_title: 'Nessuna attività ancora',
    aumico_cpmm_no_tasks_subtitle: "Aggiungi un'attività o una sezione per iniziare",
    aumico_cpmm_set_section_name: 'Inserisci il nome della sezione',
    aumico_cpmm_task_name: 'Nome dell’attività',
    aumico_cpmm_task_description: 'Descrizione dell’attività',
    aumico_cpmm_day_title: 'Giorno',
    aumico_cpmm_day_placeholder: 'GG',
    aumico_cpmm_month_title: 'Mese',
    aumico_cpmm_month_placeholder: 'MM',
    aumico_cpmm_period_title: 'Periodo',
    aumico_cpmm_period_placeholder: 'Imposta periodo',
    aumico_cpmm_new_task: 'Aggiungi nuova attività',
    aumico_cpmm_max_length_notice_title: 'Numero massimo di caratteri raggiunto',
    aumico_cpmm_max_length_notice_description: 'È possibile inserire un massimo di 50 caratteri.',
    aumico_cpmm_current_period: 'Periodo attuale',
    aumico_cpmm_next_period: 'Periodo successivo',
    aumico_cpmm_workflow_save_success: 'Workflow salvato con successo',
    aumico_cpmm_workflow_update_failure: 'Impossibile aggiornare il workflow. Riprova.',
    aumico_cpmm_section_update_success: 'Sezione aggiornata con successo',
    aumico_cpmm_section_update_failure: 'Impossibile aggiornare la sezione. Riprova.',
    aumico_cpmm_copy_of: 'Copia di ',
    aumico_cpmm_period_tooltip:
        'Periodo attuale: anno della data di bilancio selezionata per il progetto, Prossimo periodo: anno successivo alla data di bilancio selezionata.',
    aumico_tasks_unassigned: 'unassigned - it',
    aumico_pm_tasks_company_table_header: 'Azienda',
    aumico_pm_tasks_due_date_table_header: 'Due Date - it',
    aumico_pm_tasks_section_table_header: 'Section - it',
    aumico_pm_tasks_task_table_header: 'Task - it',
    aumico_pm_tasks_latest_comment_table_header: 'Ultimo commento',
    aumico_pm_tasks_status_table_header: 'Status - it',
    aumico_pm_tasks_responsible_table_header: 'Responsible - it',
    aumico_pm_tasks_select_date_today: 'Today - it',
    aumico_pm_tasks_filter_clear: 'Clear - it',
    aumico_pm_tasks_assignee_filter_my_tasks: 'My Tasks - it',
    aumico_companies_form_closing_workflow: 'Closing workflow -it',
    aumico_cpmm_closing_workflows_table_delete_section_confirmation_text:
        'Are you sure you want to remove this section from the workflow - it ?',
    aumico_reports_main_navigation_projects: 'Projects - it',
    aumico_reports_my_projects: 'My Projects - it',
    aumico_reports_all_projects: 'All Projects - it',
    aumico_projects_overview_page_header: 'Projects - it',
    aumico_projects_overview_search_projects: 'Search for projects - it',
    aumico_projects_overview_add_new_project: 'New Project - it',
    aumico_companies_export_excel_table_header_name: 'Name -it',
    aumico_companies_export_excel_table_header_street_and_number: 'Street and number -it',
    aumico_companies_export_excel_table_header_addition_to_address: 'Addition to address -it',
    aumico_companies_export_excel_table_header_zip_code: 'Zip code -it',
    aumico_companies_export_excel_table_header_city: 'City -it',
    aumico_companies_export_excel_table_header_country: 'Country -it',
    aumico_companies_export_excel_table_header_assigned_user: 'Assigned user -it',
    aumico_companies_export_excel_table_header_first_name: 'First name -it',
    aumico_companies_export_excel_table_header_last_name: 'Last name -it',
    aumico_companies_export_excel_table_header_email: 'Email -it',
    aumico_companies_export_excel_table_header_phone: 'Phone -it',
    aumico_companies_export_excel_table_header_uid_number: 'UID number -it',
    aumico_companies_export_excel_table_header_legal_form: 'Legal form -it',
    aumico_companies_export_excel_table_header_tax_domicile: 'Tax domicile -it',
    aumico_companies_export_excel_table_header_industry: 'Industry -it',
    aumico_companies_export_excel_table_header_closing_workflow: 'Closing Workflow -it',
    aumico_reports_main_navigation_tasks: 'Tasks -it',
    aumico_reports_main_navigation_tasks_and_closing: 'Closing & Tasks -it',
    aumico_reports_tasks_and_closing_advertising_title: 'Enable Closing Workflow and Mandate & Task Management -it',
    aumico_reports_tasks_and_closing_advertising_description:
        'Seamless client management and closing workflows, no matter which accounting tool you use. -it',
    aumico_reports_tasks_and_closing_advertising_mandate_management_title: 'Mandate & Task Management -it',
    aumico_reports_tasks_and_closing_advertising_mandate_management_description:
        'Configure standardized workflows for recurring tasks (e.g., VAT, payroll, tax returns) across all clients. -it',
    aumico_reports_tasks_and_closing_advertising_closing_workflow_title: 'Closing Workflow -it',
    aumico_reports_tasks_and_closing_advertising_closing_workflow_description:
        'Configure and manage end-to-end closing workflows and manage tasks, documents & comments in one central place. -it',
    aumico_reports_tasks_and_closing_advertising_upgrade_button: 'Upgrade -it',
    aumico_create_project_invalid_date:
        'Data non valida, il formato inglese è MM/GG/AAAA, il formato tedesco è GG.MM.AAAA',
    aumico_reports_project_upload_document_title: 'Upload Document -it',
    aumico_reports_project_upload_document_description:
        'Select a file from your device to attach to this task. Supported formats: ',
    aumico_reports_project_upload_document_drag: 'Drag files here to upload -it',
    aumico_reports_project_upload_document_details: '(Max. file size 25MB) -it',
    aumico_cpmm_workflow_configurator_empty_section_confirmation_text:
        'Are you sure you want to save with empty sections that have no tasks? This will result in the deletion of these sections - it',
    cpmm_projects_overview_empty_mandates: 'Non hai ancora mandati!',
    cpmm_projects_overview_empty_companies: 'Non ci sono ancora aziende!',
    cpmm_projects_overview_empty_assign_instructions:
        'Inizia assegnando le aziende nel profilo aziendale. Appariranno qui una volta aggiunte!',
    cpmm_projects_overview_empty_create_instructions: 'Crea nuove aziende per vederle elencate qui!',
    cpmm_projects_overview_empty_go_to_companies_button: 'Vai alla panoramica delle aziende',
    cpmm_projects_overview_empty_add_new_company_button: 'Aggiungi nuova azienda',

    cpmm_projects_overview_group_mandate_management: 'Gestione dei mandati',
    cpmm_projects_overview_group_closing_workflow: 'Flusso di chiusura',
    cpmm_projects_overview_group_report: 'Rapporto',

    cpmm_projects_overview_col_company: 'Azienda',
    cpmm_projects_overview_col_balance_sheet_date: 'Data del bilancio',
    cpmm_projects_overview_col_responsible: 'Responsabile',
    cpmm_projects_overview_col_status: 'Stato',

    cpmm_projects_overview_action_change_status_to_done: 'Cambia stato in Completato',
    cpmm_projects_overview_action_change_status_to_active: 'Cambia stato in Attivo',
    cpmm_projects_overview_action_delete_project: 'Elimina progetto',

    cpmm_projects_overview_badge_active: 'Attivo',
    cpmm_projects_overview_header_row_abcp_closing: 'Stato',
    cpmm_projects_overview_badge_closing_started: 'Avviata',
    cpmm_projects_overview_badge_closing_not_started: 'Non avviata',
    cpmm_projects_overview_badge_done: 'Completato',

    cpmm_projects_overview_badge_report_open: 'Aperto',
    cpmm_projects_overview_badge_report_sealed: 'Sigillato',

    cpmm_projects_overview_header_row_GENERAL: 'Generale',
    cpmm_projects_overview_header_row_BALANCE_SHEET: 'Bilancio',
    cpmm_projects_overview_header_row_INCOME_STATEMENT: 'Conto economico',
    cpmm_projects_overview_empty_individual_company: 'Per questo mandato non ci sono ancora progetti!',
    cpmm_projects_overview_empty_create_instructions_individual_company:
        'Iniziate creando un progetto per questo mandato!',
    aumico_reports_cpmm_tasks: 'Tasks -it',
    aumico_reports_cpmm_export_tasks: 'Export XLSX -it',
    aumico_reports_cpmm_export_tasks_open_tasks: 'Open Tasks -it',
    aumico_reports_cpmm_export_tasks_completed_tasks: 'Completed Tasks -it',
    aumico_reports_cpmm_export_tasks_na_tasks: 'N/A Tasks -it',
    aumico_reports_cpmm_export_tasks_include_documents_names: 'Include documents-it',
    aumico_reports_cpmm_export_tasks_include_annotations: 'Include Annotations -it',
    aumico_reports_cpmm_export_tasks_in_progress_tasks: 'In Progress Tasks -it',
    aumico_reports_cpmm_export_tasks_in_review_tasks: 'In Review Tasks -it',
    aumico_reports_cpmm_export_documents_zip_mandate_management_documents: 'Mandate Management Documents-it',
    aumico_reports_cpmm_export_documents_zip_closing_workflow_documents: 'Closing Workflow Documents-it',
    tasks_empty_state_text_one: 'Non hai ancora nessuna attività!',
    tasks_empty_state_text_two: 'Inizia creando un nuovo progetto.',
    aumico_license_book_call_text:
        'Se non vuoi aspettare, prenota direttamente un appuntamento con il team commerciale.',
    aumico_license_book_call_button: 'Prenota una riunione',
    aumico_reports_export_all_companies_file_name: 'All Companies -it',
    aumico_cpmm_document_uploaded_success_title: 'Document Uploaded Successfully -it',
    aumico_cpmm_document_uploaded_success_description: 'The document has been uploaded successfully -it',
    aumico_cpmm_document_uploaded_failure_title: 'Error Uploading Document -it',
    aumico_cpmm_document_uploaded_failure_description: 'Failed to upload the document. Please try again -it',
    aumico_company_assignee_change_confirmation_dialog_title: 'Change Mandate Manager? - it',
    aumico_company_assignee_change_confirmation_dialog_text:
        'You’re changing the mandate manager for this company.How should existing tasks be reassigned? - it',
    aumico_company_assignee_change_confirmation_update_tasks_assigned_to_current_user:
        'Reassign only tasks that are still assigned to the current (old) mandate manager - it',
    aumico_company_assignee_change_confirmation_update_all_tasks:
        'Reassign all tasks, including those assigned to other users - it',
    aumico_company_assignee_change_confirmation_option: 'Option - it',
    cpmm_projects_overview_empty_filtered_text1: 'Nessun progetto trovato',
    cpmm_projects_overview_empty_filtered_text2:
        'I filtri attuali non restituiscono alcun progetto. Modificali o ripristinali.',
    tasks_empty_state_text_one_filters: 'Nessuna attività trovata',
    tasks_empty_state_text_two_filters:
        'I filtri attuali non restituiscono alcuna attività. Modificali o ripristinali.',
    aumico_backend_errors_workflow_name_already_exists: 'Un workflow con questo nome esiste già.',
    aumico_notes_super_table_edit_reconcile: 'Modifica riconciliazione valore',
    aumico_add_new_notes_clipboard_title: 'Clipboard',
    aumico_add_new_notes_paste_from_clipboard: 'Incolla dagli appunti',
    aumico_companies_assignee_filter_my_companies: 'Le mie aziende',
    aumico_companies_filter_clear: 'Cancella',
    aumico_admin_navigation_announcements: 'Annunci',
    aumico_admin_announcements_message: 'Messaggio',
    aumico_admin_announcements_link_url: 'Link Url',
    aumico_admin_announcements_link_url_placeholder: 'https://example.com',
    aumico_admin_announcements_link_name: 'Link Name',
    aumico_admin_announcements_link_name_placeholder: 'Link Name',
    aumico_admin_announcements_dismissible: 'Fermabile',
    aumico_admin_announcements_date_range: 'Intervallo di date',
    aumico_admin_announcements_create_new_announcement: 'Nuova annuncio',
    aumico_admin_announcements_edit_announcement: "Modifica l'annuncio",
    aumico_admin_announcements_start_date: 'Data di inizio',
    aumico_admin_announcements_end_date: 'Data di fine',
    aumico_admin_announcements_start_date_required: 'La data di inizio è richiesta',
    aumico_admin_announcements_end_date_required: 'La data di fine è richiesta',
    aumico_admin_announcements_update_success: 'Annuncio aggiornato con successo',
    aumico_admin_announcements_create_success: 'Annuncio creato con successo',
    aumico_admin_announcements_delete_success: 'Annuncio eliminato con successo',
    aumico_admin_success_title: 'Successo',
    aumico_create_project_dialog_select_report_type: 'Seleziona il tipo di rapporto',
    aumico_create_project_dialog_select_report_type_annual: 'Annuale',
    aumico_create_project_dialog_select_report_type_quarterly: 'Trimestrale',
    aumico_create_project_dialog_select_report_type_monthly: 'Mensile',
    aumico_create_project_dialog_select_report_type_custom: 'Personalizzato',
    aumico_annual_report_general_information_ar_template: 'Modello AR',
    aumico_annual_report_general_information_select_ar_template: 'Seleziona modello AR',
    aumico_annual_report_general_information_report_type: 'Tipo di rapporto',
    aumico_annual_report_general_information_select_report_type: 'Seleziona il tipo di rapporto',
    aumico_company_update_banner_message:
        "Hai aggiornato le informazioni dell'azienda. Vuoi applicare le modifiche a questo progetto ?",
    aumico_company_update_banner_button: 'Sì, applicare',
    aumico_annual_report_translation_gaps_title: 'Testi senza traduzione',
    aumico_annual_report_translation_gaps_text: 'testi non hanno una traduzione in {{language}}.',
    aumico_annual_report_translation_gaps_reassurance: 'L\'IA li traduce nello stile delle traduzioni già presenti in questo rapporto. In seguito le traduzioni possono essere controllate nella revisione o salvate direttamente.',
    aumico_annual_report_translation_done_title: 'Traduzione completata',
    aumico_annual_report_translation_done_count: '{{count}} testi sono stati tradotti in {{language}}.',
    aumico_annual_report_translation_done_question: 'Desidera rivedere la traduzione o salvarla direttamente?',
    aumico_annual_report_translation_done_legend_ai: 'Tradotto dall\'IA',
    aumico_annual_report_translation_done_legend_mapping: 'Traduzione standard',
    aumico_annual_report_translation_done_legend_heading: 'In modalità revisione:',
    aumico_annual_report_translation_done_legend_unmarked: 'I testi non evidenziati non sono modificabili.',
    aumico_annual_report_translation_legend_title: 'Legenda',
    aumico_annual_report_translation_done_legend_user: 'Modificato manualmente',
    aumico_annual_report_translation_action_review: 'Revisione',
    aumico_annual_report_translation_action_save_now: 'Salva ora',
    aumico_annual_report_translation_action_translate: 'Traduci con l\'IA',
    aumico_annual_report_translation_action_later: 'Più tardi',
    aumico_annual_report_translation_manage_title: 'Gestisci la traduzione',
    aumico_annual_report_translation_manage_text: 'Puoi esaminare le traduzioni di questa lingua nella revisione e correggerle una per una.',
    aumico_annual_report_translation_manage_review: 'Revisione',
    aumico_annual_report_translation_manage_undo: 'Annulla',
    aumico_annual_report_translation_manage_refresh: 'Cerca nuove lacune',
    aumico_annual_report_translation_manage_no_gaps: 'Nessuna nuova lacuna trovata.',
    aumico_annual_report_translation_undo_title: 'Annulla la traduzione',
    aumico_annual_report_translation_undo_text: 'Tutte le traduzioni di questa lingua verranno eliminate, comprese le tue correzioni.',
    aumico_annual_report_translation_undo_confirm: 'Elimina',
    aumico_annual_report_translation_part_template: 'Bilancio e conto economico',
    aumico_annual_report_translation_part_accounts: 'Conti',
    aumico_annual_report_translation_part_notes: 'Allegato',
    aumico_annual_report_translation_part_aop: 'Destinazione dell\'utile',
    aumico_annual_report_translation_part_ems: 'Prospetto del capitale proprio',
    aumico_annual_report_translation_part_cashflow: 'Rendiconto finanziario',
    aumico_annual_report_translation_part_complementary: 'Rapporti complementari',
    aumico_annual_report_translation_running: '{{count}} testi vengono tradotti in {{language}}.',
    aumico_annual_report_translation_running_progress: '{{translated}} testi su {{total}} tradotti.',
    aumico_annual_report_translation_running_hint: 'Di solito richiede meno di un minuto. Lascia aperta la finestra.',
    aumico_annual_report_translation_failed: 'La traduzione non è riuscita. Nel rapporto non è cambiato nulla.',
    aumico_annual_report_translation_save: 'Salva',
    aumico_annual_report_translation_edit_title: 'Correggi la traduzione',
    aumico_annual_report_translation_edit_source: 'Lingua del rapporto',
    aumico_annual_report_translation_edit_target: 'Traduzione',
    aumico_annual_report_translation_edit_empty: 'Il campo non può essere vuoto.',
    aumico_annual_report_translation_manage: 'Gestisci la traduzione',
    aumico_annual_report_translation_sealed_tooltip: 'Rimuovi il sigillo dal rapporto per modificare la traduzione.',
    aumico_company_update_banner_sealed_tooltip: 'Dissigilla il rapporto per applicare le modifiche.',
    aumico_general_information_current_period: 'Periodo attuale',
    aumico_general_information_balance_sheet: 'Bilancio',
    aumico_general_information_balance_sheet_date: 'Data del bilancio',
    aumico_general_information_income_statement: 'Conto economico',
    aumico_general_information_previous_period: 'PPeriodo precedente',
    aumico_general_information_load_previous_data_from_aumico: 'Carica i dati precedenti da Aumico',
    aumico_general_information_select_report: 'Seleziona il rapporto',
    aumico_general_information_choose_dataset_tooltip_text:
        'Puoi scegliere un insieme di dati da un rapporto esistente',
    cpmm_projects_overview_col_report_type: 'Tipo di rapporto',
    aumico_annual_report_general_information_has_previous_data: 'Ha dati precedenti',
    aumico_create_project_dialog_select_report_type_description: 'Tipo di rapporto',
    aumico_create_project_dialog_select_report_type_input_placeholder: 'Seleziona un tipo di rapporto',
    aumico_backend_errors_project_deletion_due_to_dependency: 'Questo rapporto non può essere eliminato perché è utilizzato come periodo precedente per altri rapporti',
    aumico_bulk_delete_dependency_warning_description:
        'I seguenti progetti sono utilizzati come periodo precedente o sono stati copiati per altri rapporti. Vuoi eliminarli comunque?',
    aumico_bulk_delete_dependency_warning_proceed: 'Sì, elimina comunque',
    aumico_bulk_delete_dependency_warning_skip: 'No, salta questi',
    aumico_organization_settings_mandate_management_configuration_mandate_and_tasks_toggle_tooltip: 'Se disattivato, la gestione dei mandati e il workflow di chiusura saranno disattivati.',
    cpmm_projects_overview_col_label: 'Etichetta',
    aumico_companies_form_label_label: 'Etichetta',
    aumico_companies_table_label_company_label: 'Etichetta',
    aumico_reports_unsaved_changes_warning_dialog_discard_and_delete_project: 'Ignora le modifiche e elimina il progetto',
    aumico_reports_unsaved_changes_and_delete_project_warning_dialog_content: 'Hai modifiche non salvate nel rapporto. Se procedi, queste modifiche andranno perse. Sei sicuro di voler eliminare il progetto?',
    aumico_annual_report_mapping_page_can_not_navigate_to_grouping_and_masking_dialog_description: 'Non puoi navigare verso la finestra di dialogo di raggruppamento e mascheramento perché mancano i dati richiesti.',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_title: 'Passa al trasferimento automatico del risultato annuale',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_description: 'Vuoi passare al trasferimento automatico del risultato annuale per questo progetto? Tutti i dati del risultato annuale precedentemente inseriti verranno eliminati e sostituiti dai dati trasferiti automaticamente.',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_info_text: 'Il tuo account non verrà eliminato, ma solo rimosso da questo elemento di bilancio.',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_confirm: 'Rimuovi & attiva',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_cancel: 'No, annulla',
    aumico_templates_annual_profit_account_badge_text: 'Profitto Trasferito',
    aumico_report_previous_annual_profit_manual_entry_title: 'Modificare manualmente il risultato dell\'anno precedente',
    aumico_report_previous_annual_profit_manual_entry_submit_text: 'Aggiungi manualmente',
    aumico_report_previous_annual_profit_manual_entry_description: 'Il profitto alla data di riferimento non è stato trovato automaticamente - si prega di inserirlo manualmente.',
    aumico_report_previous_annual_profit_manual_entry_balance_date: 'Data di bilancio',
    aumico_report_previous_annual_profit_manual_entry_missing_profit_period: 'Risultato del periodo',
    aumico_report_previous_annual_profit_manual_entry_input_label: 'Inserisci il profitto manualmente',
    aumico_report_previous_annual_profit_manual_entry_input_placeholder: 'Aggiungi il profitto qui manualmente',
    aumico_templates_group_account_mapping_menu_edit_profit_manually: 'Modifica il profitto manualmente',
    aumico_annual_report_mapping_help_automatic_transfer_toggle_text: 'Attiva il trasferimento automatico dei risultati annuali',
    aumico_annual_report_print_options_colors_accordion_title: 'Colori',
    aumico_reports_print_color_reset_to_default_button: 'Ripristina predefiniti',
    aumico_projects_release_highlights_modal_title: 'Cosa c\'è di nuovo in Aumico?',
    aumico_projects_release_highlights_modal_next: 'Successivo',
    aumico_projects_release_highlights_modal_previous: 'Precedente',
    aumico_projects_release_highlights_modal_got_it: 'Capito',
    aumico_project_reports_switch_to_automatic_transfer_of_annual_result_confirmation_description: 'Se procedi, tutti i dati del risultato annuale precedentemente inseriti verranno eliminati e sostituiti dai dati trasferiti automaticamente. Vuoi continuare?',
    aumico_templates_group_account_mapping_mapping_to_profit_fli_disabled_tooltip_text: 'Il valore viene trasferito automaticamente dal conto economico. Non è possibile mappare un altro conto.',
    aumico_annual_report_cash_flow_system_value_tooltip: 'Sistema',
    aumico_pm_tasks_filter_apply: 'Applica',
    aumico_ai_fixed_badge: '✅ Corretto con AI',
    aumico_reports_error_profit_fli_not_found: 'Il conto economico non è stato trovato. Si prega di verificare le impostazioni di mappatura per impostarlo.',

    // MFA - Setup Flow
    aumico_mfa_loading: 'Caricamento...',
    aumico_mfa_setup_step1_title: 'Configura l\'autenticazione a due fattori',
    aumico_mfa_setup_step1_description: 'Scansiona il codice QR con la tua app di autenticazione (es. Google Authenticator, Authy).',
    aumico_mfa_setup_step1_manual_key: 'Oppure inserisci questa chiave manualmente:',
    aumico_mfa_setup_step1_countdown_label: 'Nuovo codice tra:',
    aumico_mfa_setup_step1_continue_button: 'Avanti',
    aumico_mfa_setup_step2_title: 'Verifica la tua app',
    aumico_mfa_setup_step2_description: 'Inserisci il codice a 6 cifre dalla tua app di autenticazione per confermare la configurazione.',
    aumico_mfa_setup_step2_code_label: 'Codice di autenticazione',
    aumico_mfa_setup_step2_code_placeholder: 'Inserisci codice a 6 cifre',
    aumico_mfa_setup_step2_verify_button: 'Avanti',
    aumico_mfa_setup_step3_title: 'Salva i tuoi codici di backup',
    aumico_mfa_setup_step3_description: 'Salva questi codici di backup in modo sicuro. Possono essere utilizzati per accedere al tuo account se perdi il dispositivo.',
    aumico_mfa_setup_step3_download_button: 'Scarica',
    aumico_mfa_setup_step3_continue_button: 'Continua',
    aumico_mfa_setup_error_initiate: 'Inizializzazione 2FA fallita. Riprova.',
    aumico_mfa_setup_error_invalid_code: 'Codice non valido. Controlla la tua app di autenticazione.',
    aumico_mfa_setup_stepper_scan_qr: 'Scansiona QR',
    aumico_mfa_setup_stepper_verify: 'Verifica',
    aumico_mfa_setup_stepper_backup_codes: 'Codici di backup',
    aumico_mfa_setup_step1_app_hint: 'Google Authenticator, Authy o qualsiasi app compatibile TOTP',
    aumico_mfa_setup_step2_back_button: 'Indietro',
    aumico_mfa_setup_step2_hint: 'Inserisci il codice di verifica a 6 cifre',
    aumico_mfa_setup_footer: 'La tua organizzazione richiede il 2FA. Questa è una configurazione una tantum.',

    // MFA - Verify Flow (Login)
    aumico_mfa_verify_title: 'Autenticazione a due fattori',
    aumico_mfa_verify_description: 'Inserisci il codice a 6 cifre dalla tua app di autenticazione.',
    aumico_mfa_verify_code_label: 'Codice di autenticazione',
    aumico_mfa_verify_code_placeholder: 'Inserisci codice a 6 cifre',
    aumico_mfa_verify_backup_description: 'Inserisci uno dei tuoi codici di backup.',
    aumico_mfa_verify_backup_code_label: 'Codice di backup',
    aumico_mfa_verify_backup_code_placeholder: 'Inserisci codice di backup',
    aumico_mfa_verify_submit_button: 'Verifica',
    aumico_mfa_verify_use_backup_code: 'Usa un codice di backup',
    aumico_mfa_verify_use_totp_code: 'Usa l\'app di autenticazione',
    aumico_mfa_verify_error_invalid_code: 'Codice non valido. Riprova.',

    // MFA - Organization Settings
    aumico_mfa_org_toggle_title: 'Autenticazione a due fattori',
    aumico_mfa_org_toggle_description: 'Richiedi a tutti gli utenti della tua organizzazione di configurare l\'autenticazione a due fattori.',
    aumico_mfa_org_toggle_description_detail: 'Il 2FA aumenta la sicurezza richiedendo sia una password che un codice di verifica basato sul tempo generato dall\'app Google Authenticator.',
    aumico_mfa_org_status_enabled: '2FA abilitato',
    aumico_mfa_org_status_disabled: '2FA disabilitato',
    aumico_mfa_org_enable_button: 'Abilita 2FA',
    aumico_mfa_org_disable_button: 'Disabilita 2FA',
    aumico_mfa_org_users_title: 'Stato MFA degli utenti',
    aumico_mfa_org_users_col_name: 'Nome',
    aumico_mfa_org_users_col_email: 'Email',
    aumico_mfa_org_users_col_status: 'Stato MFA',
    aumico_mfa_org_users_col_actions: 'Azioni',
    aumico_mfa_org_users_col_enabled_at: 'Attivato il',
    aumico_mfa_org_users_status_complete: 'Attivato',
    aumico_mfa_org_users_status_pending: 'Non attivato',
    aumico_mfa_org_users_reset_button: 'Reimposta MFA',
    aumico_mfa_org_notification_success_title: 'Successo',
    aumico_mfa_org_notification_error_title: 'Errore',
    aumico_mfa_org_enable_success: '2FA è stato abilitato per la tua organizzazione.',
    aumico_mfa_org_enable_error: 'Abilitazione 2FA fallita. Riprova.',
    aumico_mfa_org_disable_success: '2FA è stato disabilitato per la tua organizzazione.',
    aumico_mfa_org_disable_error: 'Disabilitazione 2FA fallita. Riprova.',
    aumico_mfa_org_reset_user_success: 'MFA è stato reimpostato per l\'utente.',
    aumico_mfa_org_reset_user_error: 'Reimpostazione MFA fallita. Riprova.',
    aumico_mfa_org_enforce_button: 'Imponi l\'autenticazione a 2 fattori',
    aumico_mfa_org_enforce_button_tooltip: 'Attenzione: verrà disconnesso subito\nper configurare l\'autenticazione a due fattori.',
    aumico_mfa_org_disable_toggle_tooltip: 'La disattivazione reimposta la configurazione MFA di tutti gli utenti.',
    aumico_ai_settings_loading: 'Caricamento delle impostazioni IA...',
    aumico_ai_settings_description: 'Attiva o disattiva le funzioni IA per la tua organizzazione.',
    aumico_ai_settings_master_title: 'Attiva le funzioni IA',
    aumico_ai_settings_master_description: 'Attiva tutte le funzioni IA per la tua organizzazione. Prima accetti le condizioni d\'uso.',
    aumico_ai_settings_master_agb_empty: '(Nessun testo delle condizioni salvato. Contatta il tuo amministratore.)',
    aumico_ai_settings_daily_usage: 'Consumati oggi',
    aumico_ai_settings_monthly_usage: 'Consumati questo mese',
    aumico_ai_settings_tokens: 'token',
    aumico_ai_settings_title: 'Funzioni IA',
    aumico_ai_settings_status_active: 'Attivo',
    aumico_ai_settings_status_inactive: 'Inattivo',
    aumico_ai_settings_hero_headline: 'Un aiuto intelligente per la tua contabilità',
    aumico_ai_settings_hero_sub: 'Le funzioni IA analizzano i tuoi dati direttamente nell\'applicazione. Elaborati in modo sicuro nell\'UE, mai usati per addestrare il modello.',
    aumico_ai_settings_usage_title: 'Consumo di token',
    aumico_ai_settings_master_short_description: 'Attiva tutte le funzioni IA per la tua organizzazione.',
    aumico_ai_settings_agents_title: 'Funzioni IA disponibili',
    aumico_ai_settings_wip_label: 'In sviluppo',
    aumico_ai_settings_wip_headline: 'Ampliamo aumico IA di continuo',
    aumico_ai_settings_wip_text: 'L\'infrastruttura è pronta. Stiamo investendo molto in nuove funzioni.',
    aumico_ai_settings_agent_available: 'Disponibile',
    aumico_ai_settings_agent_soon: 'In preparazione',
    aumico_ai_settings_agent_more_title: 'Altre funzioni in arrivo',
    aumico_ai_settings_agent_more_text: 'Le nuove funzioni compaiono qui non appena sono disponibili. Resta aggiornato.',
    aumico_ai_settings_feature_closing_title: 'Processo di chiusura con l\'IA',
    aumico_ai_settings_feature_closing_text: 'Ti accompagna nella chiusura annuale: legge i tuoi giustificativi, li assegna ai conti e propone le riconciliazioni.',
    aumico_ai_settings_feature_translate_title: 'Tradurre il rapporto',
    aumico_ai_settings_feature_translate_text: 'Traduce un rapporto in un\'altra lingua.',
    aumico_ai_settings_feature_datev_title: 'Riparare l\'importazione DATEV',
    aumico_ai_settings_feature_datev_text: 'Ripara la gerarchia dei conti di un\'importazione DATEV.',
    aumico_ai_settings_resets_daily: 'Si azzera a mezzanotte',
    aumico_ai_settings_resets_monthly: 'Si azzera il 1° del mese',
    aumico_ai_settings_info_blocked: 'Quando un limite è raggiunto, le ulteriori richieste IA vengono bloccate automaticamente.',
    aumico_ai_settings_info_agb: 'Quando le condizioni vengono aggiornate, le accetti di nuovo.',
    aumico_ai_settings_load_error: 'Impossibile caricare le impostazioni IA.',
    aumico_ai_settings_notification_success_title: 'Impostazione salvata',
    aumico_ai_settings_notification_enabled: 'Le funzioni IA sono state attivate.',
    aumico_ai_settings_notification_disabled: 'Le funzioni IA sono state disattivate.',
    aumico_ai_settings_notification_error_title: 'Errore',
    aumico_ai_settings_notification_error: 'Impossibile salvare l\'impostazione.',
    aumico_ai_settings_notification_version_changed: 'Le condizioni d\'uso sono state aggiornate. Leggi e accetta le nuove condizioni.',
    aumico_ai_settings_acceptance_intro: 'Leggi attentamente le seguenti condizioni d\'uso prima di attivare le funzioni IA:',
    aumico_ai_settings_acceptance_disclaimer: 'Cliccando su «Accetta e attiva» confermi di aver letto le condizioni e di acconsentire al trattamento dei dati. Puoi disattivare le funzioni IA in qualsiasi momento.',
    aumico_ai_settings_acceptance_accept: 'Accetta e attiva',
    aumico_ai_settings_acceptance_decline: 'Rifiuta',

    // MFA - Navigation
    aumico_reports_organization_navigation_2fa: 'Autenticazione a 2 fattori',

    // CCR – Riserve da apporti in capitale (KER)
    aumico_annual_report_ccr_description: 'Riserve da apporti in capitale',
    aumico_annual_report_ccr_beginning_of_year: "Totale riserve da apporti in capitale all'inizio dell'esercizio",
    aumico_annual_report_ccr_end_of_year: "Totale riserve da apporti in capitale alla fine dell'esercizio",
    aumico_annual_report_ccr_select_account: 'Seleziona conto patrimonio netto',
    aumico_annual_report_ccr_add_new_item: 'Aggiungi nuovo elemento',
    aumico_annual_report_ccr_enter_text: 'Inserisci testo',
    aumico_annual_report_ccr_enter_value: 'Inserisci importo',
    aumico_annual_report_ccr_toggle_show: 'Mostra riserve da apporti in capitale',
    aumico_annual_report_ccr_toggle_hide: 'Nascondi riserve da apporti in capitale',
    aumico_annual_report_ccr_diff_prior: 'Differenza anno precedente',
    aumico_annual_report_ccr_diff_cur: 'Differenza aperta anno corrente',
    aumico_annual_report_ccr_add_comment: 'Aggiungi commento',
    aumico_annual_report_ccr_remove_comment_confirm: 'Vuoi davvero rimuovere il commento? Tutto il contenuto della nota a piè di pagina verrà eliminato.',

    // REV-20899: Reclassification feature
    aumico_grouping_masking_reclass_column_header_cy: 'Riclassificazione AC',
    aumico_grouping_masking_reclass_column_header_py: 'Riclassificazione AP',
    aumico_grouping_masking_reclass_py_lock_tooltip: "Blocca riclassificazioni dell'anno precedente",
    aumico_grouping_masking_reclass_py_unlock_tooltip: "Sblocca riclassificazioni dell'anno precedente",
    aumico_grouping_masking_reclass_py_lock_state_locked: 'Bloccato',
    aumico_grouping_masking_reclass_py_lock_state_editable: 'Modificabile',
    aumico_grouping_masking_reclass_modal_title: 'Riclassificazione',
    aumico_grouping_masking_reclass_modal_subtitle_source: 'Conto sorgente',
    aumico_grouping_masking_reclass_modal_subtitle_balance: 'Saldo',
    aumico_grouping_masking_reclass_modal_period_cy: 'Anno corrente',
    aumico_grouping_masking_reclass_modal_period_py: 'Anno precedente',
    aumico_grouping_masking_reclass_modal_incoming_section: 'Riclassificazioni in entrata',
    aumico_grouping_masking_reclass_modal_outgoing_section: 'Riclassificazioni in uscita',
    aumico_grouping_masking_reclass_modal_amount_label: 'Importo',
    aumico_grouping_masking_reclass_modal_amount_placeholder: '0,00',
    aumico_grouping_masking_reclass_modal_target_label: 'Conto destinazione',
    aumico_grouping_masking_reclass_modal_target_placeholder: 'Seleziona un conto...',
    aumico_grouping_masking_bulk_action_delete: 'Elimina',
    aumico_grouping_masking_reclass_account_badge_tooltip: 'Conto di riclassificazione',
    aumico_grouping_masking_reclass_generated_account_name_prefix: 'Riclassificazione da',
    aumico_grouping_masking_reclass_generated_account_name_to: 'a',
    aumico_grouping_masking_reclass_delete_account_confirm_text:
        'Su questo conto esistono riclassificazioni. Vuoi davvero eliminare il conto incluse tutte le riclassificazioni assegnate?',
    aumico_grouping_masking_reclass_delete_account_confirm_action: 'Elimina conto e riclassificazioni',
    aumico_grouping_masking_reclass_modal_description_label: 'Motivo',
    aumico_grouping_masking_reclass_modal_description_optional: 'opzionale',
    aumico_grouping_masking_reclass_modal_description_placeholder: 'es. Riclassificazione secondo requisito di revisione',
    aumico_grouping_masking_reclass_modal_add_entry: 'Aggiungi riclassificazione',
    aumico_grouping_masking_reclass_modal_delete_entry: 'Elimina',
    aumico_grouping_masking_reclass_modal_new_account_button: 'Crea nuovo conto',
    aumico_grouping_masking_reclass_validation_amount_required:
        'Inserisci un importo diverso da 0. Sono ammessi importi negativi.',
    aumico_grouping_masking_reclass_validation_target_required: 'Seleziona un conto destinazione.',
    aumico_grouping_masking_reclass_validation_exceeds_balance:
        '⚠ L\'importo totale supera il saldo del conto. Il conto sorgente mostrerà un saldo negativo.',
    aumico_grouping_masking_reclass_validation_cross_side:
        '⚠ Riclassificazione tra attività e passività. Verifica se si tratta di una riclassificazione o di una scrittura di trasferimento.',
    aumico_grouping_masking_reclass_validation_duplicate_target: 'Più riclassificazioni verso lo stesso conto destinazione.',
    aumico_grouping_masking_reclass_new_account_modal_title: 'Crea nuovo conto',
    aumico_grouping_masking_reclass_new_account_number_label: 'Numero conto',
    aumico_grouping_masking_reclass_new_account_number_placeholder: 'es. 1099',
    aumico_grouping_masking_reclass_new_account_name_label: 'Nome conto',
    aumico_grouping_masking_reclass_new_account_name_placeholder: 'es. Conto di trasferimento',
    aumico_grouping_masking_reclass_new_account_fli_label: 'Seleziona FLI',
    aumico_grouping_masking_reclass_new_account_fli_placeholder: 'Seleziona FLI...',
    aumico_grouping_masking_reclass_new_account_save: 'Crea',
    aumico_grouping_masking_reclass_new_account_number_required: 'Inserisci un numero di conto.',
    aumico_grouping_masking_reclass_new_account_number_duplicate: 'Un conto con questo numero esiste già.',
    aumico_grouping_masking_reclass_new_account_name_required: 'Inserisci un nome conto.',
    aumico_grouping_masking_reclass_new_account_fli_required: 'Seleziona un FLI.',
    aumico_grouping_masking_reclass_new_target_choice_title: 'Nuova destinazione di riclassificazione',
    aumico_grouping_masking_reclass_new_target_choice_prompt: 'Che cosa vuoi creare?',
    aumico_grouping_masking_reclass_new_target_choice_account: 'Crea conto',
    aumico_grouping_masking_reclass_new_target_choice_group: 'Crea gruppo',
    aumico_grouping_masking_reclass_new_group_modal_title: 'Crea nuovo gruppo',
    aumico_grouping_masking_reclass_new_group_name_label: 'Nome del gruppo',
    aumico_grouping_masking_reclass_new_group_name_placeholder: 'ad es. Altri debiti',
    aumico_grouping_masking_reclass_new_group_fli_label: 'Seleziona FLI',
    aumico_grouping_masking_reclass_new_group_fli_placeholder: 'Scegli FLI...',
    aumico_grouping_masking_reclass_new_group_save: 'Crea',
    aumico_grouping_masking_reclass_new_group_name_required: 'Inserisci il nome del gruppo.',
    aumico_grouping_masking_reclass_new_group_fli_required: 'Seleziona un FLI.',
    aumico_grouping_masking_reclass_new_group_option_suffix: '(nuovo gruppo)',
    aumico_grouping_masking_reclass_new_group_name_exists:
        'Questa voce ha già un gruppo con questo nome. La riclassificazione verrà aggiunta a quel gruppo.',
    aumico_grouping_masking_reclass_conflicts_banner:
        'Ci sono {{count}} conflitto/i di riclassificazione non risolto/i. Clicca qui per risolverli.',
    aumico_grouping_masking_reclass_conflicts_show: 'Mostra conflitti',
    aumico_grouping_masking_reclass_conflicts_title: 'Conflitti',
    aumico_grouping_masking_reclass_conflicts_description:
        'I seguenti conti sono stati eliminati o modificati ma hanno ancora riclassificazioni aperte.',
    aumico_grouping_masking_reclass_conflicts_delete: 'Elimina',
    aumico_grouping_masking_reclass_conflicts_reassign: 'Riassegna',
    aumico_grouping_masking_reclass_preview_button: 'Specchio riclassificazioni',
    aumico_grouping_masking_reclass_preview_title: 'Specchio riclassificazioni',
    aumico_grouping_masking_reclass_preview_col_from: 'DA CONTO',
    aumico_grouping_masking_reclass_preview_col_to: 'A CONTO',
    aumico_grouping_masking_reclass_preview_col_cy: 'AC ({{currency}})',
    aumico_grouping_masking_reclass_preview_col_py: 'AP ({{currency}})',
    aumico_grouping_masking_reclass_preview_col_description: 'DESCRIZIONE',
    aumico_grouping_masking_reclass_preview_section_bs: 'Stato patrimoniale',
    aumico_grouping_masking_reclass_preview_section_is: 'Conto economico',
    aumico_grouping_masking_reclass_preview_footer_note: 'Tutte le riclassificazioni attive per questo bilancio annuale',
    aumico_grouping_masking_reclass_preview_close: 'Chiudi',
    aumico_grouping_masking_reclass_preview_export_pdf: 'Esporta PDF',
    aumico_grouping_masking_reclass_preview_empty: 'Nessuna riclassificazione disponibile.',
    aumico_grouping_masking_reclass_conflicts_back: 'Torna alla tabella',
    aumico_grouping_masking_reclass_conflicts_transactions: 'riclassificazione/i',
    aumico_grouping_masking_reclass_conflicts_total: 'Importo totale',
    aumico_grouping_masking_reclass_conflicts_cy: 'AC',
    aumico_grouping_masking_reclass_conflicts_py: 'AP',
    aumico_grouping_masking_reclass_conflicts_table_amount: 'Importo',
    aumico_grouping_masking_reclass_conflicts_table_source: 'Origine',
    aumico_grouping_masking_reclass_conflicts_table_target: 'Destinazione',
    aumico_grouping_masking_reclass_conflicts_confirm_delete:
        'Tutte le riclassificazioni di questo conto saranno eliminate definitivamente. Questa operazione non può essere annullata. Continuare?',
    aumico_grouping_masking_reclass_tab_indicator_tooltip: '{{count}} conflitto/i di riclassificazione non risolto/i',
    aumico_grouping_masking_disambiguation_modal_title: 'Seleziona conto',
    aumico_grouping_masking_disambiguation_modal_description:
        'Il conto {{accountNumber}} «{{accountName}}» appare più volte nei dati finanziari. Seleziona l\'istanza a cui applicare le riclassificazioni.',
    aumico_grouping_masking_disambiguation_modal_fli_label: 'FLI',
    aumico_grouping_masking_disambiguation_modal_row_no: 'Riga',
    aumico_grouping_masking_disambiguation_modal_closing_balance: 'Saldo finale',
    aumico_grouping_masking_disambiguation_modal_opening_balance: 'Saldo iniziale',
    aumico_grouping_masking_disambiguation_modal_select_button: 'Seleziona',
    // ── REV-21964 · SharePoint sync report + upstream states ─────────────────────────────
    abcp_sync_run_status_pending: 'In attesa',
    abcp_sync_run_status_running: 'In corso',
    abcp_sync_run_status_completed: 'Completata',
    abcp_sync_run_status_failed: 'Non riuscita',
    abcp_sync_refused_closing_sealed: 'La chiusura è sigillata. Non vengono più accettati documenti.',
    abcp_sync_refused_already_running: 'Una sincronizzazione è già in corso.',
    abcp_sync_refused_no_bound_folders: 'Nessuna cartella è ancora collegata.',
    abcp_sync_started: 'Sincronizzazione avviata. Può continuare a lavorare.',
    abcp_sync_new_documents: '{{count}} nuovo documento',
    abcp_sync_new_documents_plural: '{{count}} nuovi documenti',
    abcp_sync_new_documents_none: 'Nessun nuovo documento',
    abcp_sync_problem_files: '{{count}} file non importato',
    abcp_sync_problem_files_plural: '{{count}} file non importati',
    abcp_sync_failed_folders: '{{count}} cartella illeggibile',
    abcp_sync_failed_folders_plural: '{{count}} cartelle illeggibili',
    abcp_sync_skips_truncated: 'Gli altri file non sono elencati qui singolarmente. Il numero dei nuovi documenti è completo.',
    abcp_sync_folder_failed: 'Impossibile leggere la cartella: {{folderPath}}',
    abcp_sync_never_run: 'Questa chiusura non è mai stata sincronizzata.',
    abcp_sync_skip_unsupported_type: 'Tipo di file non importato (solo PDF, Excel e Word)',
    abcp_sync_skip_already_imported: 'Già nella chiusura, invariato',
    abcp_sync_skip_download_failed: 'Impossibile scaricare il file',
    abcp_sync_skip_rejected_by_ingest: 'Rifiutato durante il caricamento',
    abcp_sync_skip_listing_capped: 'La cartella contiene più file di quanti ne legga un’esecuzione',
    abcp_sync_skip_too_large: 'File più grande di 32 MB',
    abcp_sync_skip_duplicate_content: 'Stesso contenuto di un documento esistente. Il nome vi è annotato.',
    abcp_upstream_state_deleted: 'Eliminato in SharePoint',
    abcp_upstream_state_moved_out: 'Spostato fuori dalla cartella collegata',
    abcp_upstream_state_replaced: 'Sostituito da una versione più recente',
    abcp_upstream_notice_assigned: 'Questo documento sostiene un conto e non è più al suo posto in SharePoint. Resta nella chiusura — la preghiamo di verificare.',
    abcp_upstream_notice_unassigned: 'Non è più al suo posto in SharePoint.',
    abcp_upstream_notice_replaced_assigned: 'SharePoint contiene una versione più recente di questo file. Questo documento sostiene un conto e resta invariato nella chiusura — la nuova versione si trova in entrata e deve essere assegnata da voi.',
    abcp_upstream_notice_replaced_unassigned: 'SharePoint contiene una versione più recente di questo file. Si trova in entrata.',
    abcp_upstream_action_not_relevant: 'Segna come non rilevante',
    abcp_upstream_alias_names: 'Altri nomi in SharePoint: {{names}}',
    abcp_upstream_changed_at: 'Rilevato il {{date}}',
    abcp_accounts_status_open: 'Aperto',
    abcp_accounts_status_difference: 'Differenza',
    abcp_accounts_status_reconciled: 'Riconciliato',
    abcp_accounts_col_number: 'N.',
    abcp_accounts_col_label: 'Descrizione',
    abcp_accounts_col_status: 'Stato',
    abcp_accounts_error: 'Impossibile caricare la panoramica dei conti.',
    abcp_accounts_empty: 'Nessun conto disponibile.',
    abcp_accounts_group_reconciled_tooltip: 'Tutti i conti di questo gruppo sono riconciliati',
    abcp_accounts_group_status_tooltip: '{{reconciled}} riconciliati, {{difference}} con differenza, {{open}} aperti',
    abcp_accounts_marked_tooltip: 'Contrassegnato',
    abcp_ledger_col_date: 'Data',
    abcp_ledger_col_text: 'Descrizione',
    abcp_ledger_col_account: 'Contropartita',
    abcp_ledger_col_account_label: 'Denominazione contropartita',
    abcp_ledger_col_vat: 'IVA',
    abcp_ledger_col_debit: 'Dare',
    abcp_ledger_col_credit: 'Avere',
    abcp_ledger_col_balance: 'Saldo',
    abcp_ledger_row_opening: 'Saldo iniziale',
    abcp_ledger_row_closing: 'Saldo finale',
    abcp_ledger_empty: 'Nessuna registrazione disponibile.',
    abcp_ledger_error: 'Non è stato possibile caricare le registrazioni.',
    abcp_ledger_foreign_rate: 'Cambio',
    abcp_ledger_foreign_unavailable: 'non disponibile',
    abcp_ledger_load_more: 'Carica altre',
    abcp_ledger_mark_comment: 'Commenta',
    abcp_ledger_mark_todo: 'Registra pendenza',
    abcp_ledger_line_missing_title: 'Registrazione non trovata',
    abcp_ledger_line_missing_body: 'La registrazione non è più nel libro mastro del conto. È stata modificata o eliminata nell’ERP.',
    abcp_settings_open: 'Impostazioni',
    abcp_closing_currency_missing: 'Per questa chiusura non è ancora definita una valuta. Impostala nelle impostazioni per vedere gli importi.',
    abcp_settings_title: 'Impostazioni chiusura annuale',
    abcp_settings_loading: 'Caricamento delle impostazioni …',
    abcp_settings_year: 'Esercizio corrente',
    abcp_settings_period_start: 'Inizio',
    abcp_settings_period_end: 'Fine',
    abcp_settings_currency: 'Valuta',
    abcp_settings_save: 'Salva',
    abcp_settings_cancel: 'Annulla',
    abcp_settings_reason_order: 'L’inizio deve precedere la fine.',
    abcp_settings_load_failed: 'Non è stato possibile caricare le impostazioni.',
    abcp_settings_save_failed: 'Non è stato possibile salvare le impostazioni.',

    // REV-21370 / REV-21364 / REV-21375 — Korrekturbuchungen (ADR-0015).
    //
    // FLAT keys, like `abcp_ledger_*` above: these are FE-owned and carry no dots. The nested
    // `abcp.*` form is for the DOTTED keys the backend supplies, which i18next can only resolve
    // out of an object (ADR-0015 §12).
    abcp_adjustments_filter_all: 'Tutte',
    abcp_adjustments_filter_released: 'Approvato',
    abcp_adjustments_filter_transferred: 'Trasferito',
    abcp_adjustments_filter_booked: 'Registrate',
        abcp_adjustments_filter_discarded: 'Scartato',
        abcp_adjustments_restore: 'Approva di nuovo',
        abcp_adjustments_restore_hint: 'La correzione scartata viene approvata di nuovo e ricompare negli elenchi di lavoro.',
        abcp_adjustments_discarded: 'Scartato',
        abcp_adjustments_discarded_hint: 'Ritirato — non eliminato. Conservato per la tracciabilità.',
        abcp_adjustments_edit_start: 'Modifica',
        abcp_adjustments_edit_save: 'Salva',
        abcp_adjustments_edit_cancel: 'Annulla',
    abcp_adjustments_fiscal_year: 'Esercizio',
    abcp_adjustments_fiscal_year_short: 'Es.',
    abcp_adjustments_fiscal_year_current: 'in corso',
    abcp_adjustments_new: 'Nuova registrazione',
    abcp_adjustments_transfer: 'Trasferisci',
    abcp_adjustments_row_actions: 'Azioni',
    abcp_adjustments_edit: 'Modifica',
    abcp_adjustments_discard: 'Scarta',
    abcp_adjustments_retry: 'Riprova',
    abcp_adjustments_col_state: 'Stato',
    abcp_adjustments_col_text: 'Descrizione',
    abcp_adjustments_col_debit: 'Dare',
    abcp_adjustments_col_credit: 'Avere',
    abcp_adjustments_col_amount: 'Importo',
    abcp_adjustments_col_pnl: 'P&L',
    abcp_adjustments_effect_increase: 'Aumenta l’utile',
    abcp_adjustments_effect_decrease: 'Riduce l’utile',
    abcp_adjustments_effect_none: 'Nessun effetto',
    abcp_adjustments_col_source: 'Origine',
    abcp_adjustments_col_date: 'Data',
    abcp_adjustments_state_released: 'Approvato',
        abcp_adjustments_state_proposed: 'Proposta',
        abcp_adjustments_state_proposed_hint: 'Proposto da un agente — non ancora approvato.',
        abcp_adjustments_not_found: 'Non trovato',
        abcp_adjustments_not_found_hint: 'Non trovato nel giornale importato dall´ERP. Non è un errore — la registrazione può ancora seguire.',
        abcp_adjustments_result_excluded: 'Non classificato',
        abcp_adjustments_result_excluded_hint: 'Un conto di questa registrazione manca nel piano dei conti. La registrazione è esclusa dal risultato.',
        abcp_adjustments_field_date: 'Data di registrazione',
        abcp_adjustments_field_date_hint: 'Per impostazione predefinita la data di chiusura. Modificabile entro l´esercizio.',
        abcp_adjustments_error_date_invalid: 'Inserire una data valida.',
        abcp_adjustments_error_date_outside_year: 'La data di registrazione deve rientrare nell´esercizio della chiusura.',
        abcp_adjustments_transfer_all_released: 'Trasferisci tutti gli approvati',
    abcp_adjustments_state_released_hint: 'Registrato e approvato — non ancora trasferito all´ERP.',
    abcp_adjustments_state_transferred: 'Trasferita',
    abcp_adjustments_state_transferred_hint: 'Trasferita all’ERP — non ancora confermata nel giornale.',
    abcp_adjustments_state_booked: 'Registrata',
    abcp_adjustments_state_booked_hint: 'Ritrovata nel giornale importato dall’ERP.',
    abcp_adjustments_source_user: 'Utente',
    abcp_adjustments_source_agent: 'Agent',
    abcp_adjustments_source_prior_year: 'EP',
    abcp_adjustments_ambiguous: 'Ambigua',
    abcp_adjustments_ambiguous_hint: 'Più registrazioni del giornale corrispondono — non si tira a indovinare. Scegliere quella giusta nella vista di dettaglio.',
    abcp_adjustments_ambiguity_title: 'Corrispondenza ambigua nel giornale',
    abcp_adjustments_ambiguity_hint: 'Più registrazioni del giornale coincidono in dare, avere, importo ed esercizio. Scegliere quella che documenta questa correzione — non si tira a indovinare.',
    abcp_adjustments_ambiguity_confirm: 'Usa questa registrazione come prova',
    abcp_adjustments_transfer_erp: 'Invia direttamente all’ERP',
    abcp_adjustments_transfer_erp_hint: 'Il software di contabilità ha un’interfaccia di scrittura',
    abcp_adjustments_transfer_manual: 'Segna come registrata manualmente',
    abcp_adjustments_transfer_manual_hint: 'Già inserita direttamente nell’ERP',
    abcp_adjustments_transfer_reason_no_write_api: 'Il software di contabilità collegato non ha un’interfaccia di scrittura. Usare l’esportazione CSV.',
    abcp_adjustments_transfer_reason_not_connected: 'Per questo mandato non è collegato alcun software di contabilità. Usare l’esportazione CSV.',
    abcp_adjustments_transfer_reason_reauth: 'Il collegamento al software di contabilità deve essere rinnovato.',
    abcp_adjustments_transfer_reason_unavailable: 'Il software di contabilità non è attualmente raggiungibile.',
    abcp_adjustments_transfer_reason_no_caller_context: 'Il trasferimento all’ERP non è possibile per questa via. Usare l’esportazione CSV.',
    abcp_adjustments_transfer_reason_vendor_rejected: 'Il software di contabilità ha rifiutato questa registrazione.',
    abcp_adjustments_result_provisional: 'Risultato provvisorio dell’esercizio',
    abcp_adjustments_result_provisional_hint: '· prima delle correzioni',
    abcp_adjustments_result_after: 'Risultato dell’esercizio dopo le correzioni',
    abcp_adjustments_result_impact: 'Effetto delle correzioni sul risultato',
    abcp_adjustments_total: 'Totale correzioni',
    abcp_adjustments_total_year: 'Totale es. {{year}}',
    abcp_adjustments_unclassified_note: '{{count}} correzione(i) riguardano un conto non ancora attribuito a una posizione — rientrano nel totale ma non nell’effetto sul risultato.',
    abcp_adjustments_empty: 'Nessuna correzione disponibile.',
    abcp_adjustments_empty_year: 'Nessuna correzione nell’es. {{year}}.',
    abcp_adjustments_no_hits: 'Nessuna correzione corrisponde a «{{term}}».',
    abcp_adjustments_error: 'Non è stato possibile caricare le correzioni.',
    abcp_adjustments_search_hits: '{{count}} risultato(i) per «{{term}}»',
    abcp_adjustments_search_reset: 'Reimposta la ricerca',
    abcp_adjustments_modal_create_title: 'Nuova correzione',
    abcp_adjustments_modal_edit_title: 'Modifica la correzione',
    abcp_adjustments_modal_account: 'Conto',
    abcp_adjustments_modal_submit: 'Registra',
    abcp_adjustments_modal_save: 'Salva',
    abcp_adjustments_modal_cancel: 'Annulla',
    abcp_adjustments_modal_no_accounts: 'Per questa chiusura non esiste ancora un piano dei conti. Aggiornare prima i dati contabili.',
    abcp_adjustments_field_text: 'Descrizione',
    abcp_adjustments_field_text_placeholder: 'p. es. spese bancarie Q4',
    abcp_adjustments_field_debit: 'Conto in dare',
    abcp_adjustments_field_credit: 'Conto in avere',
    abcp_adjustments_field_amount: 'Importo',
    abcp_adjustments_field_owner: 'Attribuzione (conto)',
    abcp_adjustments_field_owner_auto: 'Automatico (dare)',
    abcp_adjustments_field_choose: 'Scegliere',
    abcp_adjustments_field_remark: 'Osservazioni',
    abcp_adjustments_field_remark_placeholder: 'Osservazione facoltativa sulla correzione.',
    abcp_adjustments_field_vat: 'IVA',
    abcp_adjustments_preview: 'Registrazione',
    abcp_adjustments_preview_against: 'a',
    abcp_adjustments_detail_back: 'Indietro',
    abcp_adjustments_transfer_progress_title: 'Trasferimento ERP',
    abcp_adjustments_transfer_progress_connection: 'Connessione all’ERP',
    abcp_adjustments_transfer_progress_sending: 'Trasferimento di {{count}} correzione/i',
    abcp_adjustments_proof_pending: 'La prova di registrazione seguirà con «Aggiorna ERP».',
    abcp_adjustments_open_count: '{{count}} aperte',
    abcp_adjustments_account_empty: 'Nessuna correzione per l’es. {{year}}.',
    abcp_adjustments_error_same_accounts: 'Il conto in dare e quello in avere non possono essere identici.',
    abcp_adjustments_error_not_open: 'Solo le correzioni aperte possono essere modificate o eliminate.',
    abcp_adjustments_error_not_found: 'Questa correzione non è disponibile.',
    abcp_adjustments_error_discarded: 'Questa correzione è stata eliminata.',
    abcp_adjustments_error_not_ambiguous: 'Per questa correzione non è in sospeso alcuna scelta.',
    abcp_adjustments_error_candidate_unknown: 'Questa registrazione del giornale non è fra le candidate trovate.',
    abcp_adjustments_error_proof_taken: 'Questa registrazione del giornale documenta già un’altra correzione.',
    abcp_adjustments_error_prior_year: 'Questo esercizio non può essere modificato.',
    abcp_adjustments_error_accounts_equal: 'Il conto in dare e quello in avere non possono essere identici.',
    abcp_adjustments_error_account_unknown: 'Questo conto non fa parte del piano dei conti della chiusura.',
    abcp_adjustments_error_amount: 'L’importo deve essere maggiore di zero.',
    abcp_adjustments_error_text: 'La descrizione non può essere vuota.',
    abcp_adjustments_error_no_connection: 'Per questo mandato non è collegato alcun software di contabilità. Usare l’esportazione CSV.',
    abcp_adjustments_error_connection_ambiguous: 'Per questo mandato sono collegati più software di contabilità, quindi il trasferimento diretto non è possibile.',
    // REV-21367 — ABCP-Dokumentenhub (abcp-documents-hub).
    abcp_documents_filter_inbox: 'Da classificare',
    abcp_documents_filter_assigned: 'Classificato',
    abcp_documents_filter_not_relevant: 'Non pertinente',
    abcp_documents_col_filename: 'Nome del documento',
    abcp_documents_col_account: 'Conto',
    abcp_documents_col_confidence: 'Tipo di documento',
    abcp_documents_col_confidence_hint: 'Il tipo di documento riconosciuto dall’IA – nessun giudizio sulla scelta del conto.',
    abcp_documents_col_date: 'Data',
    abcp_documents_col_source: 'Origine',
    abcp_documents_col_status: 'Stato',
    abcp_documents_status_open: 'Aperto',
    abcp_documents_status_proposed: 'Proposta',
    abcp_documents_status_assigned: 'Assegnato',
    abcp_documents_source_upload: 'Upload',
    abcp_documents_source_sharepoint: 'Sharepoint',
    abcp_documents_source_email: 'E-mail',
    abcp_documents_search_placeholder: 'Cerca in tutti i documenti…',
    abcp_documents_upload: 'Upload',
    abcp_documents_sync_now: 'Sincronizza ora',
    abcp_documents_sync_settings: 'Impostazioni',
    abcp_documents_sync_disconnected: 'Non connesso',
    abcp_documents_account_select: 'Seleziona conto',
    abcp_documents_project_file: 'Pratica di progetto',
    abcp_documents_picker_search_placeholder: 'N. conto o descrizione…',
    abcp_documents_picker_project_file: 'Generale · Pratica di progetto',
    abcp_documents_picker_project_file_hint: 'Verbali assembleari, dichiarazione di completezza, contratti',
    abcp_documents_picker_empty: 'Nessun conto trovato',
    abcp_documents_picker_assignment: 'Attribuzione',
    abcp_documents_picker_back: 'Indietro',
    abcp_documents_validity_closing: 'Solo questa chiusura annuale',
    abcp_documents_validity_closing_hint: 'Il documento riguarda solo l’esercizio in corso',
    abcp_documents_validity_long_term_option: 'Valida a lungo termine',
    abcp_documents_validity_long_term_hint: 'Contratti, leasing, prestiti — resta valido per più anni',
    abcp_documents_proposal_accept: 'Conferma',
    abcp_documents_proposal_reject: 'Rifiuta',
    abcp_documents_not_relevant_mark: 'Non pertinente per questa chiusura — il documento viene conservato',
    abcp_documents_not_relevant_restore: 'Contrassegna di nuovo come pertinente per questa chiusura',
    abcp_documents_drop_title: 'Trascina qui i documenti',
    abcp_documents_drop_hint: 'Solo PDF · possibile caricamento multiplo',
    abcp_documents_validity_long_term: 'Pratica permanente — valida a lungo termine',
    abcp_documents_empty: 'Nessun documento in questo filtro.',
    abcp_documents_uploading: 'Caricamento in corso …',
    abcp_documents_error: 'Impossibile caricare i documenti.',
    abcp_documents_agent_notice_title: 'Assegnato automaticamente.',
    abcp_documents_agent_filter: 'Assegnato automaticamente in questa vista',
    abcp_documents_proposal_error: 'Operazione non riuscita — riprova.',
    abcp_documents_proposal_pending: 'Elaborazione in corso…',
    // REV-22302 — what the AI is doing with a document: the working indicator and its steps, the two
    // findings with their reasons, the picker action beside them, and the recognised Belegart.
    abcp_documents_ai_working: 'L’IA sta leggendo il giustificativo …',
    abcp_documents_ai_step_reading: 'Lettura del testo',
    abcp_documents_ai_step_kind: 'Riconoscimento del tipo di documento',
    abcp_documents_ai_step_scan: 'Verifica del file',
    abcp_documents_ai_step_value: 'Lettura del saldo',
    abcp_documents_proposal_source_content: 'Proposto in base al contenuto',
    abcp_documents_proposal_source_balance: 'Proposto in base al saldo',
    abcp_documents_proposal_source_both: 'Contenuto e saldo concordano',
    abcp_documents_proposal_balance_matches: 'Il saldo corrisponde',
    abcp_documents_proposal_balance_differs: 'Il saldo non corrisponde',
    abcp_documents_proposal_balance_not_checked: 'Saldo non verificato',
    abcp_documents_no_proposal: 'Nessuna proposta',
    abcp_documents_not_readable: 'Non leggibile',
    abcp_documents_account_choose: 'Scegli conto',
    abcp_documents_refusal_no_bound_account: 'Nessun conto del piano dei conti è collegato a questo tipo di documento.',
    abcp_documents_refusal_accounts_unclassified: 'I conti corrispondenti non sono ancora classificati.',
    abcp_documents_refusal_ambiguous: 'Più conti sono possibili – sceglierne uno.',
    abcp_documents_refusal_no_candidate: 'Nessun conto corrisponde al nome sul giustificativo – sceglierne uno.',
    abcp_documents_refusal_name_out_of_cut: 'Il nome sul giustificativo rimanda a un conto al di fuori di quelli possibili – sceglierne uno.',
    abcp_documents_refusal_name_unavailable: 'Il confronto dei nomi non è stato possibile – sceglierne uno.',
    abcp_documents_refusal_unclassified: 'L’IA non è riuscita a riconoscere il tipo di documento.',
    abcp_documents_refusal_no_text: 'Nel giustificativo non è stato trovato testo leggibile.',
    abcp_documents_refusal_model_unparseable: 'La risposta dell’IA non era valutabile.',
    abcp_documents_refusal_integrity_fail: 'Non è stato possibile leggere il giustificativo senza errori.',
    abcp_documents_refusal_not_extracted: 'Il giustificativo non era ancora stato letto quando l’IA ha cercato un conto.',
    abcp_documents_refusal_unknown: 'L’IA non ha proposto alcun conto.',
    abcp_documents_refusal_rejected: 'La proposta dell’IA è stata rifiutata.',
    abcp_documents_kind_bank_statement: 'Estratto conto bancario',
    abcp_documents_kind_securities_depot_statement: 'Estratto del deposito titoli',
    abcp_documents_kind_open_items_list: 'Elenco partite aperte',
    // REV-21368 — ABCP-Einzeldokument (abcp-document-detail). Flache Keys wie beim
    // Schwester-Pure-View abcp_documents_*. Bewusst EIGENE Keys statt Wiederverwendung, wo der
    // Prototyp der Einzelseite anders beschriftet als der Hub: 'Akzeptieren' statt 'Bestätigen',
    // 'Klasse' statt 'Kl.', 'Nur dieser Abschluss' statt 'Nur dieser Jahresabschluss'.
    // Umkehrbar geteilt bleiben abcp_documents_not_relevant_mark/_restore und _proposal_reject.
    abcp_document_detail_close: 'Indietro',
    abcp_document_detail_not_relevant_mark: 'Non rilevante',
    abcp_document_detail_not_relevant_restore: 'Segna come rilevante',
    abcp_document_detail_not_relevant_title: 'Questo documento non è rilevante.',
    abcp_document_detail_not_relevant_body: 'Segnalo come rilevante per poterlo assegnare a un conto.',
    abcp_document_detail_write_error: 'Non ha funzionato. Riprova.',
    abcp_documents_dialog_close: 'Chiudi',
    abcp_document_detail_proposal_title: 'Proposta dell’agente',
    abcp_document_detail_proposal_accept: 'Accetta',
    abcp_document_detail_assigned_title: 'Assegnato',
    abcp_document_detail_assigned_remove: 'Rimuovi assegnazione',
    abcp_document_detail_picker_title: 'Assegna conto',
    abcp_document_detail_picker_counter: '{{matched}} di {{total}}',
    abcp_document_detail_picker_search_placeholder: 'N. conto, denominazione o gruppo di conti…',
    abcp_document_detail_picker_empty: 'Nessun conto trovato.',
    abcp_document_detail_project_file: 'Pratica di progetto',
    abcp_document_detail_project_file_hint: 'Documenti generali di progetto',
    abcp_document_detail_validity_title: 'Validità',
    abcp_document_detail_validity_closing: 'Solo questa chiusura',
    abcp_document_detail_validity_long_term: 'A lungo termine',
    abcp_document_detail_interpretation_title: 'Valore del documento',
    abcp_document_interpretation_reason_quote_not_in_document: 'La riga citata non compare nel documento.',
    abcp_document_quote: '«{{quote}}»',
    abcp_document_quote_line: 'pagina {{page}}, riga {{line}}',
    abcp_document_detail_interpretation_sentence: '{{amount}} al {{asOfDate}} — dedotto dalla riga {{asOfDate}}',
    abcp_document_detail_interpretation_sentence_neutral: '{{amount}} al {{asOfDate}}',
    abcp_document_detail_interpretation_interpreting: 'Interpretazione in corso',
    abcp_document_detail_interpretation_no_value: 'Interpretato, nessun importo',
    abcp_document_detail_interpretation_none: 'Non interpretato',
    abcp_document_detail_interpretation_disabled: 'Interpretazione disattivata per questa organizzazione',
    // REV-22010 — the AI pipeline's document feedback: reading state, interpretation reason, proposal refusal, hub banner.
    abcp_document_reading_title: 'Lettura IA',
    abcp_document_reading_read: 'Letto dall\'IA',
    abcp_document_reading_state_pending: 'Non ancora letto dall\'IA',
    abcp_document_reading_state_reading: 'In lettura da parte dell\'IA',
    abcp_document_reading_state_deferred_daily_cap: 'Limite giornaliero raggiunto – verrà letto domani',
    abcp_document_reading_state_failed: 'L\'IA non è riuscita a leggere il giustificativo',
    abcp_document_reading_state_not_supported: 'Formato non letto dall\'IA (solo PDF)',
    abcp_document_reading_quality_structure_fail: 'Struttura delle pagine non rilevata completamente',
    abcp_document_reading_quality_findings: '{{count}} anomalia/e durante la lettura',
    abcp_document_detail_interpretation_limit_reached: 'Interpretazione in pausa',
    abcp_document_interpretation_reason_not_enabled: 'L\'interpretazione dei giustificativi non è attivata nelle impostazioni IA.',
    abcp_document_interpretation_reason_limit_reached: 'Il limite di token IA dell\'organizzazione è stato raggiunto.',
    abcp_document_interpretation_reason_closing_has_no_balance_sheet_date: 'La chiusura non ha ancora una data di bilancio.',
    abcp_document_interpretation_reason_reading_unusable: 'La versione letta del giustificativo è incompleta.',
    abcp_document_interpretation_reason_model_answer_unusable: 'La risposta dell\'IA non ha superato i controlli.',
    abcp_document_interpretation_reason_kind_not_supported: 'Per questo tipo di giustificativo non esiste una regola di interpretazione.',
    abcp_document_interpretation_reason_no_booking_owner: 'Il giustificativo non è assegnato a nessun conto.',
    abcp_document_interpretation_reason_statement_dates_unreadable: 'Le date dell\'estratto (saldo iniziale/finale) non sono leggibili.',
    abcp_document_interpretation_reason_statement_ends_before_balance_sheet_date: 'L\'estratto termina prima della data di bilancio.',
    abcp_document_interpretation_reason_amount_unreadable: 'L\'importo o la valuta non sono leggibili in modo univoco.',
    abcp_document_proposal_refusal_title: 'Nessuna proposta di conto',
    abcp_document_proposal_refusal_no_account_for_kind: 'Nel piano dei conti nessun conto è associato a questo tipo di giustificativo.',
    abcp_document_proposal_refusal_accounts_not_classified: 'I conti corrispondenti non sono ancora classificati.',
    abcp_document_proposal_refusal_several_accounts_match: 'Più conti sono possibili – sceglierne uno.',
    abcp_documents_ai_disabled_mapping: 'L\'assegnazione dei giustificativi tramite IA non è attivata per la vostra organizzazione. I giustificativi non ricevono una proposta di conto.',
    abcp_documents_ai_disabled_interpretation: 'L\'interpretazione dei giustificativi tramite IA non è attivata per la vostra organizzazione. I giustificativi non ricevono un valore.',
    abcp_documents_ai_disabled_both: 'L\'assegnazione e l\'interpretazione dei giustificativi tramite IA non sono attivate per la vostra organizzazione.',
    abcp_documents_ai_disabled_action: 'Apri impostazioni IA',
    abcp_documents_ai_disabled_contact_admin: 'Il tuo amministratore può attivare l’IA nelle impostazioni dell’organizzazione.',
    abcp_document_preview_unsupported: 'Per questo formato di file non è disponibile un’anteprima.',
    abcp_document_preview_unsupported_hint: 'Il documento è archiviato invariato nella chiusura.',
    abcp_document_preview_missing: 'Anteprima non ancora disponibile.',
    abcp_document_preview_missing_hint: 'Il documento è in fase di verifica e comparirà qui in seguito.',
    abcp_document_detail_error: 'Impossibile caricare il documento.',    // REV-21361 — involucro del dettaglio del conto (abcp-account-workspace)
    // REV-21363 — geteilte Vorschau (abcp-document-preview), Konto-Dokumentbereich
    // (abcp-account-documents) und geteiltes Upload-Modal (abcp-upload-modal). Flache Keys wie bei
    // den Schwester-Pure-Views. Der Augen-Tooltip des Konto-Bereichs ist bewusst KEIN eigener Key:
    // er teilt sich abcp_documents_not_relevant_mark mit Hub und Einzelseite — gleiche Handlung,
    // gleicher Satz. ⚠️ Die Modal-Copy sagt PDF, nicht "PDF oder Bild": der Ingest ist PDF-only
    // (ADR-0009 §12), der Prototyp ist an dieser Stelle überholt.
    abcp_document_preview_error: 'Non è stato possibile caricare l’anteprima.',
    abcp_account_documents_error: 'Non è stato possibile caricare i documenti.',
    abcp_account_documents_upload: 'Carica documento',
    abcp_account_documents_dropzone_title: 'Trascina qui i file',
    abcp_account_documents_dropzone_or: 'oppure',
    abcp_account_documents_dropzone_pick: 'Seleziona file',
    abcp_upload_modal_title: 'Carica documenti',
    abcp_upload_modal_close: 'Chiudi',
    abcp_upload_modal_dropzone: 'Trascina qui i file',
    abcp_upload_modal_hint: 'Solo PDF · max. {{max}}',
    abcp_upload_modal_pick: 'Seleziona file',
    abcp_upload_modal_selected: 'File selezionati',
    abcp_upload_modal_remove: 'Rimuovi dalla selezione',
    abcp_upload_modal_rejected_type: 'Non è un PDF — non verrà caricato.',
    abcp_upload_modal_rejected_size: 'Troppo grande (max. {{max}}) — non verrà caricato.',
    abcp_upload_modal_failures: 'Non caricato',
    abcp_upload_modal_progress: 'Caricamento dei documenti…',
    abcp_upload_modal_cancel: 'Annulla',
    abcp_upload_modal_submit: 'Carica documenti',
    abcp_workspace_pane_kind_ledger: 'Libro mastro del conto',
    abcp_workspace_pane_kind_documents: 'Documenti',
    abcp_workspace_pane_kind_comments: 'Commenti',
    abcp_workspace_pane_kind_todos: 'Pendenze',
    abcp_workspace_pane_kind_adjustments: 'Scritture di rettifica',
    abcp_workspace_pane_kind_activity_log: 'Registro attività',
    abcp_workspace_document_balance: 'Giustificativo',
    abcp_workspace_ai_as_of: 'al {{date}}',
    abcp_workspace_ai_refused: 'Nessun valore letto',
    abcp_workspace_ai_open: 'Ancora nessun valore',
    abcp_workspace_ai_reconciling: 'Riconciliazione in corso …',
    abcp_workspace_ai_reconciling_step: 'Il controllo di chiusura verifica il conto',
    abcp_workspace_ai_not_used: 'Giustificativo letto, ma non utilizzato per la chiusura',
    abcp_workspace_ai_open_missing: 'Giustificativo mancante: {{kind}}',
    abcp_workspace_ai_open_date_mismatch: 'Data del giustificativo non conforme: {{kind}}',
    abcp_workspace_ai_open_value_pending: 'Valore non ancora letto: {{kind}}',
    // REV-22005 — the hand-entered document balance and the account-state write refusals. TOP-level
    // on purpose: the account page translates the backend messageKey with a bare `t(key)`.
    abcp_workspace_document_balance_manual: 'inserito manualmente',
    abcp_error_review_flag_invalid: 'Indicare un motivo (al massimo 500 caratteri).',
    abcp_error_document_balance_invalid: 'Il valore del giustificativo non è valido.',
    abcp_error_document_balance_currency_mismatch: 'Il valore del giustificativo deve essere inserito nella valuta della chiusura.',
    abcp_error_closing_currency_missing: 'Per questa chiusura non è definita alcuna valuta. Impostala prima nelle impostazioni.',
    abcp_error_account_state_unknown_account: 'Questo conto non fa parte di questa chiusura.',
    abcp_error_account_state_write_failed: 'Non è stato possibile salvare la modifica. Riprovare più tardi.',
    abcp_workspace_pane_add: 'Aggiungi area',
    abcp_workspace_pane_empty: 'Per quest\'area non ci sono ancora contenuti.',
    abcp_workspace_review_mark: 'Contrassegna per revisione',
    abcp_workspace_review_marked: 'Contrassegnato per revisione',
    abcp_workspace_back: 'Indietro',
    abcp_workspace_amount: 'Importo',
    abcp_workspace_reference: 'Riferimento',
    abcp_workspace_confirm: 'Conferma',
    abcp_workspace_cancel: 'Annulla',
    abcp_workspace_error: 'Non è stato possibile caricare i dettagli del conto.',
    abcp_workspace_review_dialog_title: 'Contrassegna per revisione',
    abcp_workspace_review_dialog_account: 'Conto {{number}} · {{name}}',
    abcp_workspace_review_dialog_question: 'Che cosa deve verificare il revisore?',
    abcp_workspace_review_dialog_placeholder:
        'ad es. giustificativo mancante — richiederlo esternamente o è accettabile? Si prega di controfirmare la posizione.',
    abcp_workspace_review_dialog_hint:
        'Il commento appare direttamente sul conto per il revisore. Lo stato di elaborazione rimane invariato.',
    abcp_workspace_review_dialog_confirm: 'Contrassegna',
    // REV-21366 — ABCP activity log (pure view)
    abcp_activity_count: 'Attività',
    abcp_activity_count_plural: 'Attività',
    abcp_activity_actor_unknown: 'Sconosciuto',
    abcp_activity_load_more: 'Carica altre',
    abcp_activity_empty: 'Nessuna attività disponibile.',
    abcp_activity_error: 'Non è stato possibile caricare le attività.',
    // REV-21360 — ABCP closing workspace header (pure view)
    aumico_abcp_header_erp_refresh: 'Aggiorna ERP',
    aumico_abcp_header_tab_accounts: 'Conti',
    aumico_abcp_header_tab_documents: 'Documenti',
    aumico_abcp_header_tab_adjustments: 'Scritture di rettifica',
    aumico_abcp_header_tab_open_items: 'Pendenze',
    aumico_abcp_header_tab_comments: 'Commenti',
    aumico_abcp_header_crumb_account: 'Conto {{number}}',
    aumico_abcp_header_search_accounts: 'Cerca in tutti i conti…',
    aumico_abcp_header_search_documents: 'Cerca in tutti i documenti…',
    aumico_abcp_header_search_adjustments: 'Cerca in tutte le scritture…',
    aumico_abcp_header_search_open_items: 'Cerca in tutte le pendenze…',
    aumico_abcp_header_search_comments: 'Cerca in tutti i commenti…',
    aumico_abcp_header_error: 'Non è stato possibile caricare i dati di chiusura.',    // REV-21057 — SharePoint "Ordner hinzufügen" (aumico-integration-sharepoint-folders)
    // REV-21057 — SharePoint "Ordner hinzufügen" (aumico-integration-sharepoint-folders)
    aumico_integration_card_beta: 'BETA',
    aumico_integration_card_beta_tooltip:
        'Beta: stiamo ancora validando questa integrazione con i primi clienti. Puoi già utilizzarla – il tuo feedback ci aiuta a migliorarla.',
    aumico_integration_sharepoint_title: 'Aggiungi cartella',
    aumico_integration_sharepoint_description:
        'Collega il tuo account Microsoft 365 per selezionare cartelle da SharePoint o OneDrive per la chiusura. aumico ottiene accesso in sola lettura.',
    aumico_integration_sharepoint_connect: 'Connetti con Microsoft 365',
    aumico_integration_sharepoint_connecting: 'Connessione in corso …',
    aumico_integration_sharepoint_connected_banner: 'Connesso',
    aumico_integration_sharepoint_read_only: 'accesso in sola lettura',
    aumico_integration_sharepoint_include_subfolders: 'incl. sottocartelle',
    aumico_integration_sharepoint_add_folder: 'Aggiungi cartella',
    aumico_integration_sharepoint_add_folder_hint: 'Aggiungi la cartella che contiene i documenti di questa chiusura.',
    aumico_integration_sharepoint_remove: 'Rimuovi',
    aumico_integration_sharepoint_error: 'Connessione a Microsoft 365 non riuscita. Riprova.',
    aumico_integration_sharepoint_no_site: 'Nessun SharePoint trovato per questo account Microsoft. Verifica che l\'account abbia una licenza SharePoint oppure collega un altro account.',
    aumico_integration_sharepoint_expired: 'La connessione a Microsoft 365 è scaduta. Accedi di nuovo.',
    aumico_integration_sharepoint_provider_sharepoint_label: 'SharePoint',
    aumico_integration_sharepoint_provider_sharepoint_desc: 'Cartelle da SharePoint / OneDrive',
    aumico_integration_sharepoint_provider_google_drive_label: 'Google Drive',
    aumico_integration_sharepoint_provider_google_drive_desc: 'Cartelle da Google Drive',
    aumico_integration_sharepoint_provider_manual_upload_label: 'Caricamento manuale',
    aumico_integration_sharepoint_provider_manual_upload_desc: 'Carica file direttamente',
    // REV-21057 — in-app pre-consent card (aumico-rendered, shown before the Microsoft popup)
    // TODO i18n review
    aumico_integration_sharepoint_consent_heading: 'aumico desidera accedere a Microsoft 365',
    aumico_integration_sharepoint_consent_permissions_label: 'Autorizzazione richiesta',
    aumico_integration_sharepoint_consent_permission_files_read: 'Leggere i file',
    aumico_integration_sharepoint_consent_permission_files_read_desc:
        'aumico si limita a leggere. Nulla viene mai riscritto, modificato o eliminato in Microsoft 365.',
    aumico_integration_sharepoint_consent_permission_sites_read: 'Leggere siti e cartelle di SharePoint',
    aumico_integration_sharepoint_consent_footnote:
        'Nel passaggio successivo accedi a Microsoft. Sono visibili solo le cartelle a cui il tuo account è già autorizzato.',
    aumico_integration_sharepoint_consent_allow: 'Consenti l’accesso',
    aumico_integration_sharepoint_consent_cancel: 'Annulla',
    // REV-21860 — SharePoint as an integration card in Org Settings -> Integrations.
    aumico_integration_sharepoint_displayname: 'SharePoint',
    aumico_integration_sharepoint_card_description: 'Utilizza i documenti di SharePoint e OneDrive nelle chiusure.',
    aumico_integration_sharepoint_displayname_help: 'Opzionale. Se lasciato vuoto, aumico assegna alla connessione il nome del tenant Microsoft.',
    aumico_integration_sharepoint_connect_modal_title: 'Collega SharePoint',
    aumico_integration_sharepoint_connect_intro: 'Accedi con un account aziendale Microsoft per consentire ad aumico l’accesso in lettura a SharePoint e OneDrive.',
    aumico_integration_sharepoint_connect_button: 'Connetti con Microsoft 365',
    aumico_integration_sharepoint_awaiting_consent: 'In attesa della conferma nella finestra Microsoft …',
    aumico_integration_sharepoint_manage_modal_title: 'Connessioni SharePoint',
    aumico_integration_sharepoint_manage_empty: 'Nessuna connessione SharePoint.',
    aumico_integration_sharepoint_manage_add_button: 'Aggiungi un’altra connessione',
    aumico_integration_sharepoint_manage_disconnect_button: 'Disconnetti',
    aumico_integration_sharepoint_manage_connected_at: 'Connesso dal',
    aumico_integration_sharepoint_manage_disconnect_confirm_title: 'Disconnettere davvero SharePoint?',
    aumico_integration_sharepoint_manage_disconnect_confirm_text: 'La connessione verrà eliminata. Le chiusure le cui cartelle fanno riferimento a questa connessione non potranno più sincronizzare i documenti.',
    // ── Chiavi condivise dei modali di integrazione, usate dai modali Accounto (REV-21119) —
    //    redatto dal team di sviluppo, da far rileggere a un traduttore ──
    aumico_button_retry: 'Riprova',
    aumico_integration_setup_displayname_label: 'Nome visualizzato',
    aumico_integration_setup_displayname_placeholder: 'ad es. Fiduciaria X',
    aumico_integration_search_company_placeholder: 'Cerca azienda ...',
    aumico_integration_status_error_title: 'Connessione non riuscita',
    aumico_integration_status_testing: 'Test della connessione ...',
    aumico_integration_status_connected: 'Connesso',
    aumico_integration_connect_button: 'Stabilisci connessione',
    aumico_integration_connect_already_exists_title: 'Server già connesso',
    aumico_integration_connect_already_exists_description: 'Questo server è già connesso nella tua organizzazione. Lo trovi nella panoramica.',
    aumico_integration_aumico_company_label: 'Azienda aumico',
    // ── Accounto (REV-21119) — redatto dal team di sviluppo, da far rileggere a un traduttore ──
    aumico_integration_accounto_displayname: 'Accounto',
    aumico_integration_accounto_description: 'Importa i dati contabili direttamente da Accounto.',
    aumico_accounto_connect_modal_title: 'Collega Accounto',
    aumico_accounto_step_welcome_intro:
        'Crea una chiave API in Accounto e incollala qui. Una chiave fiduciaria collega tutti i tuoi mandanti, una chiave PMI la tua azienda. aumico legge soltanto i dati contabili e non scrive mai nel tuo Accounto.',
    aumico_accounto_step_config_displayname_help:
        'Obbligatorio. Ti aiuta a distinguere più accessi Accounto nella panoramica.',
    aumico_accounto_step_config_apikey_label: 'Chiave API',
    aumico_accounto_step_config_apikey_help:
        'Viene salvata cifrata e non viene più mostrata. La chiave ha una data di scadenza; aumico ti avvisa 30 giorni prima.',
    aumico_accounto_step_config_apikey_show: 'Mostra',
    aumico_accounto_step_config_apikey_hide: 'Nascondi',
    aumico_accounto_validation_apikey_invalid:
        'Questa non è una chiave API di Accounto. Copia l’intera chiave da Accounto: tre parti separate da punti.',
    aumico_accounto_validation_missing_fields: 'Ancora da compilare:',
    aumico_accounto_manage_modal_title: 'Accessi Accounto collegati',
    aumico_accounto_manage_empty: 'Nessun accesso Accounto ancora collegato.',
    aumico_accounto_manage_add_server: 'Collega una nuova chiave API',
    aumico_accounto_manage_back_to_list: 'Torna agli accessi',
    aumico_accounto_manage_status_reauth: 'Accesso non riuscito',
    aumico_accounto_manage_key_advisor: 'Chiave fiduciaria · mandante {{tenantId}}',
    aumico_accounto_manage_key_client: 'Chiave PMI · mandante {{tenantId}}',
    aumico_accounto_key_valid_until: 'Chiave API valida fino al {{date}}',
    aumico_accounto_key_expiring: 'La chiave API scade il {{date}}. Crea una nuova chiave in Accounto.',
    aumico_accounto_key_expired: 'La chiave API è scaduta il {{date}}. Crea una nuova chiave in Accounto.',
    aumico_accounto_card_key_expiring: 'Chiave in scadenza',
    aumico_accounto_card_key_expired: 'Chiave scaduta',
    aumico_accounto_manage_loading_companies: 'Caricamento dei mandanti ...',
    aumico_accounto_manage_companies_count: '{{count}} mandanti',
    aumico_accounto_manage_no_mapping: '(non collegato)',
    aumico_accounto_manage_company_column_accounto: 'Mandante Accounto',
    aumico_accounto_manage_search_empty: 'Nessun mandante trovato.',
    aumico_accounto_manage_btn_unlink: 'Scollega',
    aumico_accounto_manage_btn_disconnect: 'Disconnetti l’accesso',
    aumico_accounto_manage_disconnect_confirm_title: 'Disconnettere davvero questo accesso?',
    aumico_accounto_manage_disconnect_confirm_text:
        'Tutti i collegamenti e i dati memorizzati per questo accesso verranno rimossi.',
    aumico_accounto_automatch_running: 'Rilevamento automatico dei collegamenti ...',
    aumico_accounto_automatch_success: '{{autoMatched}} rilevati automaticamente · {{notMapped}} non collegati',
    aumico_accounto_automatch_partial_errors: '({{errors}} errori)',
    aumico_accounto_automatch_failed: 'Rilevamento automatico non riuscito. Collega le aziende manualmente.',
    accounto_importing_title: 'Importazione dei dati',
    accounto_importing_subtitle: 'Recupero dei tuoi dati contabili da Accounto',
    accounto_importing_hint: 'Ci vuole solo un momento',
    accounto_summary_title: 'Riepilogo dell’importazione',
    accounto_summary_overview: 'Panoramica',
    accounto_summary_company: 'Azienda',
    accounto_summary_period: 'Periodo',
    accounto_summary_previous_period: 'Periodo precedente',
    accounto_summary_accounts: 'Conti',
    accounto_summary_continue: 'Continua con l’assegnazione',
    accounto_summary_discard: 'Scarta',
    accounto_summary_validation_title: 'Verifica',
    accounto_summary_balance_check: 'Controllo del saldo',
    accounto_summary_current_year: 'Anno corrente',
    accounto_summary_previous_year: 'Anno precedente',
    accounto_summary_assets: 'Attivi',
    accounto_summary_liabilities: 'Passivi',
    accounto_import_failed_title: 'Importazione non riuscita',
    accounto_import_failed_description: 'L’importazione da Accounto non è riuscita. Riprova più tardi.',
    accounto_import_key_expired_description: 'La chiave API di Accounto è scaduta. Crea una nuova chiave in Accounto.',
    accounto_import_invalid_key_description:
        'La chiave API di Accounto non è valida o è scaduta. Crea una nuova chiave in Accounto e sostituiscila in Impostazioni dell’organizzazione → Integrazioni.',
    accounto_import_connection_error_description:
        'La connessione ad Accounto è interrotta. Verificala in Impostazioni dell’organizzazione → Integrazioni o sostituisci lì la chiave API.',
    accounto_import_tenant_not_allowed_description:
        'Una chiave PMI importa solo la propria azienda. Scegli il mandante di questa chiave o collega una chiave fiduciaria.',
    accounto_import_vendor_mismatch_description:
        'La connessione scelta non è una connessione Accounto. Scegli la connessione Accounto di questa azienda.',
    accounto_import_tenant_not_mapped_description:
        'Questo mandante Accounto non è assegnato a questa azienda. Verifica l’assegnazione in Integrazioni.',
    accounto_import_mapping_not_active_description:
        'L’assegnazione a questo mandante Accounto non è attiva. Attivala in Integrazioni e riprova.',
    accounto_import_unbalanced_booking_description:
        'Una registrazione in Accounto non è bilanciata: dare e avere non coincidono. Correggila in Accounto e importa di nuovo.',
    accounto_import_unknown_accounting_type_description:
        'Un conto movimentato in Accounto ha un tipo di conto sconosciuto. Verifica il tipo di conto in Accounto e importa di nuovo.',

    // ── Proffix (REV-22536) — redatto dal team di sviluppo, da far rileggere a un traduttore ──
    aumico_integration_proffix_displayname: 'PROFFIX',
    aumico_integration_proffix_description: 'Importa i dati contabili direttamente da PROFFIX.',
    aumico_proffix_connect_modal_title: 'Collega PROFFIX',
    aumico_proffix_step_welcome_intro:
        'Inserisci l’indirizzo della tua PxRestAPI di PROFFIX, la password della REST API e il nome utente e la password PROFFIX. La PxRestAPI deve essere raggiungibile via HTTPS (ad es. tramite un reverse proxy). aumico legge soltanto i dati contabili e non scrive mai nel tuo PROFFIX.',
    aumico_proffix_step_config_displayname_help: 'Obbligatorio. Ti aiuta a distinguere più server PROFFIX nella panoramica.',
    aumico_proffix_step_config_serverurl_label: 'URL del server',
    aumico_proffix_step_config_serverurl_help:
        'L’indirizzo della tua PxRestAPI con la porta, ad es. https://proffix.example.ch:11011 o https://proffix.example.ch:11011/pxapi/V4',
    aumico_proffix_step_config_restapikey_label: 'Password della REST API',
    aumico_proffix_step_config_restapikey_help:
        'La password della PxRestAPI (non la tua password utente). Viene salvata cifrata e non viene più mostrata.',
    aumico_proffix_step_config_username_label: 'Nome utente',
    aumico_proffix_step_config_password_label: 'Password',
    aumico_proffix_step_config_password_help:
        'La password del tuo utente PROFFIX. Viene salvata cifrata e non viene più mostrata.',
    aumico_proffix_step_config_password_show: 'Mostra',
    aumico_proffix_step_config_password_hide: 'Nascondi',
    aumico_proffix_validation_serverurl_invalid:
        'Inserisci solo l’indirizzo del server con la porta, eventualmente con /pxapi/V4, ma senza altri percorsi come /PRO/Info. Inizia con https://.',
    aumico_proffix_validation_missing_fields: 'Ancora da compilare:',
    aumico_proffix_manage_modal_title: 'Server PROFFIX collegati',
    aumico_proffix_manage_empty: 'Nessun server PROFFIX ancora collegato.',
    aumico_proffix_manage_add_server: 'Collega un nuovo server',
    aumico_proffix_manage_back_to_list: 'Torna ai server',
    aumico_proffix_manage_status_reauth: 'Accesso non riuscito',
    aumico_proffix_manage_loading_companies: 'Caricamento dei database ...',
    aumico_proffix_manage_companies_count: '{{count}} database',
    aumico_proffix_manage_no_mapping: '(non collegato)',
    aumico_proffix_manage_company_column_proffix: 'Database PROFFIX',
    aumico_proffix_manage_search_empty: 'Nessun database trovato.',
    aumico_proffix_manage_btn_unlink: 'Scollega',
    aumico_proffix_manage_btn_disconnect: 'Disconnetti server',
    aumico_proffix_manage_disconnect_confirm_title: 'Disconnettere davvero questo server?',
    aumico_proffix_manage_disconnect_confirm_text:
        'Tutti i collegamenti e i dati memorizzati per questo server verranno rimossi.',
    aumico_proffix_automatch_running: 'Rilevamento automatico dei collegamenti ...',
    aumico_proffix_automatch_success: '{{autoMatched}} rilevati automaticamente · {{notMapped}} non collegati',
    aumico_proffix_automatch_partial_errors: '({{errors}} errori)',
    aumico_proffix_automatch_failed: 'Rilevamento automatico non riuscito. Collega le aziende manualmente.',
    proffix_importing_title: 'Importazione dei dati',
    proffix_importing_subtitle: 'Recupero dei tuoi dati contabili da PROFFIX',
    proffix_importing_hint: 'Ci vuole solo un momento',
    proffix_summary_title: 'Riepilogo dell’importazione',
    proffix_summary_overview: 'Panoramica',
    proffix_summary_company: 'Azienda',
    proffix_summary_period: 'Periodo',
    proffix_summary_previous_period: 'Periodo precedente',
    proffix_summary_accounts: 'Conti',
    proffix_summary_continue: 'Continua con l’assegnazione',
    proffix_summary_discard: 'Scarta',
    proffix_summary_validation_title: 'Verifica',
    proffix_summary_balance_check: 'Controllo del saldo',
    proffix_summary_current_year: 'Anno corrente',
    proffix_summary_previous_year: 'Anno precedente',
    proffix_summary_assets: 'Attivi',
    proffix_summary_liabilities: 'Passivi',
    proffix_import_failed_title: 'Importazione non riuscita',
    proffix_import_failed_description: 'L’importazione da PROFFIX non è riuscita. Riprova più tardi.',

    /**
     * REV-21960 / REV-21357 / REV-21378 — le chiavi ABCP, ANNIDATE.
     *
     * Annidate e non piatte (`aumico_abcp_…`) perché il backend memorizza chiavi PUNTATE: una voce
     * del protocollo porta `titleKey: 'abcp.trail.previewStatus'`. i18next gira con
     * `keySeparator: '.'` di default — solo un oggetto annidato risolve queste chiavi.
     *
     * ⚠️ **AGGIUNTO IL 16.09.2026 (revisione 4, rilievo R4-1) — DA FAR RILEGGERE A UN TRADUTTORE.**
     * Finora questo file non conteneva alcuna chiave `abcp.*` e, poiché `fallbackLng` è `de-CH`,
     * ognuna di queste righe mostrava prosa TEDESCA in un’interfaccia italiana. I testi qui sotto
     * eliminano quel difetto; sono redatti dal team di sviluppo e non sono ancora stati riletti da
     * un traduttore professionista.
     *
     * ⚠️ **`accountSurface.position` è ASSENTE, deliberatamente.** Quelle 30 chiavi sono le voci del
     * bilancio e del conto economico secondo l’**art. 959a CO**. L’italiano è una lingua ufficiale
     * del Codice delle obbligazioni: la dicitura corretta ESISTE nel testo italiano della legge e non
     * si traduce — riprenderla da altrove sarebbe un errore professionale, non un’approssimazione
     * linguistica. Finché non viene ripresa dal testo ufficiale, queste chiavi ricadono su `de-CH`
     * come prima: nessuna regressione, una lacuna dichiarata. La guardia
     * `activity-keys.unit.spec.ts` non copre queste chiavi — copre `abcp.activity.*` e
     * `abcp.trail.*`, tutte presenti qui sotto.
     */
    abcp: {
        // Righe di struttura del bilancio e del conto economico: titoli di gruppo, totali, subtotali.
        statementLayout: {
            section: '{{heading}} in {{currency}}',
            incomeStatement: 'Conto economico',
            incomeStatementSection: 'Conto economico in {{currency}}',
            assets: 'Attivi',
            assetsTotal: 'Totale attivi',
            currentAssetsTotal: 'Totale attivo circolante',
            nonCurrentAssetsTotal: 'Totale attivo fisso',
            liabilitiesAndEquity: 'Passivi',
            liabilitiesAndEquityTotal: 'Totale passivi',
            liabilitiesTotal: 'Totale capitale di terzi',
            currentLiabilitiesTotal: 'Totale capitale di terzi a breve termine',
            nonCurrentLiabilitiesTotal: 'Totale capitale di terzi a lungo termine',
            equityTotal: 'Totale capitale proprio',
            operatingRevenueTotal: 'Totale ricavi d’esercizio',
            materialExpenseTotal: 'Totale costi del materiale e delle merci',
            grossProfit: 'Utile lordo',
            personnelExpenseTotal: 'Totale costi del personale',
            otherOperatingExpenseTotal: 'Totale altri costi d’esercizio',
            ebitda: 'Risultato d’esercizio prima di ammortamenti, risultato finanziario e imposte (EBITDA)',
            ebit: 'Risultato d’esercizio prima del risultato finanziario e delle imposte (EBIT)',
            financialResultTotal: 'Totale risultato finanziario',
            ancillaryResultTotal: 'Totale risultato accessorio d’esercizio',
            operatingResult: 'Risultato operativo',
            nonOperatingResultTotal: 'Totale risultato estraneo all’esercizio e straordinario',
            resultBeforeTaxes: 'Risultato d’esercizio prima delle imposte',
            result: 'Risultato d’esercizio',
        },
        accountSurface: {
            // ⚠️ `position: { … }` — vedi l’avvertenza sopra: art. 959a CO, serve il testo ufficiale.
            // Le voci del conto economico (piano contabile PMI). Le voci di bilancio mancano ancora, vedi sopra.
            position: {
                INCOME_STATEMENT_PRODUCTION_REVENUE: 'Ricavi della produzione',
                INCOME_STATEMENT_TRADE_REVENUE: 'Ricavi dalla vendita di merci',
                INCOME_STATEMENT_SERVICE_REVENUE: 'Ricavi da prestazioni di servizi',
                INCOME_STATEMENT_OTHER_REVENUE: 'Altri ricavi da forniture e prestazioni',
                INCOME_STATEMENT_OWN_WORK_CAPITALISED: 'Prestazioni proprie e consumo proprio',
                INCOME_STATEMENT_REVENUE_DEDUCTIONS: 'Diminuzioni di ricavi',
                INCOME_STATEMENT_INVENTORY_CHANGES: 'Variazioni delle scorte di prodotti semilavorati e finiti e delle prestazioni di servizi non fatturate',
                INCOME_STATEMENT_MATERIAL_EXPENSE: 'Costi del materiale',
                INCOME_STATEMENT_GOODS_EXPENSE: 'Costi delle merci',
                INCOME_STATEMENT_THIRD_PARTY_SERVICES: 'Costi per prestazioni di terzi',
                INCOME_STATEMENT_PRODUCTION_ENERGY: 'Costi dell’energia per la produzione',
                INCOME_STATEMENT_PURCHASE_DEDUCTIONS: 'Diminuzioni di costi',
                INCOME_STATEMENT_WAGES: 'Costi salariali',
                INCOME_STATEMENT_SOCIAL_SECURITY: 'Oneri sociali',
                INCOME_STATEMENT_OTHER_PERSONNEL: 'Altri costi del personale',
                INCOME_STATEMENT_TEMPORARY_STAFF: 'Prestazioni di lavoro di terzi',
                INCOME_STATEMENT_PREMISES: 'Costi dei locali',
                INCOME_STATEMENT_MAINTENANCE: 'Manutenzione, riparazioni, sostituzioni e leasing di immobilizzazioni materiali mobili',
                INCOME_STATEMENT_VEHICLES: 'Costi dei veicoli e di trasporto',
                INCOME_STATEMENT_INSURANCE_FEES: 'Assicurazioni cose, tributi, tasse e autorizzazioni',
                INCOME_STATEMENT_ENERGY_DISPOSAL: 'Costi dell’energia e di smaltimento',
                INCOME_STATEMENT_ADMINISTRATION: 'Costi amministrativi',
                INCOME_STATEMENT_IT: 'Costi informatici',
                INCOME_STATEMENT_ADVERTISING: 'Costi pubblicitari',
                INCOME_STATEMENT_OTHER_OPERATING: 'Costi d’esercizio diversi',
                INCOME_STATEMENT_DEPRECIATION: 'Ammortamenti e rettifiche di valore sulle voci dell’attivo fisso',
                INCOME_STATEMENT_FINANCIAL_EXPENSE: 'Costi finanziari',
                INCOME_STATEMENT_FINANCIAL_INCOME: 'Ricavi finanziari',
                INCOME_STATEMENT_ANCILLARY_OPERATIONS: 'Risultato delle attività accessorie',
                INCOME_STATEMENT_OPERATING_PROPERTY: 'Risultato degli immobili d’esercizio',
                INCOME_STATEMENT_NON_OPERATING: 'Costi e ricavi estranei all’esercizio',
                INCOME_STATEMENT_EXTRAORDINARY: 'Costi e ricavi straordinari, unici o relativi ad altri esercizi',
                INCOME_STATEMENT_DIRECT_TAXES: 'Imposte dirette',
                // Vecchie chiavi di classe, ancora inviate da un backend senza le voci dettagliate.
                INCOME_STATEMENT_OPERATING_REVENUE: 'Ricavi d’esercizio',
                INCOME_STATEMENT_COST_OF_MATERIALS: 'Costi del materiale e delle merci',
                INCOME_STATEMENT_PERSONNEL_EXPENSE: 'Costi del personale',
                INCOME_STATEMENT_OTHER_OPERATING_EXPENSE: 'Altri costi d’esercizio',
                INCOME_STATEMENT_ANCILLARY_RESULT: 'Risultato delle attività accessorie d’esercizio',
                INCOME_STATEMENT_NON_OPERATING_AND_TAX: 'Risultato estraneo all’esercizio e straordinario, imposte',
                INCOME_STATEMENT_CLOSING: 'Conti di chiusura',
            },
            navBalanceSheet: 'Riconciliare i conti di bilancio',
            navIncomeStatement: 'Verificare la plausibilità del conto economico',
            syncCompaniesNotLoaded: 'I dati dell’azienda non sono ancora stati caricati. Attendere un momento e riprovare.',
            syncNoConnection: 'Per questo mandato non è registrata alcuna connessione ERP attiva.',
            syncNoContext: 'Nessun mandato o nessun progetto nel contesto — il recupero dall’ERP non può essere avviato.',
            PROJECT_PERIOD_MISSING: 'Il progetto non ha né un periodo né una data di chiusura da cui ricavarlo.',
            PROJECT_NOT_FOUND: 'Questo progetto non è reperibile.',
            CONNECTION_REQUIRED: 'Per questo fornitore mancano la connessione e l’azienda fornitore.',
            VENDOR_PERIOD_NOT_FOUND: 'Il fornitore non conosce alcun esercizio per questo periodo.',
            erpRightsMissing: "L'ERP nega l'accesso ai dati su valute o IVA. Verificare i diritti di lettura dell'app aumico nell'ERP — la connessione ERP stessa resta attiva.",
            abcp_error_mandate_data_unavailable: 'Il recupero non è riuscito. Riprovare più tardi.',
            abcp_error_account_binding_invalid: 'L’attribuzione è stata respinta.',
            abcp_error_mandate_not_found: 'Questa chiusura non è reperibile.',
            columnPercent: '%',
            columnDeltaAbsolute: 'Δ assoluto',
            chip: {
                zeroAccounts: 'Conti a zero',
                all: 'Tutti',
                open: 'Aperti',
                marked: 'Contrassegnati',
                reconciled: 'Riconciliati',
                difference: 'Differenza',
            },
            columnCurrentPlain: 'Saldo',
            columnPriorPlain: 'Esercizio precedente',
            syncRunningTitle: 'Recupero dei dati in corso',
            syncRunningSubtitle: 'Le registrazioni e i conti vengono caricati dall’ERP.',
            syncRunningHint: 'Con più periodi l’operazione può richiedere del tempo. Lasciare aperta la finestra.',
            syncDoneTitle: 'Sincronizzazione completata',
            syncDoneAll: 'Fatto — tutti i periodi richiesti sono stati recuperati.',
            syncDonePartly: 'Fatto, ma non è stato possibile recuperare un periodo di confronto.',
            syncDoneClose: 'Chiudi',
            syncDonePeriod: 'Periodo',
            syncDoneAccounts: 'Conti nell’ERP',
            syncDoneJournalOnly: 'Solo nel giornale',
            syncDoneStatesCreated: 'Creati ex novo',
            syncDoneVatUnreadable: "Per {{count}} documento/i manca il codice IVA: l'ERP non li ha forniti (eliminati o non leggibili per l'app aumico). Tutti gli altri dati sono caricati.",
            syncDoneComparisons: 'Periodi di confronto',
            syncTitle: 'Sincronizzazione ERP',
            syncIntro: 'Recupera dall’ERP le registrazioni di questa chiusura.',
            syncOwnHeading: 'Periodo corrente',
            syncOwnPeriod: 'Questo esercizio: {{range}}',
            syncHeldHeading: 'Già disponibili',
            syncHeldHint:
                'Questi periodi sono già archiviati e non vengono recuperati di nuovo — possono appartenere a un progetto già chiuso.',
            syncFetchHeading: 'Carica gli anni precedenti',
            syncTagWillFetch: 'verrà aggiornato',
            syncTagHeld: 'disponibile',
            syncMaxPeriodsReached:
                'Cinque periodi sono archiviati — il conto economico non ne mostra di più. Non c’è nulla da ricaricare.',
            syncNothingHeldYet:
                'Alla prima sincronizzazione viene recuperato solo il periodo corrente. I periodi di confronto possono essere aggiunti in seguito.',
            syncNoRowsChosen: 'Nessun periodo di confronto selezionato.',
            syncFrom: 'Dal',
            syncTo: 'Al',
            syncAddPeriod: 'Aggiungi periodo',
            syncMaxRowsReached: 'Sono possibili al massimo cinque esercizi, compreso questo.',
            syncRemovePeriod: 'Rimuovi',
            syncIncompleteRow: 'Indicare per ogni periodo la data di inizio e di fine.',
            syncStart: 'Avvia sincronizzazione',
            syncCancel: 'Annulla',
            syncOutcome: {
                FILLED: 'recuperato',
                ALREADY_PRESENT: 'era già disponibile',
                FAILED: 'non riuscito',
            },
            comparisonYears: 'Altri esercizi:',
            comparisonPeriodMissing:
                'Per {{periods}} non è ancora disponibile alcun giornale. Avviare la sincronizzazione ERP per caricare il periodo.',
            unpositionedNotice:
                'Questi conti non hanno ancora una posizione e non vengono mostrati: {{accounts}}. Assegnarli nel piano dei conti per mostrarli.',
            zeroAccountsLocked: 'Assegnare prima i {{n}} conti a saldo zero nel piano dei conti.',
            toggle: {
                percentOfRevenue: '% del ricavo d’esercizio',
                priorYearComparison: 'Confronto con l’esercizio precedente',
            },
            unassignedGroup: 'Senza voce',
            unassignedBanner: '{{count}} conti non sono attribuiti ad alcuna voce',
            classificationRunning: 'L’IA sta attribuendo i conti di questa chiusura — {{open}} di {{total}} ancora aperti',
            classificationOverdue:
                'L’attribuzione è in sospeso da più di dieci minuti. Riavviare la sincronizzazione ERP.',
            classificationDone: 'Attribuzione completata — tutti i conti sono attribuiti a una voce',
            unassignedBannerAction: 'Attribuisci ora',
            assignTitle: 'Attribuisci il conto',
            assignPositionLabel: 'Voce',
            assignPositionPlaceholder: 'Scegliere una voce',
            assignSkip: 'Salta',
            assignSave: 'Salva',
            assignProgress: 'Conto {{index}} di {{total}}',
            assignDone: 'Tutti i conti sono attribuiti.',
            columnCurrent: 'Saldo {{year}}',
            columnPrior: 'Saldo {{year}}',
            columnDelta: 'Δ%',
        },
        /** REV-21378 — la metà UMANA del registro delle attività (`abcp_closing_activity`). */
        activity: {
            // REV-22005 — review flag and hand-entered document balance (N-2.2, N-3.5).
            reviewFlagged: 'Contrassegnato per revisione',
            reviewUnflagged: 'Contrassegno di revisione rimosso',
            documentBalanceEntered: 'Valore del giustificativo inserito manualmente',
            documentBalanceCleared: 'Valore del giustificativo rimosso',
            documentBalanceConflict: 'Valore del giustificativo inserito manualmente mantenuto – l\'elaborazione IA non l\'ha sovrascritto',
            evidenceAssigned: '{{count}} giustificativo/i attribuito/i',
            evidenceAssignedDetail: 'Attribuzione effettuata da una persona',
            evidenceUnassigned: 'Attribuzione annullata',
            classificationChanged: 'Attribuzione del conto modificata',
            classificationChangedDetail: 'Nuovo gruppo: {{group}}',
            statusChanged: 'Stato modificato',
            statusChangedDetail: 'Nuovo stato: {{to}}',
            erpSynced: 'La sincronizzazione ERP ha interessato questo conto',
            adjustmentBooked: 'Registrazione di rettifica inserita',
            adjustmentDiscarded: 'Registrazione di rettifica scartata',
            adjustmentTransferred: 'Registrazione di rettifica trasmessa all’ERP',
            adjustmentEdited: 'Registrazione di rettifica modificata',
            orComplianceChecked: 'Conformità al CO verificata',
        },
        trail: {
            // The lines a per-account run writes (kept here because stored log entries point at them).
            runStarted: 'Riconciliazione avviata: {{trigger}}',
            documentRead: '{{kind}} letto: {{amount}} al {{date}}',
            documentUnreadable: '{{kind}}: il valore non ha potuto essere letto',
            compared: 'Confrontato con la contabilità: {{outcome}}',
            runFailed: 'Riconciliazione non riuscita, nulla è stato modificato',
            // REV-22005 — a run found hand-entered document balances and kept them (N-3.5).
            manualDocumentBalanceKept: '{{count}} valore/i del giustificativo inserito/i manualmente mantenuto/i',
            runPlanned: '{{units}} unità di lavoro pianificate su {{positions}} voce/voci',
            unitBlocked: 'Passo bloccato: {{code}}',
            fixtureMode: 'ATTENZIONE modalità fixture ({{mode}}): l’elaborazione calcola su dati di test fittizi, non su dati di mandato',
            positionStarted: 'Voce {{positionId}} avviata (pacchetto di regole {{rulePackId}} {{version}})',
            journalAnalysed: 'Estratto conto analizzato: {{accounts}} conti letti',
            evidenceAssigned: '{{documents}} giustificativi attribuiti ({{perAccount}} per conto)',
            engineDispatched: 'Motore {{entry}} richiamato',
            differenceDetected: 'Differenza rilevata su {{accountName}}',
            findingIdentified: 'Causa individuata su {{accountName}}',
            proposalsGenerated: '{{proposals}} proposta/e di registrazione create per {{accountName}}',
            previewStatus: 'Anteprima per {{accountName}}',
            reconciled: 'Giustificativo riconciliato con il saldo: {{accountName}}',
            baseCurrencyDefaulted: 'Valuta di base assunta come predefinita ({{currency}})',
            accountStateWriteFailed: 'Non è stato possibile riscrivere lo stato del conto',
            runAborted: 'Elaborazione interrotta: {{reason}}',
            trusteeAsked: 'Domanda rivolta alla fiduciaria',
            orComplianceChecked: 'Conformità al CO verificata',
            statusChanged: 'Stato modificato: {{status}}',
            positionNotImplemented: 'Per la voce {{positionId}} non esiste ancora alcun pacchetto di regole',
            entryRefused: 'Non è stato possibile salvare una voce del protocollo in questo punto',
            detail: {
                unbookedBankCharges: 'Spese bancarie non contabilizzate',
            },
        },
        block: {
            unresolvedAccountGroup: 'Per la voce {{positionId}} non è possibile risolvere alcun conto — la superficie dei conti ABCP non esiste ancora',
            fixtureRunBlocked: 'L’elaborazione fixture è stata bloccata ({{code}})',
            noFixturePosition: 'Per la voce {{positionId}} non esiste alcun set fixture',
        },
        catalog: {
            engineReconciliation: 'Riconciliazione',
            engineValuation: 'Valutazione',
            toolBalanceAggregation: 'Aggregazione dei saldi',
            toolOpenItemMatching: 'Abbinamento delle partite aperte',
            toolMateriality: 'Rilevanza',
            toolFxBazg: 'Corsi delle divise (UDSC)',
            toolAgingBuckets: 'Classi di scadenza',
            toolDerivationBuilder: 'Derivazione',
            toolBookingProposalBuilder: 'Proposta di registrazione',
            genaiAccountGroupClassifier: 'Classificazione dei gruppi di conti',
            genaiRootCauseAnalysis: 'Analisi delle cause',
            gateFinal: 'Verifica finale',
        },
    },
};
